import * as t$1 from "react";
import t__default, { createContext, useMemo, createElement, useContext, useRef, useEffect, useLayoutEffect, forwardRef, Children, isValidElement, cloneElement, Fragment as Fragment$1, useState, useCallback } from "react";
import "react-dom";
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ createContext(defaultContext);
    const index = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const value = useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ createElement(Context.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      const context = useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext$1
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}
const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect : () => {
};
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function")
    ref(value);
  else if (ref !== null && ref !== void 0)
    ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node)
  );
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (Children.count(newElement) > 1)
          return Children.only(null);
        return /* @__PURE__ */ isValidElement(newElement) ? newElement.props.children : null;
      } else
        return child;
    });
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ isValidElement(newElement) ? /* @__PURE__ */ cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (/* @__PURE__ */ isValidElement(children))
    return /* @__PURE__ */ cloneElement(children, {
      ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
      ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
    });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children }) => {
  return /* @__PURE__ */ createElement(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue)
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      else if (slotPropValue)
        overrideProps[propName] = slotPropValue;
    } else if (propName === "style")
      overrideProps[propName] = {
        ...slotPropValue,
        ...childPropValue
      };
    else if (propName === "className")
      overrideProps[propName] = [
        slotPropValue,
        childPropValue
      ].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ createElement(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node
  };
}, {});
const $cddcb0b647441e34$var$AVATAR_NAME = "Avatar";
const [$cddcb0b647441e34$var$createAvatarContext, $cddcb0b647441e34$export$90370d16b488820f] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cddcb0b647441e34$var$AVATAR_NAME);
const [$cddcb0b647441e34$var$AvatarProvider, $cddcb0b647441e34$var$useAvatarContext] = $cddcb0b647441e34$var$createAvatarContext($cddcb0b647441e34$var$AVATAR_NAME);
const $cddcb0b647441e34$export$e2255cf6045e8d47 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, ...avatarProps } = props;
  const [imageLoadingStatus, setImageLoadingStatus] = useState("idle");
  return /* @__PURE__ */ createElement($cddcb0b647441e34$var$AvatarProvider, {
    scope: __scopeAvatar,
    imageLoadingStatus,
    onImageLoadingStatusChange: setImageLoadingStatus
  }, /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, avatarProps, {
    ref: forwardedRef
  })));
});
const $cddcb0b647441e34$var$IMAGE_NAME = "AvatarImage";
const $cddcb0b647441e34$export$2cd8ae1985206fe8 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, src, onLoadingStatusChange = () => {
  }, ...imageProps } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
  const imageLoadingStatus = $cddcb0b647441e34$var$useImageLoadingStatus(src);
  const handleLoadingStatusChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a((status) => {
    onLoadingStatusChange(status);
    context.onImageLoadingStatusChange(status);
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (imageLoadingStatus !== "idle")
      handleLoadingStatusChange(imageLoadingStatus);
  }, [
    imageLoadingStatus,
    handleLoadingStatusChange
  ]);
  return imageLoadingStatus === "loaded" ? /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.img, _extends({}, imageProps, {
    ref: forwardedRef,
    src
  })) : null;
});
const $cddcb0b647441e34$var$FALLBACK_NAME = "AvatarFallback";
const $cddcb0b647441e34$export$69fffb6a9571fbfe = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { __scopeAvatar, delayMs, ...fallbackProps } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
  const [canRender, setCanRender] = useState(delayMs === void 0);
  useEffect(() => {
    if (delayMs !== void 0) {
      const timerId = window.setTimeout(
        () => setCanRender(true),
        delayMs
      );
      return () => window.clearTimeout(timerId);
    }
  }, [
    delayMs
  ]);
  return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, fallbackProps, {
    ref: forwardedRef
  })) : null;
});
function $cddcb0b647441e34$var$useImageLoadingStatus(src) {
  const [loadingStatus, setLoadingStatus] = useState("idle");
  useEffect(() => {
    if (!src) {
      setLoadingStatus("error");
      return;
    }
    let isMounted = true;
    const image2 = new window.Image();
    const updateStatus = (status) => () => {
      if (!isMounted)
        return;
      setLoadingStatus(status);
    };
    setLoadingStatus("loading");
    image2.onload = updateStatus("loaded");
    image2.onerror = updateStatus("error");
    image2.src = src;
    return () => {
      isMounted = false;
    };
  }, [
    src
  ]);
  return loadingStatus;
}
const $704cf1d3b684cc5c$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
const $704cf1d3b684cc5c$var$SSRContext = /* @__PURE__ */ t__default.createContext($704cf1d3b684cc5c$var$defaultContext);
let $704cf1d3b684cc5c$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
function $704cf1d3b684cc5c$export$619500959fc48b26(defaultId) {
  let ctx = useContext($704cf1d3b684cc5c$var$SSRContext);
  if (ctx === $704cf1d3b684cc5c$var$defaultContext && !$704cf1d3b684cc5c$var$canUseDOM)
    console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  return useMemo(
    () => defaultId || `react-aria${ctx.prefix}-${++ctx.current}`,
    [
      defaultId
    ]
  );
}
function $704cf1d3b684cc5c$export$535bd6ca7f90a273() {
  let cur = useContext($704cf1d3b684cc5c$var$SSRContext);
  let isInSSRContext = cur !== $704cf1d3b684cc5c$var$defaultContext;
  let [isSSR, setIsSSR] = useState(isInSSRContext);
  if (typeof window !== "undefined" && isInSSRContext)
    useLayoutEffect(() => {
      setIsSSR(false);
    }, []);
  return isSSR;
}
function r$1(e2) {
  var t2, f2, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2)
    n2 += e2;
  else if ("object" == typeof e2)
    if (Array.isArray(e2))
      for (t2 = 0; t2 < e2.length; t2++)
        e2[t2] && (f2 = r$1(e2[t2])) && (n2 && (n2 += " "), n2 += f2);
    else
      for (t2 in e2)
        e2[t2] && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function clsx() {
  for (var e2, t2, f2 = 0, n2 = ""; f2 < arguments.length; )
    (e2 = arguments[f2++]) && (t2 = r$1(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof window !== "undefined" ? t__default.useLayoutEffect : () => {
};
let $bdb11010cef70236$var$idsUpdaterMap = /* @__PURE__ */ new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = useState(defaultId);
  let nextId = useRef(null);
  let res = $704cf1d3b684cc5c$export$619500959fc48b26(value);
  let updateValue = useCallback((val) => {
    nextId.current = val;
  }, []);
  $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let r2 = res;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(r2);
    };
  }, [
    res
  ]);
  useEffect(() => {
    let newId = nextId.current;
    if (newId) {
      nextId.current = null;
      setValue(newId);
    }
  });
  return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB)
    return idA;
  let setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
  if (setIdA) {
    setIdA(idB);
    return idB;
  }
  let setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
  if (setIdB) {
    setIdB(idA);
    return idA;
  }
  return idB;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks)
      if (typeof callback === "function")
        callback(...args);
  };
}
function $3ef42575df84b30b$export$9d1611c77c2fe928(...args) {
  let result = {
    ...args[0]
  };
  for (let i2 = 1; i2 < args.length; i2++) {
    let props = args[i2];
    for (let key in props) {
      let a2 = result[key];
      let b2 = props[key];
      if (typeof a2 === "function" && typeof b2 === "function" && key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= 65 && key.charCodeAt(2) <= 90)
        result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a2, b2);
      else if ((key === "className" || key === "UNSAFE_className") && typeof a2 === "string" && typeof b2 === "string")
        result[key] = clsx(a2, b2);
      else if (key === "id" && a2 && b2)
        result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a2, b2);
      else
        result[key] = b2 !== void 0 ? b2 : a2;
    }
  }
  return result;
}
function $5dc95899b306f630$export$c9058316764c140e(...refs) {
  return (value) => {
    for (let ref of refs) {
      if (typeof ref === "function")
        ref(value);
      else if (ref != null)
        ref.current = value;
    }
  };
}
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]);
const $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
  let { labelable, propNames } = opts;
  let filteredProps = {};
  for (const prop in props)
    if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop)))
      filteredProps[prop] = props[prop];
  return filteredProps;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll())
    element.focus({
      preventScroll: true
    });
  else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      var focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e2) {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth)
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement)
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map();
let $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined")
    return;
  let onTransitionStart = (e2) => {
    let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e2.target);
    if (!transitions) {
      transitions = /* @__PURE__ */ new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e2.target, transitions);
      e2.target.addEventListener("transitioncancel", onTransitionEnd);
    }
    transitions.add(e2.propertyName);
  };
  let onTransitionEnd = (e2) => {
    let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e2.target);
    if (!properties)
      return;
    properties.delete(e2.propertyName);
    if (properties.size === 0) {
      e2.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e2.target);
    }
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks)
        cb();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading")
    $bbed8b41f857bcc0$var$setupGlobalEvents();
  else
    document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  requestAnimationFrame(() => {
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0)
      fn();
    else
      $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let globalListeners = useRef(/* @__PURE__ */ new Map());
  let addGlobalListener = useCallback((eventTarget, type, listener, options) => {
    let fn = (options === null || options === void 0 ? void 0 : options.once) ? (...args) => {
      globalListeners.current.delete(listener);
      listener(...args);
    } : listener;
    globalListeners.current.set(listener, {
      type,
      eventTarget,
      fn,
      options
    });
    eventTarget.addEventListener(type, listener, options);
  }, []);
  let removeGlobalListener = useCallback((eventTarget, type, listener, options) => {
    var ref;
    let fn = ((ref = globalListeners.current.get(listener)) === null || ref === void 0 ? void 0 : ref.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  let removeAllGlobalListeners = useCallback(() => {
    globalListeners.current.forEach((value, key) => {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [
    removeGlobalListener
  ]);
  useEffect(() => {
    return removeAllGlobalListeners;
  }, [
    removeAllGlobalListeners
  ]);
  return {
    addGlobalListener,
    removeGlobalListener,
    removeAllGlobalListeners
  };
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return () => {
        context.ref.current = null;
      };
    }
  }, [
    context,
    ref
  ]);
}
function $c87311424ea30a05$var$testUserAgent(re2) {
  var ref;
  if (typeof window === "undefined" || window.navigator == null)
    return false;
  return ((ref = window.navigator["userAgentData"]) === null || ref === void 0 ? void 0 : ref.brands.some(
    (brand) => re2.test(brand.brand)
  )) || re2.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re2) {
  var ref;
  return typeof window !== "undefined" && window.navigator != null ? re2.test(((ref = window.navigator["userAgentData"]) === null || ref === void 0 ? void 0 : ref.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted)
    return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType)
    return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
var e = "colors", t = "sizes", r = "space", n$2 = { gap: r, gridGap: r, columnGap: r, gridColumnGap: r, rowGap: r, gridRowGap: r, inset: r, insetBlock: r, insetBlockEnd: r, insetBlockStart: r, insetInline: r, insetInlineEnd: r, insetInlineStart: r, margin: r, marginTop: r, marginRight: r, marginBottom: r, marginLeft: r, marginBlock: r, marginBlockEnd: r, marginBlockStart: r, marginInline: r, marginInlineEnd: r, marginInlineStart: r, padding: r, paddingTop: r, paddingRight: r, paddingBottom: r, paddingLeft: r, paddingBlock: r, paddingBlockEnd: r, paddingBlockStart: r, paddingInline: r, paddingInlineEnd: r, paddingInlineStart: r, top: r, right: r, bottom: r, left: r, scrollMargin: r, scrollMarginTop: r, scrollMarginRight: r, scrollMarginBottom: r, scrollMarginLeft: r, scrollMarginX: r, scrollMarginY: r, scrollMarginBlock: r, scrollMarginBlockEnd: r, scrollMarginBlockStart: r, scrollMarginInline: r, scrollMarginInlineEnd: r, scrollMarginInlineStart: r, scrollPadding: r, scrollPaddingTop: r, scrollPaddingRight: r, scrollPaddingBottom: r, scrollPaddingLeft: r, scrollPaddingX: r, scrollPaddingY: r, scrollPaddingBlock: r, scrollPaddingBlockEnd: r, scrollPaddingBlockStart: r, scrollPaddingInline: r, scrollPaddingInlineEnd: r, scrollPaddingInlineStart: r, fontSize: "fontSizes", background: e, backgroundColor: e, backgroundImage: e, borderImage: e, border: e, borderBlock: e, borderBlockEnd: e, borderBlockStart: e, borderBottom: e, borderBottomColor: e, borderColor: e, borderInline: e, borderInlineEnd: e, borderInlineStart: e, borderLeft: e, borderLeftColor: e, borderRight: e, borderRightColor: e, borderTop: e, borderTopColor: e, caretColor: e, color: e, columnRuleColor: e, fill: e, outline: e, outlineColor: e, stroke: e, textDecorationColor: e, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: t, minBlockSize: t, maxBlockSize: t, inlineSize: t, minInlineSize: t, maxInlineSize: t, width: t, minWidth: t, maxWidth: t, height: t, minHeight: t, maxHeight: t, flexBasis: t, gridTemplateColumns: t, gridTemplateRows: t, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, i = (e2, t2) => "function" == typeof t2 ? { "()": Function.prototype.toString.call(t2) } : t2, o$1 = () => {
  const e2 = /* @__PURE__ */ Object.create(null);
  return (t2, r2, ...n2) => {
    const o2 = ((e3) => JSON.stringify(e3, i))(t2);
    return o2 in e2 ? e2[o2] : e2[o2] = r2(t2, ...n2);
  };
}, l$1 = Symbol.for("sxs.internal"), s = (e2, t2) => Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)), a = (e2) => {
  for (const t2 in e2)
    return true;
  return false;
}, { hasOwnProperty: c } = Object.prototype, d = (e2) => e2.includes("-") ? e2 : e2.replace(/[A-Z]/g, (e3) => "-" + e3.toLowerCase()), g$1 = /\s+(?![^()]*\))/, p$1 = (e2) => (t2) => e2(..."string" == typeof t2 ? String(t2).split(g$1) : [t2]), u = { appearance: (e2) => ({ WebkitAppearance: e2, appearance: e2 }), backfaceVisibility: (e2) => ({ WebkitBackfaceVisibility: e2, backfaceVisibility: e2 }), backdropFilter: (e2) => ({ WebkitBackdropFilter: e2, backdropFilter: e2 }), backgroundClip: (e2) => ({ WebkitBackgroundClip: e2, backgroundClip: e2 }), boxDecorationBreak: (e2) => ({ WebkitBoxDecorationBreak: e2, boxDecorationBreak: e2 }), clipPath: (e2) => ({ WebkitClipPath: e2, clipPath: e2 }), content: (e2) => ({ content: e2.includes('"') || e2.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e2) ? e2 : `"${e2}"` }), hyphens: (e2) => ({ WebkitHyphens: e2, hyphens: e2 }), maskImage: (e2) => ({ WebkitMaskImage: e2, maskImage: e2 }), maskSize: (e2) => ({ WebkitMaskSize: e2, maskSize: e2 }), tabSize: (e2) => ({ MozTabSize: e2, tabSize: e2 }), textSizeAdjust: (e2) => ({ WebkitTextSizeAdjust: e2, textSizeAdjust: e2 }), userSelect: (e2) => ({ WebkitUserSelect: e2, userSelect: e2 }), marginBlock: p$1((e2, t2) => ({ marginBlockStart: e2, marginBlockEnd: t2 || e2 })), marginInline: p$1((e2, t2) => ({ marginInlineStart: e2, marginInlineEnd: t2 || e2 })), maxSize: p$1((e2, t2) => ({ maxBlockSize: e2, maxInlineSize: t2 || e2 })), minSize: p$1((e2, t2) => ({ minBlockSize: e2, minInlineSize: t2 || e2 })), paddingBlock: p$1((e2, t2) => ({ paddingBlockStart: e2, paddingBlockEnd: t2 || e2 })), paddingInline: p$1((e2, t2) => ({ paddingInlineStart: e2, paddingInlineEnd: t2 || e2 })) }, h$1 = /([\d.]+)([^]*)/, f$1 = (e2, t2) => e2.length ? e2.reduce((e3, r2) => (e3.push(...t2.map((e4) => e4.includes("&") ? e4.replace(/&/g, /[ +>|~]/.test(r2) && /&.*&/.test(e4) ? `:is(${r2})` : r2) : r2 + " " + e4)), e3), []) : t2, m$1 = (e2, t2) => e2 in b && "string" == typeof t2 ? t2.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t3, r2, n2, i2) => r2 + ("stretch" === n2 ? `-moz-available${i2};${d(e2)}:${r2}-webkit-fill-available` : `-moz-fit-content${i2};${d(e2)}:${r2}fit-content`) + i2) : String(t2), b = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, S = (e2) => e2 ? e2 + "-" : "", k = (e2, t2, r2) => e2.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e3, n2, i2, o2, l2) => "$" == o2 == !!i2 ? e3 : (n2 || "--" == o2 ? "calc(" : "") + "var(--" + ("$" === o2 ? S(t2) + (l2.includes("$") ? "" : S(r2)) + l2.replace(/\$/g, "-") : l2) + ")" + (n2 || "--" == o2 ? "*" + (n2 || "") + (i2 || "1") + ")" : "")), y = /\s*,\s*(?![^()]*\))/, B = Object.prototype.toString, $ = (e2, t2, r2, n2, i2) => {
  let o2, l2, s2;
  const a2 = (e3, t3, r3) => {
    let c2, g2;
    const p2 = (e4) => {
      for (c2 in e4) {
        const R2 = 64 === c2.charCodeAt(0), z2 = R2 && Array.isArray(e4[c2]) ? e4[c2] : [e4[c2]];
        for (g2 of z2) {
          const e5 = /[A-Z]/.test($2 = c2) ? $2 : $2.replace(/-[^]/g, (e6) => e6[1].toUpperCase()), z3 = "object" == typeof g2 && g2 && g2.toString === B && (!n2.utils[e5] || !t3.length);
          if (e5 in n2.utils && !z3) {
            const t4 = n2.utils[e5];
            if (t4 !== l2) {
              l2 = t4, p2(t4(g2)), l2 = null;
              continue;
            }
          } else if (e5 in u) {
            const t4 = u[e5];
            if (t4 !== s2) {
              s2 = t4, p2(t4(g2)), s2 = null;
              continue;
            }
          }
          if (R2 && (b2 = c2.slice(1) in n2.media ? "@media " + n2.media[c2.slice(1)] : c2, c2 = b2.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e6, t4, r4, n3, i3, o3) => {
            const l3 = h$1.test(t4), s3 = 0.0625 * (l3 ? -1 : 1), [a3, c3] = l3 ? [n3, t4] : [t4, n3];
            return "(" + ("=" === r4[0] ? "" : ">" === r4[0] === l3 ? "max-" : "min-") + a3 + ":" + ("=" !== r4[0] && 1 === r4.length ? c3.replace(h$1, (e7, t5, n4) => Number(t5) + s3 * (">" === r4 ? 1 : -1) + n4) : c3) + (i3 ? ") and (" + (">" === i3[0] ? "min-" : "max-") + a3 + ":" + (1 === i3.length ? o3.replace(h$1, (e7, t5, r5) => Number(t5) + s3 * (">" === i3 ? -1 : 1) + r5) : o3) : "") + ")";
          })), z3) {
            const e6 = R2 ? r3.concat(c2) : [...r3], n3 = R2 ? [...t3] : f$1(t3, c2.split(y));
            void 0 !== o2 && i2(x(...o2)), o2 = void 0, a2(g2, n3, e6);
          } else
            void 0 === o2 && (o2 = [[], t3, r3]), c2 = R2 || 36 !== c2.charCodeAt(0) ? c2 : `--${S(n2.prefix)}${c2.slice(1).replace(/\$/g, "-")}`, g2 = z3 ? g2 : "number" == typeof g2 ? g2 && e5 in I ? String(g2) + "px" : String(g2) : k(m$1(e5, null == g2 ? "" : g2), n2.prefix, n2.themeMap[e5]), o2[0].push(`${R2 ? `${c2} ` : `${d(c2)}:`}${g2}`);
        }
      }
      var b2, $2;
    };
    p2(e3), void 0 !== o2 && i2(x(...o2)), o2 = void 0;
  };
  a2(e2, t2, r2);
}, x = (e2, t2, r2) => `${r2.map((e3) => `${e3}{`).join("")}${t2.length ? `${t2.join(",")}{` : ""}${e2.join(";")}${t2.length ? "}" : ""}${Array(r2.length ? r2.length + 1 : 0).join("}")}`, I = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, R = (e2) => String.fromCharCode(e2 + (e2 > 25 ? 39 : 97)), z = (e2) => ((e3) => {
  let t2, r2 = "";
  for (t2 = Math.abs(e3); t2 > 52; t2 = t2 / 52 | 0)
    r2 = R(t2 % 52) + r2;
  return R(t2 % 52) + r2;
})(((e3, t2) => {
  let r2 = t2.length;
  for (; r2; )
    e3 = 33 * e3 ^ t2.charCodeAt(--r2);
  return e3;
})(5381, JSON.stringify(e2)) >>> 0), W = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], j = (e2) => {
  if (e2.href && !e2.href.startsWith(location.origin))
    return false;
  try {
    return !!e2.cssRules;
  } catch (e3) {
    return false;
  }
}, E = (e2) => {
  let t2;
  const r2 = () => {
    const { cssRules: e3 } = t2.sheet;
    return [].map.call(e3, (r3, n3) => {
      const { cssText: i2 } = r3;
      let o2 = "";
      if (i2.startsWith("--sxs"))
        return "";
      if (e3[n3 - 1] && (o2 = e3[n3 - 1].cssText).startsWith("--sxs")) {
        if (!r3.cssRules.length)
          return "";
        for (const e4 in t2.rules)
          if (t2.rules[e4].group === r3)
            return `--sxs{--sxs:${[...t2.rules[e4].cache].join(" ")}}${i2}`;
        return r3.cssRules.length ? `${o2}${i2}` : "";
      }
      return i2;
    }).join("");
  }, n2 = () => {
    if (t2) {
      const { rules: e3, sheet: r3 } = t2;
      if (!r3.deleteRule) {
        for (; 3 === Object(Object(r3.cssRules)[0]).type; )
          r3.cssRules.splice(0, 1);
        r3.cssRules = [];
      }
      for (const t3 in e3)
        delete e3[t3];
    }
    const i2 = Object(e2).styleSheets || [];
    for (const e3 of i2)
      if (j(e3)) {
        for (let i3 = 0, o3 = e3.cssRules; o3[i3]; ++i3) {
          const l3 = Object(o3[i3]);
          if (1 !== l3.type)
            continue;
          const s2 = Object(o3[i3 + 1]);
          if (4 !== s2.type)
            continue;
          ++i3;
          const { cssText: a2 } = l3;
          if (!a2.startsWith("--sxs"))
            continue;
          const c2 = a2.slice(14, -3).trim().split(/\s+/), d2 = W[c2[0]];
          d2 && (t2 || (t2 = { sheet: e3, reset: n2, rules: {}, toString: r2 }), t2.rules[d2] = { group: s2, index: i3, cache: new Set(c2) });
        }
        if (t2)
          break;
      }
    if (!t2) {
      const i3 = (e3, t3) => ({ type: t3, cssRules: [], insertRule(e4, t4) {
        this.cssRules.splice(t4, 0, i3(e4, { import: 3, undefined: 1 }[(e4.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return "@media{}" === e3 ? `@media{${[].map.call(this.cssRules, (e4) => e4.cssText).join("")}}` : e3;
      } });
      t2 = { sheet: e2 ? (e2.head || e2).appendChild(document.createElement("style")).sheet : i3("", "text/css"), rules: {}, reset: n2, toString: r2 };
    }
    const { sheet: o2, rules: l2 } = t2;
    for (let e3 = W.length - 1; e3 >= 0; --e3) {
      const t3 = W[e3];
      if (!l2[t3]) {
        const r3 = W[e3 + 1], n3 = l2[r3] ? l2[r3].index : o2.cssRules.length;
        o2.insertRule("@media{}", n3), o2.insertRule(`--sxs{--sxs:${e3}}`, n3), l2[t3] = { group: o2.cssRules[n3 + 1], index: n3, cache: /* @__PURE__ */ new Set([e3]) };
      }
      v(l2[t3]);
    }
  };
  return n2(), t2;
}, v = (e2) => {
  const t2 = e2.group;
  let r2 = t2.cssRules.length;
  e2.apply = (e3) => {
    try {
      t2.insertRule(e3, r2), ++r2;
    } catch (e4) {
    }
  };
}, T = Symbol(), w = o$1(), M = (e2, t2) => w(e2, () => (...r2) => {
  let n2 = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const t3 of r2)
    if (null != t3)
      if (t3[l$1]) {
        null == n2.type && (n2.type = t3[l$1].type);
        for (const e3 of t3[l$1].composers)
          n2.composers.add(e3);
      } else
        t3.constructor !== Object || t3.$$typeof ? null == n2.type && (n2.type = t3) : n2.composers.add(C(t3, e2));
  return null == n2.type && (n2.type = "span"), n2.composers.size || n2.composers.add(["PJLV", {}, [], [], {}, []]), P(e2, n2, t2);
}), C = ({ variants: e2, compoundVariants: t2, defaultVariants: r2, ...n2 }, i2) => {
  const o2 = `${S(i2.prefix)}c-${z(n2)}`, l2 = [], s2 = [], d2 = /* @__PURE__ */ Object.create(null), g2 = [];
  for (const e3 in r2)
    d2[e3] = String(r2[e3]);
  if ("object" == typeof e2 && e2)
    for (const t3 in e2) {
      p2 = d2, u2 = t3, c.call(p2, u2) || (d2[t3] = "undefined");
      const r3 = e2[t3];
      for (const e3 in r3) {
        const n3 = { [t3]: String(e3) };
        "undefined" === String(e3) && g2.push(t3);
        const i3 = r3[e3], o3 = [n3, i3, !a(i3)];
        l2.push(o3);
      }
    }
  var p2, u2;
  if ("object" == typeof t2 && t2)
    for (const e3 of t2) {
      let { css: t3, ...r3 } = e3;
      t3 = "object" == typeof t3 && t3 || {};
      for (const e4 in r3)
        r3[e4] = String(r3[e4]);
      const n3 = [r3, t3, !a(t3)];
      s2.push(n3);
    }
  return [o2, n2, l2, s2, d2, g2];
}, P = (e2, t2, r2) => {
  const [n2, i2, o2, a2] = L(t2.composers), c2 = "function" == typeof t2.type || t2.type.$$typeof ? ((e3) => {
    function t3() {
      for (let r3 = 0; r3 < t3[T].length; r3++) {
        const [n3, i3] = t3[T][r3];
        e3.rules[n3].apply(i3);
      }
      return t3[T] = [], null;
    }
    return t3[T] = [], t3.rules = {}, W.forEach((e4) => t3.rules[e4] = { apply: (r3) => t3[T].push([e4, r3]) }), t3;
  })(r2) : null, d2 = (c2 || r2).rules, g2 = `.${n2}${i2.length > 1 ? `:where(.${i2.slice(1).join(".")})` : ""}`, p2 = (l2) => {
    l2 = "object" == typeof l2 && l2 || A;
    const { css: s2, ...p3 } = l2, u2 = {};
    for (const e3 in o2)
      if (delete p3[e3], e3 in l2) {
        let t3 = l2[e3];
        "object" == typeof t3 && t3 ? u2[e3] = { "@initial": o2[e3], ...t3 } : (t3 = String(t3), u2[e3] = "undefined" !== t3 || a2.has(e3) ? t3 : o2[e3]);
      } else
        u2[e3] = o2[e3];
    const h = /* @__PURE__ */ new Set([...i2]);
    for (const [n3, i3, o3, l3] of t2.composers) {
      r2.rules.styled.cache.has(n3) || (r2.rules.styled.cache.add(n3), $(i3, [`.${n3}`], [], e2, (e3) => {
        d2.styled.apply(e3);
      }));
      const t3 = O(o3, u2, e2.media), s3 = O(l3, u2, e2.media, true);
      for (const i4 of t3)
        if (void 0 !== i4)
          for (const [t4, o4, l4] of i4) {
            const i5 = `${n3}-${z(o4)}-${t4}`;
            h.add(i5);
            const s4 = (l4 ? r2.rules.resonevar : r2.rules.onevar).cache, a3 = l4 ? d2.resonevar : d2.onevar;
            s4.has(i5) || (s4.add(i5), $(o4, [`.${i5}`], [], e2, (e3) => {
              a3.apply(e3);
            }));
          }
      for (const t4 of s3)
        if (void 0 !== t4)
          for (const [i4, o4] of t4) {
            const t5 = `${n3}-${z(o4)}-${i4}`;
            h.add(t5), r2.rules.allvar.cache.has(t5) || (r2.rules.allvar.cache.add(t5), $(o4, [`.${t5}`], [], e2, (e3) => {
              d2.allvar.apply(e3);
            }));
          }
    }
    if ("object" == typeof s2 && s2) {
      const t3 = `${n2}-i${z(s2)}-css`;
      h.add(t3), r2.rules.inline.cache.has(t3) || (r2.rules.inline.cache.add(t3), $(s2, [`.${t3}`], [], e2, (e3) => {
        d2.inline.apply(e3);
      }));
    }
    for (const e3 of String(l2.className || "").trim().split(/\s+/))
      e3 && h.add(e3);
    const f2 = p3.className = [...h].join(" ");
    return { type: t2.type, className: f2, selector: g2, props: p3, toString: () => f2, deferredInjector: c2 };
  };
  return s(p2, { className: n2, selector: g2, [l$1]: t2, toString: () => (r2.rules.styled.cache.has(n2) || p2(), n2) });
}, L = (e2) => {
  let t2 = "";
  const r2 = [], n2 = {}, i2 = [];
  for (const [o2, , , , l2, s2] of e2) {
    "" === t2 && (t2 = o2), r2.push(o2), i2.push(...s2);
    for (const e3 in l2) {
      const t3 = l2[e3];
      (void 0 === n2[e3] || "undefined" !== t3 || s2.includes(t3)) && (n2[e3] = t3);
    }
  }
  return [t2, r2, n2, new Set(i2)];
}, O = (e2, t2, r2, n2) => {
  const i2 = [];
  e:
    for (let [o2, l2, s2] of e2) {
      if (s2)
        continue;
      let e3, a2 = 0, c2 = false;
      for (e3 in o2) {
        const n3 = o2[e3];
        let i3 = t2[e3];
        if (i3 !== n3) {
          if ("object" != typeof i3 || !i3)
            continue e;
          {
            let e4, t3, o3 = 0;
            for (const l3 in i3) {
              if (n3 === String(i3[l3])) {
                if ("@initial" !== l3) {
                  const e5 = l3.slice(1);
                  (t3 = t3 || []).push(e5 in r2 ? r2[e5] : l3.replace(/^@media ?/, "")), c2 = true;
                }
                a2 += o3, e4 = true;
              }
              ++o3;
            }
            if (t3 && t3.length && (l2 = { ["@media " + t3.join(", ")]: l2 }), !e4)
              continue e;
          }
        }
      }
      (i2[a2] = i2[a2] || []).push([n2 ? "cv" : `${e3}-${o2[e3]}`, l2, c2]);
    }
  return i2;
}, A = {}, N = o$1(), D = (e2, t2) => N(e2, () => (...r2) => {
  const n2 = () => {
    for (let n3 of r2) {
      n3 = "object" == typeof n3 && n3 || {};
      let r3 = z(n3);
      if (!t2.rules.global.cache.has(r3)) {
        if (t2.rules.global.cache.add(r3), "@import" in n3) {
          let e3 = [].indexOf.call(t2.sheet.cssRules, t2.rules.themed.group) - 1;
          for (let r4 of [].concat(n3["@import"]))
            r4 = r4.includes('"') || r4.includes("'") ? r4 : `"${r4}"`, t2.sheet.insertRule(`@import ${r4};`, e3++);
          delete n3["@import"];
        }
        $(n3, [], [], e2, (e3) => {
          t2.rules.global.apply(e3);
        });
      }
    }
    return "";
  };
  return s(n2, { toString: n2 });
}), H = o$1(), V = (e2, t2) => H(e2, () => (r2) => {
  const n2 = `${S(e2.prefix)}k-${z(r2)}`, i2 = () => {
    if (!t2.rules.global.cache.has(n2)) {
      t2.rules.global.cache.add(n2);
      const i3 = [];
      $(r2, [], [], e2, (e3) => i3.push(e3));
      const o2 = `@keyframes ${n2}{${i3.join("")}}`;
      t2.rules.global.apply(o2);
    }
    return n2;
  };
  return s(i2, { get name() {
    return i2();
  }, toString: i2 });
}), G = class {
  constructor(e2, t2, r2, n2) {
    this.token = null == e2 ? "" : String(e2), this.value = null == t2 ? "" : String(t2), this.scale = null == r2 ? "" : String(r2), this.prefix = null == n2 ? "" : String(n2);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + S(this.prefix) + S(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, F = o$1(), J = (e2, t2) => F(e2, () => (r2, n2) => {
  n2 = "object" == typeof r2 && r2 || Object(n2);
  const i2 = `.${r2 = (r2 = "string" == typeof r2 ? r2 : "") || `${S(e2.prefix)}t-${z(n2)}`}`, o2 = {}, l2 = [];
  for (const t3 in n2) {
    o2[t3] = {};
    for (const r3 in n2[t3]) {
      const i3 = `--${S(e2.prefix)}${t3}-${r3}`, s3 = k(String(n2[t3][r3]), e2.prefix, t3);
      o2[t3][r3] = new G(r3, s3, t3, e2.prefix), l2.push(`${i3}:${s3}`);
    }
  }
  const s2 = () => {
    if (l2.length && !t2.rules.themed.cache.has(r2)) {
      t2.rules.themed.cache.add(r2);
      const i3 = `${n2 === e2.theme ? ":root," : ""}.${r2}{${l2.join(";")}}`;
      t2.rules.themed.apply(i3);
    }
    return r2;
  };
  return { ...o2, get className() {
    return s2();
  }, selector: i2, toString: s2 };
}), U = o$1();
var X, Y = o$1(), q$1 = (e2) => {
  const t2 = ((e3) => {
    let t3 = false;
    const r2 = U(e3, (e4) => {
      t3 = true;
      const r3 = "prefix" in (e4 = "object" == typeof e4 && e4 || {}) ? String(e4.prefix) : "", i2 = "object" == typeof e4.media && e4.media || {}, o2 = "object" == typeof e4.root ? e4.root || null : globalThis.document || null, l2 = "object" == typeof e4.theme && e4.theme || {}, s2 = { prefix: r3, media: i2, theme: l2, themeMap: "object" == typeof e4.themeMap && e4.themeMap || { ...n$2 }, utils: "object" == typeof e4.utils && e4.utils || {} }, a2 = E(o2), c2 = { css: M(s2, a2), globalCss: D(s2, a2), keyframes: V(s2, a2), createTheme: J(s2, a2), reset() {
        a2.reset(), c2.theme.toString();
      }, theme: {}, sheet: a2, config: s2, prefix: r3, getCssText: a2.toString, toString: a2.toString };
      return String(c2.theme = c2.createTheme(l2)), c2;
    });
    return t3 || r2.reset(), r2;
  })(e2);
  return t2.styled = (({ config: e3, sheet: t3 }) => Y(e3, () => {
    const r2 = M(e3, t3);
    return (...e4) => {
      const t4 = r2(...e4), n2 = t4[l$1].type, i2 = t__default.forwardRef((e5, r3) => {
        const i3 = e5 && e5.as || n2, { props: o2, deferredInjector: l2 } = t4(e5);
        return delete o2.as, o2.ref = r3, l2 ? t__default.createElement(t__default.Fragment, null, t__default.createElement(i3, o2), t__default.createElement(l2, null)) : t__default.createElement(i3, o2);
      });
      return i2.className = t4.className, i2.displayName = `Styled.${n2.displayName || n2.name || n2}`, i2.selector = t4.selector, i2.toString = () => t4.selector, i2[l$1] = t4[l$1], i2;
    };
  }))(t2), t2;
}, K = () => X || (X = q$1()), te = (...e2) => K().css(...e2), re = (...e2) => K().styled(...e2);
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
function getValueAndUnit(value) {
  if (typeof value !== "string")
    return [value, ""];
  var matchedValue = value.match(cssRegex);
  if (matchedValue)
    return [parseFloat(value), matchedValue[2]];
  return [value, void 0];
}
var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};
function getRatio(ratioName) {
  return ratioNames[ratioName];
}
function modularScale(steps, base2, ratio) {
  if (base2 === void 0) {
    base2 = "1em";
  }
  if (ratio === void 0) {
    ratio = 1.333;
  }
  if (typeof steps !== "number") {
    throw new PolishedError(42);
  }
  if (typeof ratio === "string" && !ratioNames[ratio]) {
    throw new PolishedError(43);
  }
  var _ref = typeof base2 === "string" ? getValueAndUnit(base2) : [base2, ""], realBase = _ref[0], unit = _ref[1];
  var realRatio = typeof ratio === "string" ? getRatio(ratio) : ratio;
  if (typeof realBase === "string") {
    throw new PolishedError(44, base2);
  }
  return "" + realBase * Math.pow(realRatio, steps) + (unit || "");
}
function createScale(ratio, base2) {
  return function(steps) {
    return `${modularScale(steps, base2, ratio)}px`;
  };
}
const sizeValues = {
  size0: "0px",
  size10: "1px",
  size25: "2px",
  size40: "3px",
  size50: "4px",
  size65: "5px",
  size75: "6px",
  size85: "7px",
  size100: "8px",
  size115: "9px",
  size125: "10px",
  size130: "11px",
  size150: "12px",
  size160: "13px",
  size175: "14px",
  size200: "16px",
  size225: "18px",
  size250: "20px",
  size300: "24px",
  size350: "28px",
  size400: "32px",
  size450: "36px",
  size500: "40px",
  size550: "44px",
  size600: "48px",
  size675: "54px",
  size700: "56px",
  size800: "64px",
  size900: "72px",
  size1000: "80px",
  size1100: "88px",
  size1200: "96px",
  size1250: "100px",
  size1600: "128px",
  size1700: "136px",
  size2000: "160px",
  size2400: "192px",
  size3000: "240px",
  size3400: "272px",
  size3600: "288px",
  size4600: "368px",
  size5000: "400px",
  size6000: "480px",
  none: "$size0",
  xxsmall: "$size50",
  xsmall: "$size100",
  small: "$size150",
  medium: "$size200",
  large: "$size300",
  xlarge: "$size500",
  xxlarge: "$size1200"
};
const spaceValues = {
  space0: "0px",
  space10: "1px",
  space20: "2px",
  space30: "3px",
  space50: "4px",
  space65: "5px",
  space75: "6px",
  space85: "7px",
  space100: "8px",
  space115: "9px",
  space125: "10px",
  space130: "11px",
  space150: "12px",
  space160: "13px",
  space175: "14px",
  space200: "16px",
  space225: "18px",
  space250: "20px",
  space300: "24px",
  space350: "28px",
  space400: "32px",
  space450: "36px",
  space500: "40px",
  space550: "44px",
  space600: "48px",
  space700: "56px",
  space800: "64px",
  space900: "72px",
  space1000: "80px",
  space1100: "88px",
  space1200: "96px",
  space1400: "100px",
  space1600: "128px",
  space1800: "144px",
  space2000: "160px",
  space2200: "176px",
  space2400: "192px",
  space2600: "208px",
  space2800: "224px",
  space3000: "240px",
  space3200: "256px",
  space3600: "288px",
  space4000: "320px",
  space4800: "384px",
  none: "$space0",
  xxsmall: "$space50",
  xsmall: "$space100",
  small: "$space150",
  medium: "$space200",
  large: "$space300",
  xlarge: "$space400",
  xxlarge: "$space500"
};
const borderRadiusScale = createScale(1.5, 4);
const borderRadiusValues = {
  none: "0",
  xsmall: borderRadiusScale(0),
  small: borderRadiusScale(1),
  medium: borderRadiusScale(2),
  large: borderRadiusScale(3),
  xlarge: borderRadiusScale(4),
  full: "9999px"
};
const borderStyleValues = {
  solid: "solid",
  dashed: "dashed",
  dotted: "dotted",
  double: "double",
  none: "none"
};
const borderWidthValues = {
  border0: "0px",
  border100: "1px",
  border200: "2px",
  border300: "3px",
  border400: "4px",
  border500: "5px",
  border600: "6px",
  border700: "7px",
  border800: "8px",
  none: "$border0",
  thin: "$border100",
  thick: "$border200",
  thicker: "$border400",
  thickest: "$border800"
};
const fontFamilyValues = {
  inherit: "inherit",
  primary: '"Messina Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";'
};
const fontSizeValues = {
  font25: "11px",
  font50: "12px",
  font75: "14px",
  font100: "16px",
  font200: "18px",
  font300: "20px",
  font400: "22px",
  font500: "24px",
  font600: "28px",
  font700: "32px",
  xxsmall: "$font25",
  xsmall: "$font50",
  small: "$font75",
  medium: "$font100",
  large: "$font200",
  xlarge: "$font300"
};
const lineHeightValues = {
  leading75: "14px",
  leading100: "16px",
  leading200: "18px",
  leading300: "20px",
  leading400: "22px",
  leading500: "24px",
  leading600: "28px",
  leading700: "32px",
  leading800: "36px",
  leading900: "40px",
  xxsmall: "$leading75",
  xsmall: "$leading100",
  small: "$leading400",
  medium: "$leading400",
  large: "$leading500",
  xlarge: "$leading600"
};
const fontWeightValues = {
  normal: 500,
  semi: 600,
  bold: 700
};
const colorValues = {
  black: "#000000",
  white: "#FFFFFF",
  current: "currentColor",
  transparent: "transparent",
  yellow: "#FFD52E",
  oceanDark2: "#164D62",
  oceanDark1: "#164D62",
  ocean: "#206E8C",
  oceanLight1: "#E9F1F4",
  oceanLight2: "#F4F8F9",
  bodyDark2: "#3D3D3B",
  bodyDark1: "#706F6D",
  body: "#CCCAC6",
  bodyLight1: "#E0DFDD",
  bodyLight2: "#F5F4F4",
  bodyLight3: "#F7F7F6",
  lavenderDark2: "#1A2859",
  lavenderDark1: "#56608C",
  lavender: "#6773A7",
  lavenderRef: "#7280BA",
  lavenderLight1: "#EAECF5",
  lavenderLight2: "#F1F2F8",
  canaryDark2: "#384E55",
  canaryDark1: "#47616B",
  canary: "#557480",
  canaryRef: "#8DC2D5",
  canaryLight1: "#E8F3F7",
  canaryLight2: "#F4F9FB",
  lilacDark2: "#574066",
  lilacDark1: "#7A5A8E",
  lilac: "#8B66A2",
  lilacRef: "#AE80CB",
  lilacLight1: "#EFE6F5",
  lilacLight2: "#F7F2FA",
  blueDark2: "#004D99",
  blueDark1: "#0066CC",
  blue: "#0073E6",
  blueRef: "#0080FF",
  blueLight1: "#E6F2FF",
  blueLight2: "#F2F9FF",
  greenDark2: "#1B4D40",
  greenDark1: "#266C59",
  green: "#2B7B66",
  greenRef: "#369A7F",
  greenLight1: "#C3E1D9",
  greenLight2: "#EBF5F2",
  orangeDark2: "#773A11",
  orangeDark1: "#9A4B15",
  orange: "#B25719",
  orangeRef: "#ED7421",
  orangeLight1: "#FBE3D3",
  orangeLight2: "#FDF1E9",
  redDark2: "#802121",
  redDark1: "#962727",
  red: "#AB2C2C",
  redRef: "#D63737",
  redLight1: "#F7D7D7",
  redLight2: "#FBEBEB",
  primary: "$yellow",
  accent: "$ocean",
  accentHover: "$oceanDark1",
  accentPressed: "$oceanDark2",
  accentBackground: "$oceanLight1",
  accentBackgroundSecondary: "$oceanLight2",
  accentBorder: "$ocean",
  neutral: "$body",
  neutralDark1: "$bodyDark1",
  neutralDark2: "$bodyDark2",
  neutralLight1: "$bodyLight1",
  neutralLight2: "$bodyLight2",
  text: "$bodyDark2",
  textSecondary: "$bodyDark1",
  muted: "$bodyDark1",
  neutralLightBackground: "$neutralLight2",
  neutralLightBackgroundHover: "$neutralLight1",
  neutralLightBackgroundPressed: "$neutral",
  info: "$lavender",
  infoHover: "$lavenderDark1",
  infoPressed: "$lavenderDark2",
  infoBackground: "$lavenderLight1",
  infoBackgroundHover: "$lavenderLight1",
  infoBackgroundSecondary: "$lavenderLight2",
  progress: "$blue",
  progressHover: "$blueDark1",
  progressPressed: "$blueDark2",
  progressBackground: "$blueLight1",
  progressBackgroundHover: "$blueLight1",
  progressBackgroundSecondary: "$blueLight2",
  positive: "$green",
  positiveHover: "$greenDark1",
  positivePressed: "$greenDark2",
  positiveBackground: "$greenLight1",
  positiveBackgroundHover: "$greenLight1",
  positiveBackgroundSecondary: "$greenLight2",
  notice: "$orange",
  noticeHover: "$orangeDark1",
  noticePressed: "$orangeDark2",
  noticeBackground: "$orangeLight1",
  noticeBackgroundHover: "$orangeLight1",
  noticeBackgroundPressed: "$orangeLight2",
  critical: "$red",
  criticalHover: "$redDark1",
  criticalPressed: "$redDark2",
  criticalBackground: "$redLight1",
  criticalBackgroundHover: "$redLight1",
  criticalBackgroundPressed: "$redLight2"
};
({
  $default: colorValues.text,
  $muted: colorValues.textSecondary,
  $positive: colorValues.positive,
  $critical: colorValues.critical,
  $progress: colorValues.progress,
  $notice: colorValues.notice
});
const shadowValues = {
  xsmall: "0px 1px 2px rgba(0, 0, 0, 0.03)",
  small: "0px 1px 3px rgba(0, 0, 0, 0.06), 0px 1px 2px -1px rgba(0, 0, 0, 0.06)",
  medium: "0px 4px 6px -1px rgba(0, 0, 0, 0.06), 0px 2px 4px -2px rgba(0, 0, 0, 0.06)",
  large: "0px 10px 15px -3px rgba(0, 0, 0, 0.06), 0px 4px 6px -4px rgba(0, 0, 0, 0.06)",
  xlarge: "0px 20px 25px -5px rgba(0, 0, 0, 0.06), 0px 8px 10px -6px rgba(0, 0, 0, 0.06)",
  xxlarge: "0px 25px 50px -12px rgba(0, 0, 0, 0.12)"
};
const transitionValues = {
  transition100: "100ms all ease-in-out",
  transition150: "150ms all ease-in-out",
  transition200: "200ms all ease-in-out",
  transition250: "250ms all ease-in-out",
  transition300: "300ms all ease-in-out"
};
const { config, css, theme } = q$1({
  media: {
    initial: "(min-width: 0px)",
    xsmall: "(min-width: 390px)",
    small: "(min-width: 640px)",
    medium: "(min-width: 768px)",
    large: "(min-width: 1024px)",
    xlarge: "(min-width: 1280px)",
    xxlarge: "(min-width: 1440px)"
  },
  theme: {
    borderStyles: borderStyleValues,
    borderWidths: borderWidthValues,
    colors: colorValues,
    fontSizes: fontSizeValues,
    fontWeights: fontWeightValues,
    fonts: fontFamilyValues,
    lineHeights: lineHeightValues,
    radii: borderRadiusValues,
    shadows: shadowValues,
    sizes: sizeValues,
    space: spaceValues,
    transitions: transitionValues
  },
  utils: {
    marginY: (value) => ({
      marginTop: value,
      marginBottom: value
    }),
    marginX: (value) => ({
      marginLeft: value,
      marginRight: value
    }),
    paddingY: (value) => ({
      paddingTop: value,
      paddingBottom: value
    }),
    paddingX: (value) => ({
      paddingLeft: value,
      paddingRight: value
    }),
    borderTopRadius: (value) => ({
      borderTopLeftRadius: value,
      borderTopRightRadius: value
    }),
    borderRightRadius: (value) => ({
      borderTopRightRadius: value,
      borderBottomRightRadius: value
    }),
    borderBottomRadius: (value) => ({
      borderBottomLeftRadius: value,
      borderBottomRightRadius: value
    }),
    borderLeftRadius: (value) => ({
      borderTopLeftRadius: value,
      borderBottomLeftRadius: value
    }),
    size: (value) => ({
      fontSize: value,
      lineHeight: value
    }),
    truncate: (value) => {
      return value === "ellipsis" && {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      };
    }
  }
});
const backgroundKeys = {
  backgroundColor: "backgroundColor"
};
const borderKeys = {
  borderStyle: "borderStyle",
  borderLeftStyle: "borderLeftStyle",
  borderTopStyle: "borderTopStyle",
  borderRightStyle: "borderRightStyle",
  borderBottomStyle: "borderBottomStyle",
  borderWidth: "borderWidth",
  borderLeftWidth: "borderLeftWidth",
  borderRightWidth: "borderRightWidth",
  borderTopWidth: "borderTopWidth",
  borderBottomWidth: "borderBottomWidth",
  borderColor: "borderColor",
  borderLeftColor: "borderLeftColor",
  borderRightColor: "borderRightColor",
  borderTopColor: "borderTopColor",
  borderBottomColor: "borderBottomColor",
  borderRadius: "borderRadius",
  borderTopLeftRadius: "borderTopLeftRadius",
  borderTopRightRadius: "borderTopRightRadius",
  borderBottomLeftRadius: "borderBottomLeftRadius",
  borderBottomRightRadius: "borderBottomRightRadius"
};
const shadowKeys = {
  boxShadow: "boxShadow"
};
const colorKeys = {
  color: "color"
};
const layoutKeys = {
  alignSelf: "alignSelf",
  flex: "flex",
  flexBasis: "flexBasis",
  flexGrow: "flexGrow",
  flexShrink: "flexShrink",
  gridArea: "gridArea",
  gridColumn: "gridColumn",
  gridColumnEnd: "gridColumnEnd",
  gridColumnStart: "gridColumnStart",
  gridRow: "gridRow",
  gridRowEnd: "gridRowEnd",
  gridRowStart: "gridRowStart",
  justifySelf: "justifySelf",
  order: "order"
};
const flexKeys = {
  justifyContent: "justifyContent",
  alignItems: "alignItems",
  flexDirection: "flexDirection"
};
const positionKeys = {
  position: "position",
  top: "top",
  bottom: "bottom",
  left: "left",
  right: "right",
  start: "start",
  end: "end",
  zIndex: "zIndex"
};
const sizeKeys = {
  height: "height",
  maxHeight: "maxHeight",
  maxWidth: "maxWidth",
  minHeight: "minHeight",
  minWidth: "minWidth",
  width: "width"
};
const gapKeys = {
  gap: "gap"
};
const marginKeys = {
  margin: "margin",
  marginBottom: "marginBottom",
  marginLeft: "marginLeft",
  marginRight: "marginRight",
  marginTop: "marginTop",
  marginY: "marginY",
  marginX: "marginX"
};
const paddingKeys = {
  padding: "padding",
  paddingBottom: "paddingBottom",
  paddingLeft: "paddingLeft",
  paddingRight: "paddingRight",
  paddingTop: "paddingTop",
  paddingY: "paddingY",
  paddingX: "paddingX"
};
const textKeys = {
  fontFamily: "fontFamily",
  fontSize: "fontSize",
  fontWeight: "fontWeight",
  textAlign: "textAlign"
};
const iconKeys = {
  width: "width",
  height: "height"
};
const baseStyleProps = {
  ...gapKeys,
  ...layoutKeys,
  ...marginKeys,
  ...positionKeys,
  ...sizeKeys
};
const boxStyleProps = {
  ...baseStyleProps,
  ...backgroundKeys,
  ...borderKeys,
  ...flexKeys,
  ...paddingKeys,
  ...shadowKeys,
  display: "display"
};
const textStyleProps = {
  ...backgroundKeys,
  ...baseStyleProps,
  ...colorKeys,
  ...textKeys,
  display: "display"
};
const iconStyleProps = {
  ...baseStyleProps,
  ...iconKeys
};
function compose(...args) {
  return clsx(
    args.map((arg) => {
      if (typeof arg === "function")
        return arg().className;
      else
        return arg.className;
    })
  );
}
function useStyleProps(props, handlers = baseStyleProps) {
  let styleProps = {};
  let otherProps = {};
  for (let key in props) {
    let isFound = !!handlers[key];
    let value = props[key];
    if (isFound)
      if (typeof value === "object")
        for (let responsiveKey in value) {
          let prefix = "@";
          let responsiveValue = value[responsiveKey];
          styleProps[prefix + responsiveKey] = {
            ...styleProps[responsiveKey],
            [key]: responsiveValue
          };
        }
      else
        styleProps[key] = value;
    else
      otherProps[key] = value;
  }
  return { styleProps, ...otherProps };
}
const reset$e = css({
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility",
  boxSizing: "border-box",
  position: "relative"
});
const base$d = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "middle",
  overflow: "hidden",
  userSelect: "none",
  borderWidth: "$thick",
  borderStyle: "solid",
  borderColor: "$bodyLight1"
});
const variants$a = css({
  variants: {
    kind: {
      square: {
        borderRadius: "12px",
        "& > img": {
          borderRadius: "10px"
        }
      },
      circle: {
        borderRadius: "100%",
        "& > img": {
          borderRadius: "calc(100% - 2px)"
        }
      }
    },
    size: {
      xsmall: {
        width: "20px",
        height: "20px"
      },
      small: {
        width: "24px",
        height: "24px"
      },
      medium: {
        width: "32px",
        height: "32px"
      },
      large: {
        width: "40px",
        height: "40px"
      },
      xlarge: {
        width: "48px",
        height: "48px"
      },
      xxlarge: {
        width: "64px",
        height: "64px"
      }
    }
  },
  defaultVariants: {
    size: "medium",
    kind: "circle"
  }
});
const image = css({
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
const fallback = css({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "$bodyLight1",
  fontSize: "$small",
  lineHeight: "$small",
  fontWeight: "$bold",
  fontFamily: "$primary"
});
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s2 = 1; s2 < arguments.length; s2++) {
    from = Object(arguments[s2]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from, symbols[i2])) {
          to[symbols[i2]] = from[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = t__default, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$1 = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c2, a2, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  void 0 !== k2 && (e2 = "" + k2);
  void 0 !== a2.key && (e2 = "" + a2.key);
  void 0 !== a2.ref && (l2 = a2.ref);
  for (b2 in a2)
    n$1.call(a2, b2) && !p.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a2 = c2.defaultProps, a2)
      void 0 === d2[b2] && (d2[b2] = a2[b2]);
  return { $$typeof: g, type: c2, key: e2, ref: l2, props: d2, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const Avatar = forwardRef(function Avatar2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    alt,
    children,
    kind,
    size,
    src
  } = props;
  return /* @__PURE__ */ jsxs($cddcb0b647441e34$export$e2255cf6045e8d47, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    ref,
    className: compose(reset$e, base$d, variants$a({
      kind,
      size
    }), css(styleProps)),
    children: [/* @__PURE__ */ jsx($cddcb0b647441e34$export$2cd8ae1985206fe8, {
      src,
      alt,
      className: compose(reset$e, image)
    }), /* @__PURE__ */ jsx($cddcb0b647441e34$export$69fffb6a9571fbfe, {
      className: compose(reset$e, fallback)
    })]
  });
});
function composeRefs(...o2) {
  return (e2) => o2.forEach((o3) => function(o4, e3) {
    "function" == typeof o4 ? o4(e3) : null != o4 && (o4.current = e3);
  }(o3, e2));
}
const Slot$2 = /* @__PURE__ */ t$1.forwardRef((e2, o2) => {
  const { children: a2, ...s2 } = e2;
  return t$1.Children.toArray(a2).some(l) ? /* @__PURE__ */ t$1.createElement(t$1.Fragment, null, t$1.Children.map(a2, (e3) => l(e3) ? /* @__PURE__ */ t$1.createElement(n, _extends({}, s2, { ref: o2 }), e3.props.children) : e3)) : /* @__PURE__ */ t$1.createElement(n, _extends({}, s2, { ref: o2 }), a2);
});
Slot$2.displayName = "Slot";
const n = /* @__PURE__ */ t$1.forwardRef((r2, n2) => {
  const { children: l2, ...a2 } = r2;
  return t$1.isValidElement(l2) ? /* @__PURE__ */ t$1.cloneElement(l2, { ...o(a2, l2.props), ref: composeRefs(n2, l2.ref) }) : t$1.Children.count(l2) > 1 ? t$1.Children.only(null) : null;
});
n.displayName = "SlotClone";
const Slottable = ({ children: e2 }) => /* @__PURE__ */ t$1.createElement(t$1.Fragment, null, e2);
function l(e2) {
  return t$1.isValidElement(e2) && e2.type === Slottable;
}
function o(e2, t2) {
  const r2 = { ...t2 };
  for (const n2 in t2) {
    const l2 = e2[n2], o2 = t2[n2];
    /^on[A-Z]/.test(n2) ? r2[n2] = (...e3) => {
      null == o2 || o2(...e3), null == l2 || l2(...e3);
    } : "style" === n2 ? r2[n2] = { ...l2, ...o2 } : "className" === n2 && (r2[n2] = [l2, o2].filter(Boolean).join(" "));
  }
  return { ...e2, ...r2 };
}
const Box = forwardRef(function Box2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children
  } = props;
  let ElementType = asChild ? Slot$2 : "div";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css(styleProps)(),
    ref,
    children
  });
});
let $14c0b72509d70225$var$state = "default";
let $14c0b72509d70225$var$savedUserSelect = "";
let $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      $14c0b72509d70225$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
      document.documentElement.style.webkitUserSelect = "none";
    }
    $14c0b72509d70225$var$state = "disabled";
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
    target.style.userSelect = "none";
  }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled")
      return;
    $14c0b72509d70225$var$state = "restoring";
    setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          if (document.documentElement.style.webkitUserSelect === "none")
            document.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
          $14c0b72509d70225$var$savedUserSelect = "";
          $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
      let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
      if (target.style.userSelect === "none")
        target.style.userSelect = targetOldUserSelect;
      if (target.getAttribute("style") === "")
        target.removeAttribute("style");
      $14c0b72509d70225$var$modifiedElementMap.delete(target);
    }
  }
}
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = t__default.createContext(null);
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $f6c31cce2adf654f$var$usePressResponderContext(props) {
  let context = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (context) {
    let { register, ...contextProps } = context;
    props = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
    register();
  }
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, props.ref);
  return props;
}
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
  let {
    onPress: onPress1,
    onPressChange: onPressChange1,
    onPressStart: onPressStart1,
    onPressEnd: onPressEnd1,
    onPressUp: onPressUp1,
    isDisabled: isDisabled1,
    isPressed: isPressedProp,
    preventFocusOnPress,
    shouldCancelOnPointerExit,
    allowTextSelectionOnPress,
    ref: _,
    ...domProps
  } = $f6c31cce2adf654f$var$usePressResponderContext(props);
  let propsRef = useRef(null);
  propsRef.current = {
    onPress: onPress1,
    onPressChange: onPressChange1,
    onPressStart: onPressStart1,
    onPressEnd: onPressEnd1,
    onPressUp: onPressUp1,
    isDisabled: isDisabled1,
    shouldCancelOnPointerExit
  };
  let [isPressed, setPressed] = useState(false);
  let ref = useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    ignoreClickAfterPress: false,
    didFirePressStart: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null
  });
  let { addGlobalListener, removeAllGlobalListeners } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let pressProps1 = useMemo(() => {
    let state = ref.current;
    let triggerPressStart = (originalEvent, pointerType) => {
      let { onPressStart, onPressChange, isDisabled } = propsRef.current;
      if (isDisabled || state.didFirePressStart)
        return;
      if (onPressStart)
        onPressStart({
          type: "pressstart",
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey,
          altKey: originalEvent.altKey
        });
      if (onPressChange)
        onPressChange(true);
      state.didFirePressStart = true;
      setPressed(true);
    };
    let triggerPressEnd = (originalEvent, pointerType, wasPressed = true) => {
      let { onPressEnd, onPressChange, onPress, isDisabled } = propsRef.current;
      if (!state.didFirePressStart)
        return;
      state.ignoreClickAfterPress = true;
      state.didFirePressStart = false;
      if (onPressEnd)
        onPressEnd({
          type: "pressend",
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey,
          altKey: originalEvent.altKey
        });
      if (onPressChange)
        onPressChange(false);
      setPressed(false);
      if (onPress && wasPressed && !isDisabled)
        onPress({
          type: "press",
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey,
          altKey: originalEvent.altKey
        });
    };
    let triggerPressUp = (originalEvent, pointerType) => {
      let { onPressUp, isDisabled } = propsRef.current;
      if (isDisabled)
        return;
      if (onPressUp)
        onPressUp({
          type: "pressup",
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey,
          altKey: originalEvent.altKey
        });
    };
    let cancel = (e2) => {
      if (state.isPressed) {
        if (state.isOverTarget)
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType, false);
        state.isPressed = false;
        state.isOverTarget = false;
        state.activePointerId = null;
        state.pointerType = null;
        removeAllGlobalListeners();
        if (!allowTextSelectionOnPress)
          $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
      }
    };
    let pressProps = {
      onKeyDown(e2) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e2.nativeEvent, e2.currentTarget) && e2.currentTarget.contains(e2.target)) {
          if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e2.target, e2.key))
            e2.preventDefault();
          e2.stopPropagation();
          if (!state.isPressed && !e2.repeat) {
            state.target = e2.currentTarget;
            state.isPressed = true;
            triggerPressStart(e2, "keyboard");
            addGlobalListener(document, "keyup", onKeyUp, false);
          }
        } else if (e2.key === "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(e2.currentTarget))
          e2.stopPropagation();
      },
      onKeyUp(e2) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e2.nativeEvent, e2.currentTarget) && !e2.repeat && e2.currentTarget.contains(e2.target))
          triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e2), "keyboard");
      },
      onClick(e2) {
        if (e2 && !e2.currentTarget.contains(e2.target))
          return;
        if (e2 && e2.button === 0) {
          e2.stopPropagation();
          if (isDisabled1)
            e2.preventDefault();
          if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && (state.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(e2.nativeEvent))) {
            if (!isDisabled1 && !preventFocusOnPress)
              $7215afc6de606d6b$export$de79e2c695e052f3(e2.currentTarget);
            triggerPressStart(e2, "virtual");
            triggerPressUp(e2, "virtual");
            triggerPressEnd(e2, "virtual");
          }
          state.ignoreEmulatedMouseEvents = false;
          state.ignoreClickAfterPress = false;
        }
      }
    };
    let onKeyUp = (e2) => {
      if (state.isPressed && $f6c31cce2adf654f$var$isValidKeyboardEvent(e2, state.target)) {
        if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e2.target, e2.key))
          e2.preventDefault();
        e2.stopPropagation();
        state.isPressed = false;
        let target = e2.target;
        triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), "keyboard", state.target.contains(target));
        removeAllGlobalListeners();
        if (state.target instanceof HTMLElement && state.target.contains(target) && ($f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) || state.target.getAttribute("role") === "link"))
          state.target.click();
      }
    };
    if (typeof PointerEvent !== "undefined") {
      pressProps.onPointerDown = (e2) => {
        if (e2.button !== 0 || !e2.currentTarget.contains(e2.target))
          return;
        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(e2.nativeEvent)) {
          state.pointerType = "virtual";
          return;
        }
        if ($f6c31cce2adf654f$var$shouldPreventDefault(e2.currentTarget))
          e2.preventDefault();
        state.pointerType = e2.pointerType;
        e2.stopPropagation();
        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e2.pointerId;
          state.target = e2.currentTarget;
          if (!isDisabled1 && !preventFocusOnPress)
            $7215afc6de606d6b$export$de79e2c695e052f3(e2.currentTarget);
          if (!allowTextSelectionOnPress)
            $14c0b72509d70225$export$16a4697467175487(state.target);
          triggerPressStart(e2, state.pointerType);
          addGlobalListener(document, "pointermove", onPointerMove, false);
          addGlobalListener(document, "pointerup", onPointerUp, false);
          addGlobalListener(document, "pointercancel", onPointerCancel, false);
        }
      };
      pressProps.onMouseDown = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        if (e2.button === 0) {
          if ($f6c31cce2adf654f$var$shouldPreventDefault(e2.currentTarget))
            e2.preventDefault();
          e2.stopPropagation();
        }
      };
      pressProps.onPointerUp = (e2) => {
        if (!e2.currentTarget.contains(e2.target) || state.pointerType === "virtual")
          return;
        if (e2.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e2, e2.currentTarget))
          triggerPressUp(e2, state.pointerType || e2.pointerType);
      };
      let onPointerMove = (e2) => {
        if (e2.pointerId !== state.activePointerId)
          return;
        if ($f6c31cce2adf654f$var$isOverTarget(e2, state.target)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit)
            cancel(e2);
        }
      };
      let onPointerUp = (e2) => {
        if (e2.pointerId === state.activePointerId && state.isPressed && e2.button === 0) {
          if ($f6c31cce2adf654f$var$isOverTarget(e2, state.target))
            triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType);
          else if (state.isOverTarget)
            triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType, false);
          state.isPressed = false;
          state.isOverTarget = false;
          state.activePointerId = null;
          state.pointerType = null;
          removeAllGlobalListeners();
          if (!allowTextSelectionOnPress)
            $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
      };
      let onPointerCancel = (e2) => {
        cancel(e2);
      };
      pressProps.onDragStart = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        cancel(e2);
      };
    } else {
      pressProps.onMouseDown = (e2) => {
        if (e2.button !== 0 || !e2.currentTarget.contains(e2.target))
          return;
        if ($f6c31cce2adf654f$var$shouldPreventDefault(e2.currentTarget))
          e2.preventDefault();
        e2.stopPropagation();
        if (state.ignoreEmulatedMouseEvents)
          return;
        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e2.currentTarget;
        state.pointerType = $6a7db85432448f7f$export$60278871457622de(e2.nativeEvent) ? "virtual" : "mouse";
        if (!isDisabled1 && !preventFocusOnPress)
          $7215afc6de606d6b$export$de79e2c695e052f3(e2.currentTarget);
        triggerPressStart(e2, state.pointerType);
        addGlobalListener(document, "mouseup", onMouseUp, false);
      };
      pressProps.onMouseEnter = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = true;
          triggerPressStart(e2, state.pointerType);
        }
      };
      pressProps.onMouseLeave = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = false;
          triggerPressEnd(e2, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit)
            cancel(e2);
        }
      };
      pressProps.onMouseUp = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        if (!state.ignoreEmulatedMouseEvents && e2.button === 0)
          triggerPressUp(e2, state.pointerType);
      };
      let onMouseUp = (e2) => {
        if (e2.button !== 0)
          return;
        state.isPressed = false;
        removeAllGlobalListeners();
        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }
        if ($f6c31cce2adf654f$var$isOverTarget(e2, state.target))
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType);
        else if (state.isOverTarget)
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e2), state.pointerType, false);
        state.isOverTarget = false;
      };
      pressProps.onTouchStart = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e2.nativeEvent);
        if (!touch)
          return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e2.currentTarget;
        state.pointerType = "touch";
        if (!isDisabled1 && !preventFocusOnPress)
          $7215afc6de606d6b$export$de79e2c695e052f3(e2.currentTarget);
        if (!allowTextSelectionOnPress)
          $14c0b72509d70225$export$16a4697467175487(state.target);
        triggerPressStart(e2, state.pointerType);
        addGlobalListener(window, "scroll", onScroll, true);
      };
      pressProps.onTouchMove = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        if (!state.isPressed)
          return;
        let touch = $f6c31cce2adf654f$var$getTouchById(e2.nativeEvent, state.activePointerId);
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e2.currentTarget)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart(e2, state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd(e2, state.pointerType, false);
          if (propsRef.current.shouldCancelOnPointerExit)
            cancel(e2);
        }
      };
      pressProps.onTouchEnd = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        if (!state.isPressed)
          return;
        let touch = $f6c31cce2adf654f$var$getTouchById(e2.nativeEvent, state.activePointerId);
        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e2.currentTarget)) {
          triggerPressUp(e2, state.pointerType);
          triggerPressEnd(e2, state.pointerType);
        } else if (state.isOverTarget)
          triggerPressEnd(e2, state.pointerType, false);
        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (!allowTextSelectionOnPress)
          $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        removeAllGlobalListeners();
      };
      pressProps.onTouchCancel = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        e2.stopPropagation();
        if (state.isPressed)
          cancel(e2);
      };
      let onScroll = (e2) => {
        if (state.isPressed && e2.target.contains(state.target))
          cancel({
            currentTarget: state.target,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false,
            altKey: false
          });
      };
      pressProps.onDragStart = (e2) => {
        if (!e2.currentTarget.contains(e2.target))
          return;
        cancel(e2);
      };
    }
    return pressProps;
  }, [
    addGlobalListener,
    isDisabled1,
    preventFocusOnPress,
    removeAllGlobalListeners,
    allowTextSelectionOnPress
  ]);
  useEffect(() => {
    return () => {
      if (!allowTextSelectionOnPress)
        $14c0b72509d70225$export$b0d6fa1ab32e3295(ref.current.target);
    };
  }, [
    allowTextSelectionOnPress
  ]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, pressProps1)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
  return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
  const { key, code } = event;
  const element = currentTarget;
  const role = element.getAttribute("role");
  return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof HTMLTextAreaElement || element.isContentEditable) && (!$f6c31cce2adf654f$var$isHTMLAnchorLink(element) || role === "button" && key !== "Enter") && !(role === "link" && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
  const { targetTouches } = event;
  if (targetTouches.length > 0)
    return targetTouches[0];
  return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
  const changedTouches = event.changedTouches;
  for (let i2 = 0; i2 < changedTouches.length; i2++) {
    const touch = changedTouches[i2];
    if (touch.identifier === pointerId)
      return touch;
  }
  return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e2) {
  return {
    currentTarget: target,
    shiftKey: e2.shiftKey,
    ctrlKey: e2.ctrlKey,
    metaKey: e2.metaKey,
    altKey: e2.altKey
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
  let offsetX = point.width / 2 || point.radiusX || 0;
  let offsetY = point.height / 2 || point.radiusY || 0;
  return {
    top: point.clientY - offsetY,
    right: point.clientX + offsetX,
    bottom: point.clientY + offsetY,
    left: point.clientX - offsetX
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a2, b2) {
  if (a2.left > b2.right || b2.left > a2.right)
    return false;
  if (a2.top > b2.bottom || b2.top > a2.bottom)
    return false;
  return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
  let rect = target.getBoundingClientRect();
  let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
  return !(target instanceof HTMLElement) || !target.draggable;
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
  if (target instanceof HTMLInputElement)
    return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
  if (target instanceof HTMLButtonElement)
    return target.type !== "submit";
  return true;
}
const $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
  return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.isPropagationStopped = () => true;
  }
  isPropagationStopped() {
    return false;
  }
  persist() {
  }
  constructor(type, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = useRef({
    isFocused: false,
    onBlur,
    observer: null
  });
  stateRef.current.onBlur = onBlur;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  return useCallback((e1) => {
    if (e1.target instanceof HTMLButtonElement || e1.target instanceof HTMLInputElement || e1.target instanceof HTMLTextAreaElement || e1.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e1.target;
      let onBlurHandler = (e2) => {
        var _current, ref;
        stateRef.current.isFocused = false;
        if (target.disabled)
          (ref = (_current = stateRef.current).onBlur) === null || ref === void 0 ? void 0 : ref.call(_current, new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e2));
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          stateRef.current.observer.disconnect();
          target.dispatchEvent(new FocusEvent("blur"));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, []);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  let { isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange } = props;
  const onBlur = useCallback((e2) => {
    if (e2.target === e2.currentTarget) {
      if (onBlurProp)
        onBlurProp(e2);
      if (onFocusChange)
        onFocusChange(false);
      return true;
    }
  }, [
    onBlurProp,
    onFocusChange
  ]);
  const onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  const onFocus = useCallback((e2) => {
    if (e2.target === e2.currentTarget) {
      if (onFocusProp)
        onFocusProp(e2);
      if (onFocusChange)
        onFocusChange(true);
      onSyntheticFocus(e2);
    }
  }, [
    onFocusChange,
    onFocusProp,
    onSyntheticFocus
  ]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : void 0,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : null
    }
  };
}
let $507fabe10e71c6fb$var$currentModality = null;
let $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set();
let $507fabe10e71c6fb$var$hasSetupGlobalListeners = false;
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e2) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers)
    handler(modality, e2);
}
function $507fabe10e71c6fb$var$isValidKey(e2) {
  return !(e2.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e2.altKey || e2.ctrlKey || e2.key === "Control" || e2.key === "Shift" || e2.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e2) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if ($507fabe10e71c6fb$var$isValidKey(e2)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e2);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e2) {
  $507fabe10e71c6fb$var$currentModality = "pointer";
  if (e2.type === "mousedown" || e2.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e2);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e2) {
  if ($6a7db85432448f7f$export$60278871457622de(e2)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e2) {
  if (e2.target === window || e2.target === document)
    return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e2);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents() {
  if (typeof window === "undefined" || $507fabe10e71c6fb$var$hasSetupGlobalListeners)
    return;
  let focus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  document.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  document.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  window.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  window.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    document.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    document.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$var$hasSetupGlobalListeners = true;
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading")
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  else
    document.addEventListener("DOMContentLoaded", $507fabe10e71c6fb$var$setupGlobalFocusEvents);
}
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e2) {
  return !(isTextInput && modality === "keyboard" && e2 instanceof KeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e2.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  useEffect(() => {
    let handler = (modality, e2) => {
      if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(opts === null || opts === void 0 ? void 0 : opts.isTextInput, modality, e2))
        return;
      fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    $507fabe10e71c6fb$var$changeHandlers.add(handler);
    return () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(handler);
    };
  }, deps);
}
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
  let state = useRef({
    isFocusWithin: false
  });
  let onBlur = useCallback((e2) => {
    if (state.current.isFocusWithin && !e2.currentTarget.contains(e2.relatedTarget)) {
      state.current.isFocusWithin = false;
      if (onBlurWithin)
        onBlurWithin(e2);
      if (onFocusWithinChange)
        onFocusWithinChange(false);
    }
  }, [
    onBlurWithin,
    onFocusWithinChange,
    state
  ]);
  let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  let onFocus = useCallback((e2) => {
    if (!state.current.isFocusWithin) {
      if (onFocusWithin)
        onFocusWithin(e2);
      if (onFocusWithinChange)
        onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e2);
    }
  }, [
    onFocusWithin,
    onFocusWithinChange,
    onSyntheticFocus
  ]);
  if (isDisabled)
    return {
      focusWithinProps: {
        onFocus: null,
        onBlur: null
      }
    };
  return {
    focusWithinProps: {
      onFocus,
      onBlur
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
  setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e2) {
  if (e2.pointerType === "touch")
    $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === "undefined")
    return;
  if (typeof PointerEvent !== "undefined")
    document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
  else
    document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return () => {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0)
      return;
    if (typeof PointerEvent !== "undefined")
      document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else
      document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  let { onHoverStart, onHoverChange, onHoverEnd, isDisabled } = props;
  let [isHovered, setHovered] = useState(false);
  let state = useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { hoverProps: hoverProps1, triggerHoverEnd: triggerHoverEnd1 } = useMemo(() => {
    let triggerHoverStart = (event, pointerType) => {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target))
        return;
      state.isHovered = true;
      let target = event.currentTarget;
      state.target = target;
      if (onHoverStart)
        onHoverStart({
          type: "hoverstart",
          target,
          pointerType
        });
      if (onHoverChange)
        onHoverChange(true);
      setHovered(true);
    };
    let triggerHoverEnd = (event, pointerType) => {
      state.pointerType = "";
      state.target = null;
      if (pointerType === "touch" || !state.isHovered)
        return;
      state.isHovered = false;
      let target = event.currentTarget;
      if (onHoverEnd)
        onHoverEnd({
          type: "hoverend",
          target,
          pointerType
        });
      if (onHoverChange)
        onHoverChange(false);
      setHovered(false);
    };
    let hoverProps = {};
    if (typeof PointerEvent !== "undefined") {
      hoverProps.onPointerEnter = (e2) => {
        if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e2.pointerType === "mouse")
          return;
        triggerHoverStart(e2, e2.pointerType);
      };
      hoverProps.onPointerLeave = (e2) => {
        if (!isDisabled && e2.currentTarget.contains(e2.target))
          triggerHoverEnd(e2, e2.pointerType);
      };
    } else {
      hoverProps.onTouchStart = () => {
        state.ignoreEmulatedMouseEvents = true;
      };
      hoverProps.onMouseEnter = (e2) => {
        if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents)
          triggerHoverStart(e2, "mouse");
        state.ignoreEmulatedMouseEvents = false;
      };
      hoverProps.onMouseLeave = (e2) => {
        if (!isDisabled && e2.currentTarget.contains(e2.target))
          triggerHoverEnd(e2, "mouse");
      };
    }
    return {
      hoverProps,
      triggerHoverEnd
    };
  }, [
    onHoverStart,
    onHoverChange,
    onHoverEnd,
    isDisabled,
    state
  ]);
  useEffect(() => {
    if (isDisabled)
      triggerHoverEnd1({
        currentTarget: state.target
      }, state.pointerType);
  }, [
    isDisabled
  ]);
  return {
    hoverProps: hoverProps1,
    isHovered
  };
}
function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler)
    return;
  let shouldStopPropagation = true;
  return (e2) => {
    let event = {
      ...e2,
      preventDefault() {
        e2.preventDefault();
      },
      isDefaultPrevented() {
        return e2.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        shouldStopPropagation = false;
      }
    };
    handler(event);
    if (shouldStopPropagation)
      e2.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
    }
  };
}
function $6a99195332edec8b$export$80f3e147d781571c(element) {
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let lastFocusedElement = document.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      if (document.activeElement === lastFocusedElement && document.contains(element))
        $7215afc6de606d6b$export$de79e2c695e052f3(element);
    });
  } else
    $7215afc6de606d6b$export$de79e2c695e052f3(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  return scope.some(
    (node) => node.contains(element)
  );
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(data) {
    return this.fastMap.get(data);
  }
  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    let node = new $9bf71ea28793e738$var$TreeNode({
      scopeRef
    });
    parentNode.addChild(node);
    node.parent = parentNode;
    this.fastMap.set(scopeRef, node);
    if (nodeToRestore)
      node.nodeToRestore = nodeToRestore;
  }
  removeTreeNode(scopeRef) {
    if (scopeRef === null)
      return;
    let node = this.fastMap.get(scopeRef);
    let parentNode = node.parent;
    for (let current of this.traverse())
      if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current))
        current.nodeToRestore = node.nodeToRestore;
    let children = node.children;
    parentNode.removeChild(node);
    if (children.length > 0)
      children.forEach(
        (child) => parentNode.addChild(child)
      );
    this.fastMap.delete(node.scopeRef);
  }
  *traverse(node = this.root) {
    if (node.scopeRef != null)
      yield node;
    if (node.children.length > 0)
      for (let child of node.children)
        yield* this.traverse(child);
  }
  clone() {
    let newTree = new $9bf71ea28793e738$var$Tree();
    for (let node of this.traverse())
      newTree.addTreeNode(node.scopeRef, node.parent.scopeRef, node.nodeToRestore);
    return newTree;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(node) {
    this.children.push(node);
    node.parent = this;
  }
  removeChild(node) {
    this.children.splice(this.children.indexOf(node), 1);
    node.parent = void 0;
  }
  constructor(props) {
    this.children = [];
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
}
new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
  let { autoFocus = false, isTextInput, within } = props;
  let state = useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused1, setFocused] = useState(false);
  let [isFocusVisibleState, setFocusVisible] = useState(
    () => state.current.isFocused && state.current.isFocusVisible
  );
  let updateState = useCallback(
    () => setFocusVisible(state.current.isFocused && state.current.isFocusVisible),
    []
  );
  let onFocusChange = useCallback((isFocused) => {
    state.current.isFocused = isFocused;
    setFocused(isFocused);
    updateState();
  }, [
    updateState
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible) => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused: isFocused1,
    isFocusVisible: state.current.isFocused && isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
let $e6afbd83fe6ebbd2$var$FocusableContext = /* @__PURE__ */ t__default.createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
  let context = useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);
  let { ref: _, ...otherProps } = context;
  return otherProps;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
  let { focusProps } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props);
  let { keyboardProps } = $46d819fcbaf35654$export$8f71654801c2f7cd(props);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
  let domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
  let interactionProps = props.isDisabled ? {} : domProps;
  let autoFocusRef = useRef(props.autoFocus);
  useEffect(() => {
    if (autoFocusRef.current && domRef.current)
      $6a99195332edec8b$export$80f3e147d781571c(domRef.current);
    autoFocusRef.current = false;
  }, [
    domRef
  ]);
  return {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
      ...interactions,
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : void 0
    }, interactionProps)
  };
}
function $298d61e98472621b$export$dcf14c9974fe2767(props, ref) {
  let {
    elementType = "a",
    onPress,
    onPressStart,
    onPressEnd,
    onClick: deprecatedOnClick,
    isDisabled,
    ...otherProps
  } = props;
  let linkProps;
  if (elementType !== "a")
    linkProps = {
      role: "link",
      tabIndex: !isDisabled ? 0 : void 0
    };
  let { focusableProps } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPress,
    onPressStart,
    onPressEnd,
    isDisabled,
    ref
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps, {
    labelable: true
  });
  let interactionHandlers = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps);
  return {
    isPressed,
    linkProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      ...interactionHandlers,
      ...linkProps,
      "aria-disabled": isDisabled || void 0,
      onClick: (e2) => {
        pressProps.onClick(e2);
        if (deprecatedOnClick) {
          deprecatedOnClick(e2);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}
class $5b160d28a433310d$export$c17fa47878dc55b6 {
  getStringForLocale(key, locale) {
    let strings = this.strings[locale];
    if (!strings) {
      strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
      this.strings[locale] = strings;
    }
    let string = strings[key];
    if (!string)
      throw new Error(`Could not find intl message ${key} in ${locale} locale`);
    return string;
  }
  constructor(messages, defaultLocale = "en-US") {
    this.strings = {
      ...messages
    };
    this.defaultLocale = defaultLocale;
  }
}
function $5b160d28a433310d$var$getStringsForLocale(locale, strings, defaultLocale = "en-US") {
  if (strings[locale])
    return strings[locale];
  let language = $5b160d28a433310d$var$getLanguage(locale);
  if (strings[language])
    return strings[language];
  for (let key in strings) {
    if (key.startsWith(language + "-"))
      return strings[key];
  }
  return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
  if (Intl.Locale)
    return new Intl.Locale(locale).language;
  return locale.split("-")[0];
}
const $6db58dc88e78b024$var$pluralRulesCache = /* @__PURE__ */ new Map();
const $6db58dc88e78b024$var$numberFormatCache = /* @__PURE__ */ new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
  format(key, variables) {
    let message = this.strings.getStringForLocale(key, this.locale);
    return typeof message === "function" ? message(variables, this) : message;
  }
  plural(count, options, type = "cardinal") {
    let opt = options["=" + count];
    if (opt)
      return typeof opt === "function" ? opt() : opt;
    let key = this.locale + ":" + type;
    let pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
    if (!pluralRules) {
      pluralRules = new Intl.PluralRules(this.locale, {
        type
      });
      $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
    }
    let selected = pluralRules.select(count);
    opt = options[selected] || options.other;
    return typeof opt === "function" ? opt() : opt;
  }
  number(value) {
    let numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    if (!numberFormat) {
      numberFormat = new Intl.NumberFormat(this.locale);
      $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
    }
    return numberFormat.format(value);
  }
  select(options, value) {
    let opt = options[value] || options.other;
    return typeof opt === "function" ? opt() : opt;
  }
  constructor(locale, strings) {
    this.locale = locale;
    this.strings = strings;
  }
}
let $fb18d541ea1ad717$var$formatterCache = /* @__PURE__ */ new Map();
class $fb18d541ea1ad717$export$ad991b66133851cf {
  format(value) {
    return this.formatter.format(value);
  }
  formatToParts(value) {
    return this.formatter.formatToParts(value);
  }
  formatRange(start, end) {
    if (typeof this.formatter.formatRange === "function")
      return this.formatter.formatRange(start, end);
    if (end < start)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(start)} \u2013 ${this.formatter.format(end)}`;
  }
  formatRangeToParts(start, end) {
    if (typeof this.formatter.formatRangeToParts === "function")
      return this.formatter.formatRangeToParts(start, end);
    if (end < start)
      throw new RangeError("End date must be >= start date");
    let startParts = this.formatter.formatToParts(start);
    let endParts = this.formatter.formatToParts(end);
    return [
      ...startParts.map(
        (p2) => ({
          ...p2,
          source: "startRange"
        })
      ),
      {
        type: "literal",
        value: " \u2013 ",
        source: "shared"
      },
      ...endParts.map(
        (p2) => ({
          ...p2,
          source: "endRange"
        })
      )
    ];
  }
  resolvedOptions() {
    let resolvedOptions = this.formatter.resolvedOptions();
    if ($fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
      if (!this.resolvedHourCycle)
        this.resolvedHourCycle = $fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
      resolvedOptions.hourCycle = this.resolvedHourCycle;
      resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
    }
    if (resolvedOptions.calendar === "ethiopic-amete-alem")
      resolvedOptions.calendar = "ethioaa";
    return resolvedOptions;
  }
  constructor(locale, options = {}) {
    this.formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
    this.options = options;
  }
}
const $fb18d541ea1ad717$var$hour12Preferences = {
  true: {
    ja: "h11"
  },
  false: {}
};
function $fb18d541ea1ad717$var$getCachedDateFormatter(locale, options = {}) {
  if (typeof options.hour12 === "boolean" && $fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
    options = {
      ...options
    };
    let pref = $fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
    let defaultHourCycle = options.hour12 ? "h12" : "h23";
    options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
    delete options.hour12;
  }
  let cacheKey = locale + (options ? Object.entries(options).sort(
    (a2, b2) => a2[0] < b2[0] ? -1 : 1
  ).join() : "");
  if ($fb18d541ea1ad717$var$formatterCache.has(cacheKey))
    return $fb18d541ea1ad717$var$formatterCache.get(cacheKey);
  let numberFormatter = new Intl.DateTimeFormat(locale, options);
  $fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
  return numberFormatter;
}
let $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
  if ($fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null)
    $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
  return $fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
let $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
  if ($fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null)
    $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
      hour: "numeric",
      hour12: false
    }).resolvedOptions().hourCycle === "h12";
  return $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
  if (!options.timeStyle && !options.hour)
    return void 0;
  locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
  locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
  let formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, {
    ...options,
    timeZone: void 0
  });
  let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find(
    (p2) => p2.type === "hour"
  ).value, 10);
  let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find(
    (p2) => p2.type === "hour"
  ).value, 10);
  if (min === 0 && max === 23)
    return "h23";
  if (min === 24 && max === 23)
    return "h24";
  if (min === 0 && max === 11)
    return "h11";
  if (min === 12 && max === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
let $488c6ddbf4ef74c2$var$formatterCache = /* @__PURE__ */ new Map();
let $488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
  $488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch (e2) {
}
let $488c6ddbf4ef74c2$var$supportsUnit = false;
try {
  $488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch (e1) {
}
const $488c6ddbf4ef74c2$var$UNITS = {
  degree: {
    narrow: {
      default: "\xB0",
      "ja-JP": " \u5EA6",
      "zh-TW": "\u5EA6",
      "sl-SI": " \xB0"
    }
  }
};
class $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5 {
  format(value) {
    let res = "";
    if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null)
      res = $488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
    else
      res = this.numberFormatter.format(value);
    if (this.options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
      var ref;
      let { unit, unitDisplay = "short", locale } = this.resolvedOptions();
      let values = (ref = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay];
      res += values[locale] || values.default;
    }
    return res;
  }
  formatToParts(value) {
    return this.numberFormatter.formatToParts(value);
  }
  formatRange(start, end) {
    if (typeof this.numberFormatter.formatRange === "function")
      return this.numberFormatter.formatRange(start, end);
    if (end < start)
      throw new RangeError("End date must be >= start date");
    return `${this.format(start)} \u2013 ${this.format(end)}`;
  }
  formatRangeToParts(start, end) {
    if (typeof this.numberFormatter.formatRangeToParts === "function")
      return this.numberFormatter.formatRangeToParts(start, end);
    if (end < start)
      throw new RangeError("End date must be >= start date");
    let startParts = this.numberFormatter.formatToParts(start);
    let endParts = this.numberFormatter.formatToParts(end);
    return [
      ...startParts.map(
        (p2) => ({
          ...p2,
          source: "startRange"
        })
      ),
      {
        type: "literal",
        value: " \u2013 ",
        source: "shared"
      },
      ...endParts.map(
        (p2) => ({
          ...p2,
          source: "endRange"
        })
      )
    ];
  }
  resolvedOptions() {
    let options = this.numberFormatter.resolvedOptions();
    if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null)
      options = {
        ...options,
        signDisplay: this.options.signDisplay
      };
    if (!$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit")
      options = {
        ...options,
        style: "unit",
        unit: this.options.unit,
        unitDisplay: this.options.unitDisplay
      };
    return options;
  }
  constructor(locale, options = {}) {
    this.numberFormatter = $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
    this.options = options;
  }
}
function $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options = {}) {
  let { numberingSystem } = options;
  if (numberingSystem && locale.indexOf("-u-nu-") === -1)
    locale = `${locale}-u-nu-${numberingSystem}`;
  if (options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
    var ref;
    let { unit, unitDisplay = "short" } = options;
    if (!unit)
      throw new Error('unit option must be provided with style: "unit"');
    if (!((ref = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay]))
      throw new Error(`Unsupported unit ${unit} with unitDisplay = ${unitDisplay}`);
    options = {
      ...options,
      style: "decimal"
    };
  }
  let cacheKey = locale + (options ? Object.entries(options).sort(
    (a2, b2) => a2[0] < b2[0] ? -1 : 1
  ).join() : "");
  if ($488c6ddbf4ef74c2$var$formatterCache.has(cacheKey))
    return $488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
  let numberFormatter = new Intl.NumberFormat(locale, options);
  $488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
  return numberFormatter;
}
function $488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
  if (signDisplay === "auto")
    return numberFormat.format(num);
  else if (signDisplay === "never")
    return numberFormat.format(Math.abs(num));
  else {
    let needsPositiveSign = false;
    if (signDisplay === "always")
      needsPositiveSign = num > 0 || Object.is(num, 0);
    else if (signDisplay === "exceptZero") {
      if (Object.is(num, -0) || Object.is(num, 0))
        num = Math.abs(num);
      else
        needsPositiveSign = num > 0;
    }
    if (needsPositiveSign) {
      let negative = numberFormat.format(-num);
      let noSign = numberFormat.format(num);
      let minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
      if ([
        ...minus
      ].length !== 1)
        console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
      let positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
      return positive;
    } else
      return numberFormat.format(num);
  }
}
const $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]);
const $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(locale) {
  if (Intl.Locale) {
    let script = new Intl.Locale(locale).maximize().script;
    return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(script);
  }
  let lang = locale.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let locale = typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      locale
    ]);
  } catch (_err) {
    locale = "en-US";
  }
  return {
    locale,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
let $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let listener of $1e5a04cdaf7d1af8$var$listeners)
    listener($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let isSSR = $704cf1d3b684cc5c$export$535bd6ca7f90a273();
  let [defaultLocale, setDefaultLocale] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  useEffect(() => {
    if ($1e5a04cdaf7d1af8$var$listeners.size === 0)
      window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
    return () => {
      $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
      if ($1e5a04cdaf7d1af8$var$listeners.size === 0)
        window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    };
  }, []);
  if (isSSR)
    return {
      locale: "en-US",
      direction: "ltr"
    };
  return defaultLocale;
}
const $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ t__default.createContext(null);
function $18f2051aff69b9bf$export$a54013f0d02a8f82(props) {
  let { locale, children } = props;
  let defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  let value = locale ? {
    locale,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
  } : defaultLocale;
  return /* @__PURE__ */ t__default.createElement($18f2051aff69b9bf$var$I18nContext.Provider, {
    value
  }, children);
}
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  let context = useContext($18f2051aff69b9bf$var$I18nContext);
  return context || defaultLocale;
}
const $fca6afa0e843324b$var$cache = /* @__PURE__ */ new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
  let dictionary = $fca6afa0e843324b$var$cache.get(strings);
  if (!dictionary) {
    dictionary = new $5b160d28a433310d$export$c17fa47878dc55b6(strings);
    $fca6afa0e843324b$var$cache.set(strings, dictionary);
  }
  return dictionary;
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings) {
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let dictionary = useMemo(
    () => $fca6afa0e843324b$var$getCachedDictionary(strings),
    [
      strings
    ]
  );
  return useMemo(
    () => new $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale, dictionary),
    [
      locale,
      dictionary
    ]
  );
}
function $896ba0a80a8f4d36$export$85fd5fdf27bacc79(options) {
  let lastOptions = useRef(null);
  if (options && lastOptions.current && $896ba0a80a8f4d36$var$isEqual(options, lastOptions.current))
    options = lastOptions.current;
  lastOptions.current = options;
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  return useMemo(
    () => new $fb18d541ea1ad717$export$ad991b66133851cf(locale, options),
    [
      locale,
      options
    ]
  );
}
function $896ba0a80a8f4d36$var$isEqual(a2, b2) {
  if (a2 === b2)
    return true;
  let aKeys = Object.keys(a2);
  let bKeys = Object.keys(b2);
  if (aKeys.length !== bKeys.length)
    return false;
  for (let key of aKeys) {
    if (b2[key] !== a2[key])
      return false;
  }
  return true;
}
function $a916eb452884faea$export$b7a616150fdb9f44(options = {}) {
  let { locale } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  return useMemo(
    () => new $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(locale, options),
    [
      locale,
      options
    ]
  );
}
function $parcel$interopDefault(a2) {
  return a2 && a2.__esModule ? a2.default : a2;
}
function $dafd15390222438a$export$452b38fce62c9384(props, ref) {
  let { isCurrent, isDisabled, "aria-current": ariaCurrent, elementType = "a", ...otherProps } = props;
  let { linkProps } = $298d61e98472621b$export$dcf14c9974fe2767({
    isDisabled: isDisabled || isCurrent,
    elementType,
    ...otherProps
  }, ref);
  let isHeading = /^h[1-6]$/.test(elementType);
  let itemProps = {};
  if (!isHeading)
    itemProps = linkProps;
  if (isCurrent) {
    itemProps["aria-current"] = ariaCurrent || "page";
    itemProps.tabIndex = props.autoFocus ? -1 : void 0;
  }
  return {
    itemProps: {
      "aria-disabled": isDisabled,
      ...itemProps
    }
  };
}
var $28dc7e2f5ed40c80$exports = {};
var $b91590b2dc47de39$exports = {};
$b91590b2dc47de39$exports = {
  "breadcrumbs": `\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0648\u0627\u062C\u0647\u0629`
};
var $55b0693b2cf3fe91$exports = {};
$55b0693b2cf3fe91$exports = {
  "breadcrumbs": `\u0422\u0440\u043E\u0445\u0438 \u0445\u043B\u044F\u0431`
};
var $6ec1ed7729e948cc$exports = {};
$6ec1ed7729e948cc$exports = {
  "breadcrumbs": `Popis cesty`
};
var $5a41bb2baa6861e4$exports = {};
$5a41bb2baa6861e4$exports = {
  "breadcrumbs": `Br\xF8dkrummer`
};
var $f28bbea439e87eca$exports = {};
$f28bbea439e87eca$exports = {
  "breadcrumbs": `Breadcrumbs`
};
var $b3eca51cb720961a$exports = {};
$b3eca51cb720961a$exports = {
  "breadcrumbs": `\u03A0\u03BB\u03BF\u03B7\u03B3\u03AE\u03C3\u03B5\u03B9\u03C2 breadcrumb`
};
var $0b39b205118db415$exports = {};
$0b39b205118db415$exports = {
  "breadcrumbs": `Breadcrumbs`
};
var $f467c0ee7bfb0950$exports = {};
$f467c0ee7bfb0950$exports = {
  "breadcrumbs": `Migas de pan`
};
var $ab711d2ffb4cdf3d$exports = {};
$ab711d2ffb4cdf3d$exports = {
  "breadcrumbs": `Lingiread`
};
var $b63105d663e6f9d5$exports = {};
$b63105d663e6f9d5$exports = {
  "breadcrumbs": `Navigointilinkit`
};
var $9d2ed7be7fcdc2a1$exports = {};
$9d2ed7be7fcdc2a1$exports = {
  "breadcrumbs": `Chemin de navigation`
};
var $c5704294d85c7b5d$exports = {};
$c5704294d85c7b5d$exports = {
  "breadcrumbs": `\u05E9\u05D1\u05D9\u05DC\u05D9 \u05E0\u05D9\u05D5\u05D5\u05D8`
};
var $20c975671d6bbc63$exports = {};
$20c975671d6bbc63$exports = {
  "breadcrumbs": `Navigacijski putovi`
};
var $2569ca3917233115$exports = {};
$2569ca3917233115$exports = {
  "breadcrumbs": `Morzsamen\xFC`
};
var $caa152f7f8e96c85$exports = {};
$caa152f7f8e96c85$exports = {
  "breadcrumbs": `Breadcrumb`
};
var $cbc6af0cc98fad10$exports = {};
$cbc6af0cc98fad10$exports = {
  "breadcrumbs": `\u30D1\u30F3\u304F\u305A\u30EA\u30B9\u30C8`
};
var $ad9be5d332b4d607$exports = {};
$ad9be5d332b4d607$exports = {
  "breadcrumbs": `\uD0D0\uC0C9 \uD45C\uC2DC`
};
var $659de19a00ff9617$exports = {};
$659de19a00ff9617$exports = {
  "breadcrumbs": `Nar\u0161ymo kelias`
};
var $173e9fb4d14fe309$exports = {};
$173e9fb4d14fe309$exports = {
  "breadcrumbs": `Atpaka\u013Cce\u013Ci`
};
var $d8e2640a066567a9$exports = {};
$d8e2640a066567a9$exports = {
  "breadcrumbs": `Navigasjonsstier`
};
var $d71fd764236c0d12$exports = {};
$d71fd764236c0d12$exports = {
  "breadcrumbs": `Broodkruimels`
};
var $f4ad3faf9f4aaec6$exports = {};
$f4ad3faf9f4aaec6$exports = {
  "breadcrumbs": `Struktura nawigacyjna`
};
var $9703be9d55d8e9c2$exports = {};
$9703be9d55d8e9c2$exports = {
  "breadcrumbs": `Caminho detalhado`
};
var $7e23baec8a14f309$exports = {};
$7e23baec8a14f309$exports = {
  "breadcrumbs": `Categorias`
};
var $568f95594049d56e$exports = {};
$568f95594049d56e$exports = {
  "breadcrumbs": `Miez de p\xE2ine`
};
var $625df06cecc70764$exports = {};
$625df06cecc70764$exports = {
  "breadcrumbs": `\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F`
};
var $b5a67525f3a2f594$exports = {};
$b5a67525f3a2f594$exports = {
  "breadcrumbs": `Naviga\u010Dn\xE9 prvky Breadcrumbs`
};
var $16125922964febca$exports = {};
$16125922964febca$exports = {
  "breadcrumbs": `Drobtine`
};
var $de104bf355206bcf$exports = {};
$de104bf355206bcf$exports = {
  "breadcrumbs": `Putanje navigacije`
};
var $d5ab76bcbadc9c07$exports = {};
$d5ab76bcbadc9c07$exports = {
  "breadcrumbs": `S\xF6kv\xE4gar`
};
var $a6a1af5968159b55$exports = {};
$a6a1af5968159b55$exports = {
  "breadcrumbs": `\u0130\xE7erik haritalar\u0131`
};
var $5204a30f0d17ffec$exports = {};
$5204a30f0d17ffec$exports = {
  "breadcrumbs": `\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0430 \u0441\u0442\u0435\u0436\u043A\u0430`
};
var $8d15e736e12d3dfd$exports = {};
$8d15e736e12d3dfd$exports = {
  "breadcrumbs": `\u5BFC\u822A\u680F`
};
var $f8c49dd804b75140$exports = {};
$f8c49dd804b75140$exports = {
  "breadcrumbs": `\u5C0E\u89BD\u5217`
};
$28dc7e2f5ed40c80$exports = {
  "ar-AE": $b91590b2dc47de39$exports,
  "bg-BG": $55b0693b2cf3fe91$exports,
  "cs-CZ": $6ec1ed7729e948cc$exports,
  "da-DK": $5a41bb2baa6861e4$exports,
  "de-DE": $f28bbea439e87eca$exports,
  "el-GR": $b3eca51cb720961a$exports,
  "en-US": $0b39b205118db415$exports,
  "es-ES": $f467c0ee7bfb0950$exports,
  "et-EE": $ab711d2ffb4cdf3d$exports,
  "fi-FI": $b63105d663e6f9d5$exports,
  "fr-FR": $9d2ed7be7fcdc2a1$exports,
  "he-IL": $c5704294d85c7b5d$exports,
  "hr-HR": $20c975671d6bbc63$exports,
  "hu-HU": $2569ca3917233115$exports,
  "it-IT": $caa152f7f8e96c85$exports,
  "ja-JP": $cbc6af0cc98fad10$exports,
  "ko-KR": $ad9be5d332b4d607$exports,
  "lt-LT": $659de19a00ff9617$exports,
  "lv-LV": $173e9fb4d14fe309$exports,
  "nb-NO": $d8e2640a066567a9$exports,
  "nl-NL": $d71fd764236c0d12$exports,
  "pl-PL": $f4ad3faf9f4aaec6$exports,
  "pt-BR": $9703be9d55d8e9c2$exports,
  "pt-PT": $7e23baec8a14f309$exports,
  "ro-RO": $568f95594049d56e$exports,
  "ru-RU": $625df06cecc70764$exports,
  "sk-SK": $b5a67525f3a2f594$exports,
  "sl-SI": $16125922964febca$exports,
  "sr-SP": $de104bf355206bcf$exports,
  "sv-SE": $d5ab76bcbadc9c07$exports,
  "tr-TR": $a6a1af5968159b55$exports,
  "uk-UA": $5204a30f0d17ffec$exports,
  "zh-CN": $8d15e736e12d3dfd$exports,
  "zh-TW": $f8c49dd804b75140$exports
};
function $848231d7a2b3998e$export$8cefe241bd876ca0(props) {
  let { "aria-label": ariaLabel, ...otherProps } = props;
  let strings = $fca6afa0e843324b$export$f12b703ca79dfbb1(/* @__PURE__ */ $parcel$interopDefault($28dc7e2f5ed40c80$exports));
  return {
    navProps: {
      ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps, {
        labelable: true
      }),
      "aria-label": ariaLabel || strings.format("breadcrumbs")
    }
  };
}
function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  let {
    elementType = "button",
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressChange,
    preventFocusOnPress,
    allowFocusWhenDisabled,
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = "button"
  } = props;
  let additionalProps;
  if (elementType === "button")
    additionalProps = {
      type,
      disabled: isDisabled
    };
  else
    additionalProps = {
      role: "button",
      tabIndex: isDisabled ? void 0 : 0,
      href: elementType === "a" && isDisabled ? void 0 : href,
      target: elementType === "a" ? target : void 0,
      type: elementType === "input" ? type : void 0,
      disabled: elementType === "input" ? isDisabled : void 0,
      "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
      rel: elementType === "a" ? rel : void 0
    };
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  let { focusableProps } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
  if (allowFocusWhenDisabled)
    focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  let buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  }));
  return {
    isPressed,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      onClick: (e2) => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e2);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}
const reset$d = css({
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility",
  boxSizing: "border-box",
  position: "relative"
});
const breadcrumbs = css({
  listStyle: "none"
});
const Breadcrumbs = forwardRef(function Breadcrumbs2(props, ref) {
  let {
    navProps
  } = $848231d7a2b3998e$export$8cefe241bd876ca0(props);
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let children = Children.toArray(props.children);
  navProps = $3ef42575df84b30b$export$9d1611c77c2fe928(otherProps, navProps);
  return /* @__PURE__ */ jsx("nav", {
    ...navProps,
    className: compose(css(reset$d), css(styleProps)),
    ref,
    children: /* @__PURE__ */ jsx(Inline, {
      gap: "$space100",
      alignItems: "center",
      asChild: true,
      children: /* @__PURE__ */ jsx("ol", {
        className: compose(css(breadcrumbs)),
        children: children.map((child, i2) => {
          if (isValidElement(child)) {
            return cloneElement(child, {
              isCurrent: i2 === children.length - 1
            });
          }
        })
      })
    })
  });
});
const BreadcrumbItem = forwardRef(function BreadcrumbItem2(props, ref) {
  let {
    children,
    isCurrent
  } = props;
  ref = ref || useRef(null);
  let {
    itemProps
  } = $dafd15390222438a$export$452b38fce62c9384({
    ...props,
    elementType: "a"
  }, ref);
  return /* @__PURE__ */ jsx(Inline, {
    asChild: true,
    gap: "$space100",
    alignItems: "center",
    children: /* @__PURE__ */ jsxs("li", {
      children: [/* @__PURE__ */ jsx(Text2, {
        size: "small",
        fontWeight: "$normal",
        children: /* @__PURE__ */ jsx(Link, {
          ...itemProps,
          kind: "primary",
          emphasis: "quiet",
          isDisabled: isCurrent,
          ref,
          children
        })
      }), !isCurrent && /* @__PURE__ */ jsx(Text2, {
        size: "small",
        color: "$muted",
        children: /* @__PURE__ */ jsx(Icons.ChevronRight, {
          width: "1em"
        })
      })]
    })
  });
});
const reset$c = {
  appearance: "none",
  boxSizing: "border-box",
  cursor: "pointer",
  outline: "none",
  position: "relative",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  touchAction: "none",
  verticalAlign: "top",
  transition: "$transition150"
};
const button = {
  $$buttonBorderRadius: "6px",
  $$buttonBorderWidth: "2px",
  $$buttonGap: "8px",
  gap: "$$buttonGap",
  borderWidth: "$$buttonBorderWidth",
  borderStyle: "solid",
  borderRadius: "$$buttonBorderRadius",
  fontFamily: "$primary"
};
const variants$9 = css({
  backgroundColor: "$$buttonBackgroundColor !important",
  borderColor: "$$buttonBorderColor !important",
  color: "$$buttonTextColor ! important",
  height: "$$buttonHeight",
  paddingLeft: "$$buttonPaddingX",
  paddingRight: "$$buttonPaddingX",
  fontSize: "$$buttonFontSize",
  fontWeight: "$$buttonFontWeight",
  lineHeight: "$$buttonLineHeight",
  variants: {
    kind: {
      accent: {},
      critical: {}
    },
    emphasis: {
      filled: {},
      outlined: {},
      quiet: {}
    },
    size: {
      xsmall: {
        $$buttonFontSize: "11px",
        $$buttonFontWeight: "700",
        $$buttonHeight: "24px",
        $$buttonLineHeight: "14px",
        $$buttonPaddingX: "8px"
      },
      small: {
        $$buttonFontSize: "12px",
        $$buttonFontWeight: "700",
        $$buttonHeight: "32px",
        $$buttonLineHeight: "16px",
        $$buttonPaddingX: "16px"
      },
      medium: {
        $$buttonFontSize: "14px",
        $$buttonFontWeight: "700",
        $$buttonHeight: "44px",
        $$buttonLineHeight: "20px",
        $$buttonPaddingX: "18px"
      },
      large: {
        $$buttonFontSize: "16px",
        $$buttonFontWeight: "700",
        $$buttonHeight: "56px",
        $$buttonLineHeight: "24px",
        $$buttonPaddingX: "18px"
      }
    },
    isHovered: {
      true: {
        backgroundColor: "$$buttonBackgroundColorHover",
        borderColor: "$$buttonBorderColorHover"
      }
    },
    isPressed: {
      true: {
        backgroundColor: "$$buttonBackgroundColorPressed",
        borderColor: "$$buttonBorderColorPressed"
      }
    },
    isDisabled: {
      true: {
        backgroundColor: "$body !important",
        borderColor: "$body !important",
        color: "$bodyDark2 ! important",
        cursor: "auto"
      }
    },
    isFocused: {
      true: {
        $$buttonOutlineWidth: "2px",
        $$buttonOutlineOffset: "2px",
        outlineStyle: "solid",
        outlineWidth: "$$buttonOutlineWidth",
        outlineOffset: "$$buttonOutlineOffset",
        outlineColor: "$$buttonOutlineColor"
      }
    }
  },
  compoundVariants: [
    {
      kind: "accent",
      emphasis: "filled",
      css: {
        $$buttonBackgroundColor: "$colors-accent",
        $$buttonBorderColor: "$colors-accent",
        $$buttonTextColor: "$colors-white",
        $$buttonOutlineColor: "$colors-accent",
        $$buttonBackgroundColorHover: "$colors-accentHover",
        $$buttonBackgroundColorPressed: "$colors-accentPressed",
        $$buttonBorderColorHover: "$colors-accentHover",
        $$buttonBorderColorPressed: "$colors-accentPressed"
      }
    },
    {
      kind: "accent",
      emphasis: "outlined",
      css: {
        $$buttonBackgroundColor: "$colors-white",
        $$buttonBorderColor: "$colors-accent",
        $$buttonTextColor: "$colors-accent",
        $$buttonOutlineColor: "$colors-accent",
        $$buttonBackgroundColorHover: "$colors-accentBackgroundSecondary",
        $$buttonBackgroundColorPressed: "$colors-accentBackground",
        $$buttonBorderColorHover: "$colors-accent",
        $$buttonBorderColorPressed: "$colors-accent"
      }
    },
    {
      kind: "accent",
      emphasis: "quiet",
      css: {
        $$buttonBackgroundColor: "$colors-transparent",
        $$buttonBorderColor: "$colors-transparent",
        $$buttonTextColor: "$colors-accent",
        $buttonOutlineColor: "$colors-accent",
        $$buttonBackgroundColorHover: "$colors-accentBackgroundSecondary",
        $$buttonBackgroundColorPressed: "$colors-accentBackground",
        $$buttonBorderColorHover: "$colors-transparent",
        $$buttonBorderColorPressed: "$colors-transparent"
      }
    },
    {
      kind: "critical",
      emphasis: "filled",
      css: {
        $$buttonBackgroundColor: "$colors-critical",
        $$buttonBorderColor: "$colors-critical",
        $$buttonTextColor: "$colors-white",
        $$buttonOutlineColor: "$colors-critical",
        $$buttonBackgroundColorHover: "$colors-criticalHover",
        $$buttonBackgroundColorPressed: "$colors-criticalPressed",
        $$buttonBorderColorHover: "$colors-criticalHover",
        $$buttonBorderColorPressed: "$colors-criticalPressed"
      }
    },
    {
      kind: "critical",
      emphasis: "outlined",
      css: {
        $$buttonBackgroundColor: "$colors-white",
        $$buttonBorderColor: "$colors-critical",
        $$buttonTextColor: "$colors-critical",
        $$buttonOutlineColor: "$colors-critical",
        $$buttonBackgroundColorHover: "$colors-criticalBackgroundPressed",
        $$buttonBackgroundColorPressed: "$colors-criticalBackgroundHover",
        $$buttonBorderColorHover: "$colors-critical",
        $$buttonBorderColorPressed: "$colors-critical"
      }
    },
    {
      kind: "critical",
      emphasis: "quiet",
      css: {
        $$buttonBackgroundColor: "$colors-transparent",
        $$buttonBorderColor: "$colors-transparent",
        $$buttonTextColor: "$colors-critical",
        $buttonOutlineColor: "$colors-critical",
        $$buttonBackgroundColorHover: "$colors-criticalBackgroundPressed",
        $$buttonBackgroundColorPressed: "$colors-criticalBackgroundHover",
        $$buttonBorderColorHover: "$colors-transparent",
        $$buttonBorderColorPressed: "$colors-transparent"
      }
    }
  ],
  defaultVariants: {
    kind: "accent",
    emphasis: "outlined"
  }
});
const IconContext = createContext({});
const ButtonContext = createContext({});
function ButtonIconProvider(props) {
  let {
    children,
    size,
    ...value
  } = props;
  let height;
  let width;
  switch (size) {
    case "xsmall":
      height = "$size150";
      width = "$size150";
      break;
    case "small":
      height = "$size200";
      width = "$size200";
      break;
    case "medium":
      height = "$size250";
      width = "$size250";
      break;
    case "large":
      height = "$size300";
      width = "$size300";
      break;
  }
  value = {
    ...value,
    height,
    width
  };
  return /* @__PURE__ */ jsx(IconContext.Provider, {
    value,
    children
  });
}
const Button = forwardRef((props, ref) => {
  let contextProps = useContextProps(ButtonContext, props);
  let {
    buttonRef = null,
    children,
    emphasis,
    isDisabled,
    kind = "accent",
    size = "medium"
  } = contextProps;
  ref = $5dc95899b306f630$export$c9058316764c140e(buttonRef, ref) || useRef(null);
  let {
    buttonProps,
    isPressed
  } = $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref);
  let {
    styleProps
  } = useStyleProps(props);
  let {
    hoverProps,
    isHovered
  } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled
  });
  let {
    focusProps,
    isFocusVisible
  } = $f7dceffc5ad7768b$export$4e328f61c538687f(props);
  buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, hoverProps, focusProps);
  return /* @__PURE__ */ jsx("button", {
    ...buttonProps,
    className: compose(css(reset$c, button), variants$9({
      emphasis,
      kind,
      size,
      isDisabled,
      isFocused: isFocusVisible,
      isHovered,
      isPressed
    }), css(styleProps)),
    ref,
    children: /* @__PURE__ */ jsx(ButtonIconProvider, {
      size,
      children
    })
  });
});
const reset$b = {
  boxSizing: "border-box",
  margin: 0,
  position: "relative"
};
const base$c = {
  backgroundColor: "$white",
  borderRadius: "8px",
  padding: "$space300",
  boxShadow: "$medium"
};
const Card = forwardRef(function Card2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children
  } = props;
  let ElementType = asChild ? Slot$2 : "div";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css(reset$b, base$c, styleProps)(),
    ref,
    children
  });
});
function CurrencyFormatter(props) {
  let {
    value,
    minimumFractionDigits,
    maximumFractionDigits,
    currency = "AUD"
  } = props;
  let options = value === 0 ? {
    minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : 0,
    maximumFractionDigits: maximumFractionDigits != null ? maximumFractionDigits : 0
  } : {
    minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : 2,
    maximumFractionDigits: maximumFractionDigits != null ? maximumFractionDigits : 2
  };
  let formatter = $a916eb452884faea$export$b7a616150fdb9f44({
    style: "currency",
    currency,
    ...options,
    ...props
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatter.format(value)
  });
}
const useDateFormatter = $896ba0a80a8f4d36$export$85fd5fdf27bacc79;
const DateFormatter = function DateTimeFormatter(props) {
  let {
    value,
    kind = "calendar"
  } = props;
  let options = {
    display: {
      day: "numeric",
      month: "short",
      year: "numeric"
    },
    calendar: {
      day: "numeric",
      month: "numeric",
      year: "numeric"
    }
  };
  let formatter = useDateFormatter(options[kind]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatter.format(value)
  });
};
const reset$a = {
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility"
};
const base$b = te({
  display: "inline-flex",
  alignItems: "center",
  gap: "$size75"
});
const fieldLabel = te({
  display: "inline-flex",
  alignItems: "flex-start",
  fontFamily: "$primary",
  fontSize: "$font75",
  lineHeight: "$leading300",
  color: "$black",
  fontWeight: "$bold",
  columnGap: "$xxsmall"
});
const optional = te({
  fontFamily: "$primary",
  fontSize: "$font50",
  lineHeight: "$leading300",
  fontWeight: "$normal",
  color: "$muted"
});
const FieldLabel = forwardRef(function FieldLabel2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    children,
    isRequired
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: css(reset$a, base$b, styleProps)(),
    children: /* @__PURE__ */ jsxs("label", {
      ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
      ref,
      className: css(reset$a, fieldLabel)(),
      children: [children, !isRequired && /* @__PURE__ */ jsx(Optional, {})]
    })
  });
});
function Optional() {
  return /* @__PURE__ */ jsx("span", {
    className: css(reset$a, optional)(),
    children: "(optional)"
  });
}
const reset$9 = {
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility"
};
const base$a = te({
  fontSize: "$small",
  lineHeight: "$small",
  fontFamily: "$primary",
  display: "inline-flex",
  alignItems: "center",
  columnGap: "$space50"
});
const variants$8 = te({
  color: "$$messageColor",
  variants: {
    tone: {
      neutral: {
        $$messageColor: "$colors-muted"
      },
      critical: {
        $$messageColor: "$colors-critical"
      },
      positive: {
        $$messageColor: "$colors-positive"
      }
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
const FieldMessage = forwardRef(function FieldMessage2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    children,
    tone
  } = props;
  return /* @__PURE__ */ jsxs("span", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$9, base$a, styleProps), variants$8({
      tone
    })),
    ref,
    children: [{
      neutral: null,
      critical: /* @__PURE__ */ jsx(Icons.Critical, {
        width: "$medium",
        height: "$medium"
      }),
      positive: /* @__PURE__ */ jsx(Icons.Positive, {
        width: "$medium",
        height: "$medium"
      })
    }[tone], children]
  });
});
const Div$1 = re("div");
const Slot$1 = re(Slot$2);
const Grid = forwardRef(function Grid2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children,
    minItemWidth
  } = props;
  let ElementType = asChild ? Slot$1 : Div$1;
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css({
      ...styleProps,
      display: "grid",
      gap: "$medium",
      gridTemplateColumns: `repeat(
          auto-fit,
          minmax(min(var(--minItemWidth, ${minItemWidth}), 100%), 1fr)
        )`
    })(),
    ref,
    children
  });
});
const reset$8 = {
  margin: 0,
  padding: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility"
};
const heading = {
  color: "$black",
  fontFamily: "$primary",
  fontWeight: "$bold"
};
const variants$7 = css({
  variants: {
    size: {
      xlarge: {
        fontSize: "$font700",
        lineHeight: "$leading900",
        textTransform: "initial"
      },
      large: {
        fontSize: "$font500",
        lineHeight: "$leading800",
        textTransform: "initial"
      },
      medium: {
        fontSize: "$font300",
        lineHeight: "$leading700",
        textTransform: "initial"
      },
      small: {
        fontSize: "$font100",
        lineHeight: "$leading600",
        textTransform: "initial"
      },
      xsmall: {
        fontSize: "$font75",
        lineHeight: "$leading300",
        textTransform: "initial"
      },
      xxsmall: {
        fontSize: "$font50",
        lineHeight: "$leading200",
        textTransform: "uppercase"
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
const Heading$1 = forwardRef(function Heading2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, textStyleProps);
  let {
    asChild,
    children,
    color: _color,
    size
  } = props;
  let ElementType = asChild ? Slot$2 : "h3";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$8, heading, styleProps), variants$7({
      size
    })),
    ref,
    children
  });
});
const base$9 = css({
  display: "block"
});
const Icon = forwardRef(function Icon2(props, ref) {
  let {
    children,
    ...contextProps
  } = useContextProps(IconContext, props);
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(contextProps, iconStyleProps);
  return /* @__PURE__ */ jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    viewBox: "0 0 256 256",
    role: "presentation",
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css(base$9, styleProps)(),
    ref,
    children
  });
});
const Bin = forwardRef(function Bin2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "M216 56H40M104 104v64M152 104v64M200 56v152a8 8 0 0 1-8 8H64a8 8 0 0 1-8-8V56M168 56V40a16 16 0 0 0-16-16h-48a16 16 0 0 0-16 16v16"
    })]
  });
});
const ChevronBottom = forwardRef(function ChevronBottom2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m208 96-80 80-80-80"
    })]
  });
});
const ChevronLeft = forwardRef(function ChevronLeft2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m160 208-80-80 80-80"
    })]
  });
});
const ChevronRight = forwardRef(function ChevronRight2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m96 48 80 80-80 80"
    })]
  });
});
const ChevronTop = forwardRef(function ChevronTop2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m48 160 80-80 80 80"
    })]
  });
});
const Circle = forwardRef(function Circle2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 128,
      r: 96,
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    })]
  });
});
const Critical = forwardRef(function Critical2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "M128 80v56"
    }), /* @__PURE__ */ jsx("path", {
      d: "M164.5 32h-73a7.9 7.9 0 0 0-5.6 2.3L34.3 85.9a7.9 7.9 0 0 0-2.3 5.6v73a7.9 7.9 0 0 0 2.3 5.6l51.6 51.6a7.9 7.9 0 0 0 5.6 2.3h73a7.9 7.9 0 0 0 5.6-2.3l51.6-51.6a7.9 7.9 0 0 0 2.3-5.6v-73a7.9 7.9 0 0 0-2.3-5.6l-51.6-51.6a7.9 7.9 0 0 0-5.6-2.3Z",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 16
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 172,
      r: 12,
      fill: "currentColor"
    })]
  });
});
const Hidden = forwardRef(function Hidden2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m48 40 160 176m-53.1-58.4A39.6 39.6 0 0 1 128 168a40 40 0 0 1-26.9-69.6"
    }), /* @__PURE__ */ jsx("path", {
      d: "M74 68.6C33.2 89.2 16 128 16 128s32 72 112 72a117.9 117.9 0 0 0 54-12.6m26.6-18.3C230.4 149.6 240 128 240 128s-32-72-112-72a123.9 123.9 0 0 0-20.7 1.7",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }), /* @__PURE__ */ jsx("path", {
      d: "M135.5 88.7a39.9 39.9 0 0 1 32.3 35.5",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    })]
  });
});
const Info = forwardRef(function Info2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 128,
      r: 96,
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 180,
      r: 12,
      fill: "currentColor"
    }), /* @__PURE__ */ jsx("path", {
      d: "M128 144v-8a28 28 0 1 0-28-28",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    })]
  });
});
const Notice = forwardRef(function Notice2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "M128 104v40M114.2 40l-88 152A16 16 0 0 0 40 216h176a16 16 0 0 0 13.8-24l-88-152a15.9 15.9 0 0 0-27.6 0Z"
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 180,
      r: 12,
      fill: "currentColor"
    })]
  });
});
const Positive = forwardRef(function Positive2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16,
      d: "m172 104-58.7 56L84 132"
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 128,
      r: 96,
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    })]
  });
});
const Visible = forwardRef(function Visible2(props, ref) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    ref,
    children: [/* @__PURE__ */ jsx("path", {
      fill: "none",
      d: "M0 0h256v256H0z"
    }), /* @__PURE__ */ jsx("path", {
      d: "M128 56c-80 0-112 72-112 72s32 72 112 72 112-72 112-72-32-72-112-72Z",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }), /* @__PURE__ */ jsx("circle", {
      cx: 128,
      cy: 128,
      r: 40,
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    })]
  });
});
const Icons = {
  Bin,
  ChevronBottom,
  ChevronLeft,
  ChevronRight,
  ChevronTop,
  Circle,
  Critical,
  Hidden,
  Info,
  Notice,
  Positive,
  Visible
};
const base$8 = css({
  display: "block"
});
const Illustration = forwardRef(function Illustration2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, iconStyleProps);
  let {
    children,
    viewBox
  } = props;
  return /* @__PURE__ */ jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    viewBox,
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css(base$8, styleProps)(),
    ref,
    children
  });
});
function Cogs(props) {
  return /* @__PURE__ */ jsxs(Illustration, {
    ...props,
    viewBox: "0 0 364 369",
    width: "100%",
    children: [/* @__PURE__ */ jsxs("g", {
      fill: "currentColor",
      clipPath: "url(#a)",
      children: [/* @__PURE__ */ jsx("path", {
        d: "M192.938 227.369c-1.06-1.685-2.482-3.139-3.706-4.733-1.578-2.063-3.18-4.125-4.659-6.253-1.438-2.071-2.744-4.24-4.026-6.253 2.333-3.213 4.651-5.851 6.327-8.842 2.416-4.322 5.349-6.483 10.55-5.012 3.583 1.011 6.837.477 8.307-3.919.321-.954 2.203-1.504 3.46-2.005 1.257-.502 2.637-.699 3.697-.97 2.112-8.036 2.342-17.74.995-24.577-.526-2.645-2.12-4.198-4.405-4.831-5.275-1.454-10.64-2.605-15.965-3.878-1.906-.461-3.804-.921-4.659-1.126-3.188-8.39-6.023-15.859-9.022-23.772 2.555-2.078 5.472-4.404 8.332-6.787 1.997-1.659 4.043-3.295 5.867-5.143 2.925-2.958 2.769-4.413-.206-7.1-2.35-2.128-4.683-4.281-6.877-6.565-.83-.863-1.241-2.12-2.359-4.125 6.163 1.29 11.167 2.342 15.695 3.295l8.866 21.561c-2.441 4.684-8.382 6.705-10.641 11.783 3.5 5.818 8.989 8.554 13.96 11.972 4.7 3.229 8.817 5.415 13.328-.493 1.389-1.824 4.289-2.95 7.124-1.742 5.021 2.136 10.058 4.224 14.716 6.179.847 4.109 1.373 7.806 2.4 11.348.978 3.385 2.991 4.363 6.664 3.977 5.16-.551 10.312-1.241 15.48-1.603 3.353-.23 6.048-1.191 8.349-3.804 1.24-1.413 3.221-2.252 4.971-3.139 2.506-1.274 4.149-3.032 4.33-5.965.082-1.389.321-2.769.452-3.854 2.999-1.602 5.661-2.786 8.053-4.38 2.777-1.848 5.316-1.857 8.06-.115 1.216.773 2.63 1.216 3.821 2.013 3.344 2.235 6.344 2.26 9.334-.739 1.389-1.397 3.148-2.473 4.857-3.509 5.735-3.475 9.712-8.726 14.667-13.673a13602.26 13602.26 0 01-9.63-13.015c1.988-4.766 3.968-9.507 5.916-14.166 2.046-.518 3.714-.953 5.39-1.348 2.342-.55 2.564-2.941 3.903-4.33.715-.74 2.021-1.191 3.098-1.265 3.779-.255 4.831-2.884 5.111-5.908.476-5.136.673-10.304.977-15.3-5.686-3.87-12.152-2.038-17.838-3.492-3-7.042-5.917-13.895-8.924-20.961 2.112-2.186 4.191-4.183 6.089-6.344 1.832-2.087 4.84-3.311 5.201-6.935-3.492-5.308-9.088-8.537-13.919-12.563-1.907-1.586-4.265-1.52-6.508-.206-2.991 1.75-5.941 3.624-9.071 5.062-1.447.665-3.534 1.043-4.939.518-6.417-2.424-12.695-5.21-18.866-7.798-2.194-5.752 2.482-11.537-.55-17.075-8.866-1.824-17.56-3.607-26.615-5.472-.871 2.399-1.61 4.428-2.284 6.253-2.564.238-4.774.452-7.009.657-1.841 6.549 3.098 12.268.559 19.112a4171.584 4171.584 0 00-8.521 3.64c-4.207-2.235-6.721-5.488-9.745-8.126-1.479-1.298-3.279-1.545-4.791-.444-8.636 6.245-17.658 11.989-25.398 19.409-.37.353-.436 1.035-.896 2.226 3.353 3.788 6.927 7.83 10.723 12.12-2.259 4.552-4.404 8.883-6.565 13.237-2.523-.156-4.519-.377-6.516-.377-1.849 0-3.632.772-4.141 2.563-.764 2.662-2.252 3.451-4.922 3.83-3.574.509-4.191 1.478-4.207 5.332-.025 4.659-.197 9.269-1.833 13.673-.435 1.183-1.281 2.218-2.259 3.87-1.972-2.3-3.385-4.084-4.938-5.744-1.693-1.807-3.862-2.16-5.317-.509-4.396 5.004-11.191 6.943-15.374 12.218-.443.559-1.577.567-2.161.756-4.207-1.766-8.208-3.377-12.152-5.127-4.15-1.832-9.261-1.019-12.991-4.659-.082-1.692-.288-3.418-.238-5.127.115-3.468.534-6.927.525-10.395-.016-6.598-2.21-8.496-8.463-7.033-5.431 1.274-10.863 1.421-16.376 1.11-2.284-.124-4.577-.025-7.05-.025-.904 1.84-1.75 3.574-2.457 5.012l-6.837 1.495c-1.75 5.933.337 12.112-3.237 17.395-3.13 1.225-6.41 2.35-9.564 3.772-3.115 1.405-6.106 3.106-9.458 4.84-2.243-2.129-4.29-4.133-6.4-6.048-1.702-1.553-3.37-3.196-5.276-4.47-3-2.013-4.75-1.652-7.683.838-1.504 1.282-3.016 2.72-4.79 3.46-2.268.953-3.665 2.645-5.325 4.264-4.125 4.026-8.488 7.822-12.72 11.742-.813.756-1.454 1.684-2.226 2.605 3.188 7.748 8.8 13.656 12.982 19.934-3.254 6.286-6.27 12.095-9.277 17.896-.27.132-.517.296-.788.37-5.555 1.602-12.112.559-15.842 6.927-.888 1.52-4.035 1.717-6.418 2.637.518 8.299.986 16.327 1.545 24.355.156 2.202 1.487 3.788 3.492 4.585 1.586.633 3.295 1.003 4.971 1.38 5.341 1.2 10.69 2.351 16.237 3.567 3.771 8.307 7.107 15.628 10.542 23.204-5.587 6.565-13.295 10.863-19.646 17.305 1.47 1.495 2.415 3.188 3.82 3.755 4.733 1.914 8.045 5.563 11.71 8.808 2.16 1.915 4.379 3.772 6.458 5.777 2.564 2.481 5.513 4.075 9.778 4.692 5.398-3.468 11.175-7.19 17.107-11.011 4.438 1.808 8.62 3.763 12.975 5.21 4.716 1.561 7.23 4.839 7.757 9.449.419 3.681.09 7.444.008 11.175-.09 4.108 1.265 6.031 5.431 6.146 8.365.23 16.738.066 25.431.066.986-1.487 2.071-3.131 3.106-4.676 2.252-.698 4.405-1.364 6.237-1.922 3.418-7.231 3.369-14.355 2.062-21.668 4.298-2.071 8.16-3.994 12.087-5.777 1.282-.583 2.728-.788 3.953-1.125 7.518 3.097 12.374 9.811 19.778 13.023 2.185-1.783 3.952-3.853 6.195-4.963 9.211-4.552 14.322-13.262 21.076-20.295 2.498-2.605 2.49-5.793.592-8.801l-.008.009zm4.774-155.603c2.07-.041 3.665-.19 5.242-.09 3.632.23 7.05 3.064 11.249.706 1.496-3.706 2.942-7.757 4.758-11.627 1.816-3.886 4.009-7.608 5.99-11.306-3.912-4.29-7.576-8.3-11.586-12.703 5.275-4.06 10.041-7.724 14.987-11.52 3.558 1.043 5.473 4.042 7.782 6.483 2.679 2.826 4.33 3.45 7.42 2.194 6.401-2.597 12.769-5.267 19.786-8.168 2.473-6.41-1.685-13.41-1.06-20.895 3.599-.56 6.491 1.06 9.515 1.479 2.827.386 5.588 1.183 8.792 1.89.723 5.924-3.558 12.35 1.816 17.312 7.822 2.926 15.604 5.834 24.092 9.006 5.135-.657 9.482-5.02 15.546-7.223 3.952 3.567 8.283 5.933 11.134 9.803l-11.997 12.235c4.799 8.324 9.507 16.278 10.288 26.047 5.702.255 10.805.485 16.393.732.517 5.826 1.495 11.109-1.299 16.565-2.629.263-5.201.403-7.724.822-2.251.37-4.453 1.043-6.45 1.528-2.728 7.658-5.324 14.93-8.077 22.654 2.186 4.166 7.247 6.935 8.726 12.711-3.418 3.18-6.943 6.459-10.64 9.902-4.602-2.342-8.94-4.552-13.608-6.927-6.343 4.322-12.982 8.25-20.558 10.485-3.188.945-5.045 3.738-4.289 7.551.271 1.372.246 2.81.402 4.692-1.512.501-2.769 1.199-4.075 1.314-5.44.469-10.896.765-16.418 1.126-3.237-3.5-.287-7.946-2.194-12.292-1.594-.641-3.697-1.446-5.768-2.317-4.511-1.898-9.112-3.624-13.484-5.81-5.045-2.53-5.834-2.678-9.983.723-1.553 1.274-3.008 2.671-4.445 3.944-7.831-2.67-10.567-4.576-15.415-10.772 3.303-3.517 6.631-7.075 9.983-10.641-3.295-8.619-6.458-16.902-9.811-25.686-4.708-2.539-11.175-.115-16.483-4.174-.468-6.261 2.547-12.555 1.479-19.737l-.016-.016zM186.06 236.44c-4.248 4.684-8.718 9.162-13.36 14.01-2.317-1.471-4.273-2.605-6.114-3.911-2.826-2.005-5.505-4.224-8.364-6.179-3.361-2.301-7.018-2.622-10.682-.773-5.941 2.999-11.923 5.686-18.595 6.894-4.914.896-6.237 3.854-4.741 9.154 1.725 6.097 1.536 11.922-1.299 17.986-7.115 1.143-14.182-.049-21.848-.106 0-2.268.123-3.912-.025-5.539-.287-3.147-.435-6.343-1.167-9.391-1.207-5.021-3.985-8.719-9.268-10.444-4.66-1.52-9.154-3.583-13.624-5.612-4.84-2.202-8.907-1.66-12.292 2.662-1.068 1.356-2.202 2.736-3.558 3.78-1.783 1.372-3.821 2.416-5.58 3.5-5.176-2.227-8.076-6.384-11.848-9.457-3.525-2.868-7.116-5.662-10.887-8.653 2.12-3.295 5.283-4.872 7.888-7.066 2.867-2.416 5.743-4.832 8.447-7.42 1.898-1.824 1.8-3.985.616-6.352-2.712-5.415-5.538-10.797-7.74-16.417-1.89-4.832-5.013-7.535-10.017-8.431-3.13-.558-6.228-1.281-9.326-2.013-2.21-.526-4.388-1.191-6.853-1.865-.665-7.666-1.314-15.094-1.955-22.407 7.428-5.037 16.203-1.783 23.557-4.618.871-4.889 1.044-9.597 2.638-13.763 1.602-4.191 4.626-7.839 7.149-11.923-4.758-6.36-10.222-11.972-13.435-19.071 5.415-5.358 10.698-10.576 16.31-16.122 2.211 2.038 4.298 3.977 6.393 5.9 1.488 1.364 2.934 2.785 4.495 4.067 2.77 2.276 5.472 2.399 8.71.436 3.92-2.375 8.143-4.331 12.407-6.032 3.197-1.273 6.68-1.84 10.025-2.752 1.364-.37 2.695-.847 4.314-1.356 1.914-6.746 2.26-13.624 2.752-20.887 7.856-.28 15.243-.55 23.698-.855 0 2.736.098 4.708-.025 6.664-.172 2.597-.674 5.177-.756 7.765-.181 5.604 1.512 8.011 7.05 9.186 4.807 1.011 9.598 1.915 14.059 4.092 4.807 2.35 4.832 2.285 7.642 7.823 4.733-.748 7.765-4.495 11.405-7.05 3.517-2.465 6.713-5.407 10.164-8.234 4.479 2.071 6.188 6.722 9.45 9.836 3.122 2.975 6.294 5.9 9.63 9.022-3.772 5.004-8.661 7.658-12.794 11.151-1.709 1.446-3.426 2.875-5.234 4.396 2.087 3.738 4.297 6.836 5.629 10.279 1.659 4.281 2.752 8.808 3.788 13.295.764 3.286 2.539 4.864 5.85 5.365 5.703.855 11.364 1.981 17.034 3.049 2.267.427 3.746 2.013 3.796 4.166.148 6.573 1.093 13.204-.534 20.23-1.816.139-3.443.337-5.078.361a31.58 31.58 0 01-4.322-.271c-7.231-.904-12.013 1.931-15.243 8.62-2.35 4.856-5.883 9.145-9.038 13.911 3.262 5.308 6.844 10.484 10.969 15.324 4.166 4.889 4.059 7.239-.287 12.03l.024.016z"
      }), /* @__PURE__ */ jsx("path", {
        d: "M362.657 259.037c-7.872-3.419-16.047-3.665-23.968-5.456-2.088-5.473-4.109-10.781-5.991-15.703 3.78-6.212 10.477-9.096 13.419-15.743-4.832-5.464-9.984-10.436-15.974-14.446-3.04-2.037-6.031-.986-8.833 1.028-3.722 2.67-7.543 5.201-11.06 7.617-6.582-2.203-12.547-4.207-18.841-6.311.361-2.728.772-4.963.928-7.214.263-3.731.51-7.478.493-11.208 0-2.334-1.66-3.714-3.837-4.051-6.557-1.003-13.131-1.939-19.721-2.728-3.262-.394-6.376-.23-7.707 3.796-.271.814-1.726 1.356-2.736 1.767-1.537.616-3.172 1.002-4.774 1.487a7505.599 7505.599 0 00-3.073 13.361c-4.667 2.654-8.866 5.037-13.188 7.493-2.507-1.873-4.815-3.574-7.108-5.316-1.38-1.052-2.67-2.227-4.092-3.221-3.476-2.416-4.93-2.268-8.11 1.167-1.183 1.282-2.046 2.72-4.026 2.933-2.539.28-3.928 2.128-5.284 4.084-2.465 3.566-5.078 7.026-7.633 10.534-.337.468-.715.912-1.052 1.381-3.845 5.406-3.755 6.811.994 11.93 1.373 1.479 2.901 2.802 4.355 4.207 1.192 1.143 2.367 2.301 3.87 3.756-3.311 5.48-6.409 10.616-9.285 15.382-1.01.468-1.503.78-2.046.944-3.615 1.052-8.43-.115-9.605 5.407-.099.477-1.446.699-2.235 1.003-1.808.69-3.632 1.364-5.095 1.906.272 6.393.477 12.112.773 17.831.23 4.478.887 5.382 5.382 6.532 4.47 1.15 9.03 1.972 13.525 3.032 3.196.756 4.749 2.95 5.226 6.138 2.005 13.254 1.75 13.952-9.121 22.769-1.126.912-2.309 1.75-3.344 2.761-.97.945-1.775 2.062-2.942 3.459 1.857 1.282 3.205 2.268 4.602 3.18 3.861 2.539 7.879 4.864 11.594 7.601 8.611 6.359 9.145 6.491 18.414.871 3.656-2.219 7.222-4.585 10.69-6.796 4.7 2.145 8.833 4.026 12.473 5.686.345 1.003.542 1.282.518 1.545-.543 6.039-1.134 12.071-1.66 18.11-.403 4.552 1.035 6.36 5.727 6.705 4.897.362 9.827.296 14.733.641 3.944.279 7.436.082 9.811-3.829.641-1.06 2.276-1.742 3.59-2.112 3.189-.887 4.791-3.098 5.58-6.047 1.331-5.005 2.563-10.041 3.894-15.292 3.065-1.29 6.237-2.613 9.565-4.01 3.147 1.635 6.286 3.081 9.244 4.848 2.925 1.75 5.669 3.813 8.282 5.604 12.441-6.976 17.839-12.136 27.699-26.384-2.276-5.917-8.496-9.055-11.528-14.7 1.2-3.049 2.794-5.678 5.547-7.65 2.958.222 5.834.476 8.709.641 2.449.139 4.766-.247 5.457-3.073.525-2.153 1.988-2.392 3.804-2.704 1.594-.279 3.073-1.183 4.766-1.873.139-11.224 1.043-22.128.197-33.279l.008.009zm-6.064 31.314c-6.138.362-12.333-2.802-18.693-.567l-9.63 16.837c4.19 4.741 8.323 9.432 12.834 14.543-4.872 5.448-9.416 10.534-14.166 15.843-4.733-2.613-9.013-4.922-13.245-7.322-3.221-1.832-6.27-2.202-9.86-.583-3.649 1.643-7.634 2.588-11.529 3.624-6.121 1.626-6.68 2.218-7.296 8.89-.296 3.164-.386 6.368-1.044 9.458-.534 2.506-1.783 4.856-2.769 7.411-6.401 2.087-12.605-.575-18.595.403-1.947-2.728-.788-5.029-.706-7.206.09-2.309.378-4.61.657-6.902.833-6.853-2.03-11.614-8.587-14.281a77.563 77.563 0 01-7.058-3.312c-3.591-1.914-6.631-1.191-9.433 1.553-3.73 3.657-7.658 7.034-13.451 8.34-5.628-3.845-11.512-7.871-17.937-12.267 3.122-2.498 5.76-4.684 8.471-6.771 4.676-3.607 7.453-7.864 5.884-14.166-.691-2.769-.444-5.76-.945-8.595-.707-4.042-3.049-6.787-7.174-7.789-5.053-1.225-10.098-2.457-15.858-3.862-.469-6.146-.904-11.849-1.372-17.905 3.097-2.284 6.943-2.169 10.583-2.276 4.412-.131 6.746-1.988 7.995-6.294.953-3.262 2.966-6.228 4.618-9.269.961-1.774 2.227-3.393 3.172-5.168 2.267-4.265 2.004-5.916-1.636-8.989-3.073-2.605-6.359-4.963-8.455-8.998 2.925-6.327 8.217-10.994 11.348-16.902 3.344-.246 4.889 2.202 7.009 3.509 2.202 1.364 4.141 3.196 6.409 4.404 2.424 1.29 5.308 1.504 7.222-.748 5.177-6.072 11.981-6.253 19.376-5.587 3.147-6.598 2.136-14.158 4.823-20.781 7.026-1.265 13.262 1.34 19.671 1.833 2.671 7.444-1.725 14.198-.378 20.657.806.657 1.184 1.183 1.685 1.356 8.71 3.015 17.428 5.982 26.244 8.997 5.21-2.268 6.451-9.006 12.375-10.887 5.489 2.531 9.343 7.058 13.722 11.972-3.574 3.41-6.869 6.606-10.238 9.729-2.95 2.728-3.402 5.612-1.643 9.326 2.095 4.404 3.64 9.063 5.62 14.116 1.602 1.561 4.117 1.907 6.787 1.939 5.514.074 10.772 1.43 15.785 2.926 1.454 7.493 1.134 22.999-.592 29.786v-.025zM108.551 137.033c-21.463.813-36.697 16.606-36.623 37.411.09 23.796 17.978 39.794 41.512 39.285 22.3-.477 37.214-19.334 36.573-38.397-.156-19.466-15.045-39.294-41.471-38.299h.009zm21.758 64.198c-3.18 4.528-7.371 7.395-12.671 8.373-13.36 2.449-24.626-1.454-33.253-12.029-8.143-9.984-9.943-21.372-5.744-33.41 4.667-13.369 12.161-17.946 26.401-17.519 7.017.214 12.958 2.876 18.209 7.124 8.553 6.919 13.138 15.925 13.089 27.034.189 7.477-1.693 14.264-6.039 20.427h.008zm143.31-87.781c17.51-.271 30.395-15.217 30.263-30.681-.238-14.939-10.624-29.014-30.156-29.187-16.664-.148-30.723 14.445-30.402 31.528.287 15.489 13.771 28.603 30.295 28.348v-.008zm-21.175-43.073c2.474-4.256 6.369-6.392 11.332-6.935 13.5-1.462 24.691 7.913 26.384 21.619.123.97.049 1.964.025 1.832.345 6.171-1.192 10.165-3.148 14.01-3.648 7.173-9.301 10.436-18.759 8.841-10.024-1.692-16.359-8.069-19.161-17.764-2.211-7.65-.584-14.881 3.327-21.603z"
      }), /* @__PURE__ */ jsx("path", {
        d: "M275.969 235.799c-23.163-.616-34.716 16.434-35.086 32.802-.476 21.372 18.866 35.628 35.39 34.807 16.163 1.035 34.018-13.065 33.772-33.229-.231-18.694-13.567-33.829-34.084-34.371l.008-.009zm15.941 55.793c-3.829 6.853-10.247 8.849-16.253 8.529-15.719-.156-27.921-11.208-29.737-25.374-1.043-8.101.575-15.365 5.127-22.177 2.613-3.919 6.097-6.031 10.567-6.713 17.428-2.662 28.266 7.247 33.007 19.153 3.69 9.261 2.005 18.176-2.703 26.59l-.008-.008z"
      })]
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "a",
        children: /* @__PURE__ */ jsx("path", {
          fill: "#fff",
          d: "M0 0h362.783v368.995H0z",
          transform: "translate(.236)"
        })
      })
    })]
  });
}
function Done(props) {
  return /* @__PURE__ */ jsxs(Illustration, {
    ...props,
    viewBox: "0 0 400 400",
    width: "100%",
    children: [/* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M69.388 350.433c-5.21-.589-10.592-1.085-15.932-1.833-11.161-1.56-22.373-2.969-32.778-7.772-.44-.201-1.001-.107-1.484-.237-.713-.194-1.83-.287-2.01-.733-.281-.712-.26-1.963.202-2.473 3.43-3.818 5.62-8.275 7.169-13.092 2.817-8.778 5.779-17.521 8.294-26.385 1.938-6.83 3.494-13.782 4.863-20.748 1.924-9.821 3.726-19.685 5.167-29.585.886-6.067 1.059-12.243 1.455-18.376.519-8.102 1.131-16.197 1.362-24.307.209-7.34.036-14.695-.122-22.042a1576.224 1576.224 0 00-.937-30.332c-.591-14.372-1.477-28.729-1.953-43.108-.31-9.504-.223-19.023-.108-28.534.1-8.225.331-16.457.8-24.66.317-5.521 1.196-11.014 1.75-16.528.145-1.438.022-2.905.022-4.716 2.32 0 4.82-.029 7.321 0 11.27.136 22.54.345 33.809.41 6.737.036 13.481-.159 20.218-.223 10.275-.1 20.543-.202 30.818-.252 8.863-.043 17.733.036 26.596-.029 10.729-.079 21.465-.309 32.194-.373 8.409-.05 16.825.071 25.234.071 5.865 0 11.73-.136 17.588-.136 8.042 0 16.083.144 24.117.072 6.752-.065 13.503-.54 20.255-.51 10.513.057 21.026.301 31.531.632 11.263.352 22.51.927 33.773 1.33 3.746.136 7.508-.043 11.262.058 3.552.093 3.696.632 3.559 4.148-.122 3.199.49 6.42.534 9.64.144 9.75.172 19.498.245 29.254.043 6.363.129 12.733.115 19.095-.043 13.883-.079 27.765-.231 41.641a2999.95 2999.95 0 01-.72 40.253c-.173 7.117-.779 14.228-.887 21.345-.043 2.948.57 5.924 1.132 8.843.72 3.731 1.902 7.391 2.5 11.136.648 4.07.728 8.218 1.29 12.301.735 5.349 1.707 10.669 2.551 16.011 1.455 9.181 2.702 18.398 4.395 27.535 1.268 6.844 3.43 13.531 4.619 20.382 2.082 12.085 4.525 24.163 3.948 36.558-.324 6.988-4.042 12.042-10.188 14.422-8.02 3.098-16.4 5.377-24.759 7.477-3.71.934-7.753.481-11.629.819-3.286.288-6.557.777-9.829 1.222-8.401 1.144-16.817 2.186-25.19 3.509-19.678 3.098-39.558 3.178-59.381 3.976-12.53.503-25.097.409-37.649.395-13.005-.014-26.011-.173-39.01-.417-9.699-.18-19.397-.539-29.096-.891-12.091-.432-24.182-.842-36.258-1.453-5.916-.302-11.803-1.136-17.719-1.517-2.752-.179-5.54.223-8.315.223-2.932 0-4.157-1.402-4.179-4.299-.022-2.365-.202-4.731-.317-7.189l-.007-.008zM47.447 37.223c-.613 6.556-1.528 12.803-1.722 19.072-.404 13.05-.706 26.105-.54 39.154.165 12.833.95 25.651 1.491 38.477.576 13.789 1.333 27.578 1.73 41.368.31 10.654.554 21.33.18 31.971-.44 12.358-1.463 24.702-2.508 37.032-.57 6.715-1.556 13.408-2.659 20.065-1.102 6.651-2.464 13.272-3.941 19.85-4.194 18.649-9.173 37.054-18.086 54.424.886.381 1.945.898 3.048 1.294 9.525 3.436 19.411 5.155 29.442 6.19 6.866.712 13.74 1.373 20.622 2.02 2.687.252 5.39.316 8.063.625 5.591.64 11.161 1.489 16.767 2.049 9.129.913 18.259 1.855 27.41 2.438 9.677.611 19.368.999 29.06 1.143 8.855.136 17.725-.036 26.581-.338 10.808-.367 21.616-.928 32.417-1.575 10.722-.64 21.43-1.481 32.144-2.257 6.6-.475 13.201-.884 19.786-1.503 9.483-.891 18.958-1.934 28.433-2.926 9.915-1.042 19.844-1.984 29.738-3.213 4.856-.604 9.878-.31 14.454-2.826 2.608-1.43 4.532-3.041 5.209-6.017.462-2.035 1.276-3.99 1.672-6.032 1.261-6.514 2.587-13.027 3.524-19.591.908-6.341 1.333-12.754 2.039-19.124.526-4.759 1.268-9.49 1.729-14.256.93-9.519 1.744-19.052 2.587-28.585.663-7.463 1.376-14.918 1.917-22.395.345-4.853.374-9.727.619-14.594.332-6.571.786-13.135 1.096-19.699.295-6.197.482-12.402.713-18.606.144-3.89.331-7.772.403-11.661.08-4.221.015-8.441.072-12.661.065-4.472.296-8.936.289-13.408-.008-7.786-.202-15.579-.217-23.365-.014-7.765.116-15.537.13-23.301.015-7.038.029-14.077-.079-21.108-.137-8.872-.411-17.743-.634-27.111-4.388 0-8.193.05-11.997-.014-8.265-.137-16.53-.216-24.787-.554-5.549-.223-11.082-1.157-16.631-1.208-10.296-.093-20.6.245-30.897.352-12.624.137-25.241.267-37.865.324-14.699.072-29.398.072-44.098.108-12.17.029-24.333.036-36.503.079-15.254.057-30.508.13-45.762.23-9.843.065-19.693.23-29.535.28-7.134.043-14.275.05-21.408-.057-4.345-.065-8.69-.381-13.51-.604l.014.043z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M247.033 198.709c.439.396.886.791 1.34 1.201-.065.237-.051.503-.18.64-3.466 3.76-7.062 7.254-12.257 8.692-3.473.963-6.499-.115-9.511-1.409-5.332-2.301-8.582-6.5-10.434-11.884-1.585-4.594-3.53-9.109-4.633-13.818-1.045-4.472-1.189-9.152-1.765-13.732-.533-4.256.756-8.21 1.866-12.229 1.484-5.349 7.141-8.304 12.941-6.672 6.449 1.812 10.225 6.305 12.264 12.337 2.565 7.585.663 14.803-3.322 21.259-2.752 4.457-7.083 7.312-13.308 6.118 1.57 4.76 3.047 9.325 6.65 12.848 2.983 2.918 5.556 3.587 8.856 1.696 1.981-1.128 3.682-2.811 5.339-4.421 3.927-3.789 7.681-7.765 11.68-11.482 1.002-.934 2.609-1.315 4.007-1.703.554-.151 1.707.244 1.859.647.245.69.201 1.826-.238 2.358-1.931 2.379-4.05 4.608-6.096 6.894-.447.504-.98.971-1.304 1.546-.901 1.61-2.011 2.164-3.762 1.107l.008.007zm-16.04-29.634c-.23-4.975-.634-9.21-3.855-12.337-1.419-1.38-3.35-2.84-5.152-2.991-1.16-.093-3.062 1.905-3.682 3.372-3.581 8.505-2.875 17.082.497 25.465.389.97 2.22 1.934 3.337 1.883 1.253-.057 2.608-1.093 3.646-2.006 4.251-3.76 4.042-9.216 5.209-13.386zM122.485 263.96c-2.125-.424-4.46-.705-6.658-1.431-.691-.23-1.599-1.991-1.347-2.415.519-.87 1.686-1.561 2.724-1.877 2.918-.884 6.016-1.258 8.848-2.336 5.743-2.186 11.291-4.882 17.048-7.032 10.441-3.889 20.932-7.671 31.496-11.215 4.517-1.517 9.287-2.279 13.913-3.487 6.291-1.646 12.538-3.465 18.843-5.054 2.594-.654 5.296-.848 7.94-1.316 2.357-.409 4.698-.941 7.054-1.351 6.039-1.064 12.077-2.157 18.137-3.12 5.75-.913 11.507-1.762 17.286-2.481 7.407-.92 14.843-1.545 22.114-3.379 1.116-.28 2.421-.122 3.566.137.67.151 1.196.913 1.787 1.402-.555.525-1.037 1.359-1.679 1.51-4.157 1.013-8.322 2.092-12.544 2.746-10.384 1.61-20.875 2.646-31.193 4.58a613.538 613.538 0 00-37.181 8.188c-12.732 3.221-25.421 6.729-37.908 10.784-9.619 3.128-18.907 7.29-28.332 11.014a80.43 80.43 0 00-5.772 2.517c-1.116.546-2.053 1.459-3.177 1.955-1.47.647-3.055 1.035-4.958 1.661h-.007zm64.944-68.637c.324 1.92.699 3.832.958 5.759.504 3.695.937 7.398 1.427 11.093.151 1.172.526 2.344.511 3.516-.014.855-.266 2.02-.857 2.458-.591.439-1.794.389-2.609.144-4.179-1.229-3.221-5.047-3.775-7.994-1.276-6.751-2.04-13.617-3.632-20.282-1.225-5.126-3.329-10.058-5.21-15.011-.562-1.481-1.484-3.185.289-3.868 1.333-.51 3.386-.122 4.719.604 1.261.69 2.068 2.293 2.94 3.58 2.047 3.041 4.006 6.133 5.995 9.203 3.091 4.773 6.082 9.626 9.31 14.307 1.808 2.624 4.013 4.975 6.038 7.448l.663-.173c.151-.805.49-1.617.432-2.408-.54-6.794-1.311-13.559-3.531-20.066-1.57-4.615-3.184-9.217-4.654-13.868-.627-1.977-.923-4.055-1.384-6.089-.144-.647-.238-1.338-.54-1.92-.591-1.136-1.196-2.322.302-3.077 1.42-.705 3.149-1.287 4.223.467.886 1.453 1.477 3.113 2.032 4.731 2.212 6.442 4.359 12.898 6.535 19.354 2.14 6.348 3.07 12.905 3.488 19.555.201 3.141.346 6.254-1.189 9.18-1.002 1.898-2.378 2.617-4.417 1.676-2.645-1.223-5.152-2.545-6.968-5.019-2.421-3.292-5.116-6.384-7.631-9.605-.972-1.25-1.787-2.624-2.673-3.947-.259.087-.526.166-.785.252h-.007zm-49.43 22.215c-.634 5.464-1.175 11.395-6.01 15.889-3.509 3.264-7.544 4.328-11.19 1.934-2.774-1.826-5.152-4.285-6.658-7.42-1.275-2.638-2.738-5.19-4.056-7.807-1.24-2.459-2.4-4.961-3.589-7.449-1.628-3.407-3.084-6.909-4.907-10.208-1.91-3.459-2.003-3.847.288-7.06.26-.36-.043-1.366-.389-1.855-.684-.964-1.729-1.69-2.363-2.675-1.218-1.876-.54-3.321 1.679-3.666 2.334-.36 4.316.064 6.002 2.106 1.218 1.467 2.947 2.61 4.64 3.566 5.736 3.243 11.666 6.147 17.301 9.548 4.561 2.753 8.488 6.261 9.072 12.106.079.82.108 1.64.201 2.977l-.021.014zm-14.31 14.293c3.206-1.273 5.461-3.25 6.153-6.73.245-1.243.512-2.501.966-3.673 1.815-4.738-.015-11.482-4.158-14.264-3.531-2.365-7.213-4.515-10.866-6.7-1.311-.784-2.738-1.366-4.107-2.042-.101.165-.202.33-.303.489 4.086 10.92 8.171 21.834 12.322 32.912l-.007.008zm46.771-26.414c.569 5.845-.058 11.33-2.328 16.5-.778 1.782-1.96 3.616-3.458 4.809-3.625 2.89-6.183 2.61-10.038.058-4.719-3.128-7.299-7.542-8.812-12.848-.951-3.35-2.688-6.506-3.401-9.885-1.312-6.183-3.062-12.459-1.146-18.807.93-3.085 1.794-6.622 5.592-7.499 1.794-.41 4.056-.532 5.634.209 3.409 1.603 6.853 3.451 9.663 5.909 6.543 5.701 8.964 13.229 8.286 21.561l.008-.007zm-20.558-23.243c-.072.05-.937.323-1.102.834-.865 2.595-2.277 5.284-2.176 7.886.317 8.477 1.614 16.845 5.851 24.43 1.419 2.538 2.882 5.061 4.503 7.47.901 1.337 2.306 1.596 3.279.028.965-1.56 1.981-3.213 2.413-4.96 1.924-7.714 2.285-15.501.144-23.243-.446-1.625-1.347-3.128-2.075-4.774-2.889 1.998-5.267 2.034-5.793.122-.468-1.704-1.636-2.48-2.601-3.631-.944-1.128-1.528-2.559-2.443-4.148v-.014zm118.322-18.218c-.151 2.509-.058 4.27-.432 5.924-.188.827-1.124 1.697-1.939 2.085-.461.223-1.513-.345-2.053-.827-1.65-1.452-2.472-3.041-2.32-5.564.295-5.033-.598-10.037-1.413-15.048-1.16-7.139-2.658-14.098-5.894-20.619-.353-.719-.396-1.596-.562-2.401-.619-2.976.519-3.336 2.897-4.069 1.801-.554 3.149.877 3.379 3.149.065.661.188 1.359.454 1.955 3.87 8.62 5.685 17.758 6.881 27.047.39 3.033.728 6.082 1.002 8.361v.007zm.857 27.204c2.969-1.847 6.14-1.588 9.202-1.631.526-.008 1.275 1.013 1.527 1.703.166.439-.237 1.294-.641 1.704-2.226 2.243-6.773 2.38-9.252.245-.475-.41-.547-1.287-.836-2.021z"
    })]
  });
}
function Padlock(props) {
  return /* @__PURE__ */ jsxs(Illustration, {
    ...props,
    viewBox: "0 0 400 400",
    width: "100%",
    children: [/* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M228.409 14.004c9.713-.103 19.048 1.667 27.516 6.48 11.344 6.453 20.044 15.407 23.05 28.52 1.846 8.052 3.006 16.301 3.933 24.525 1.151 10.2 1.718 20.46 2.611 30.686.051.636.541 1.598 1.048 1.77 6.2 2.088 11.267 6.032 16.411 9.848 4.904 3.635 9.679 7.433 14.591 11.051 4.045 2.973 6.613 6.608 7.18 11.807.704 6.496 2.301 12.898 2.825 19.394.533 6.565.516 13.216.224 19.807-.636 14.256-1.89 28.478-2.354 42.734-.446 13.603-.292 27.223-.249 40.843.018 6.187.627 12.374.507 18.561-.086 4.34-.61 8.74-1.537 12.976-1.357 6.178-5.016 11.188-9.765 15.193-7.6 6.419-15.407 12.597-23.196 18.793-6.441 5.121-12.822 10.337-19.512 15.124-10.151 7.261-21.126 13.19-32.634 17.976-8.768 3.644-18.052 5.723-27.533 6.368-7.927.541-15.562 2.294-22.93 5.001-10.967 4.039-22.226 6.806-33.656 9.1-5.978 1.195-11.843 2.931-17.778 4.374-1.193.292-2.439.43-3.667.507-3.847.224-7.729.731-11.55.499-6.261-.387-11.568-3.412-16.799-6.737-7.076-4.503-13.036-9.977-18.395-16.482-5.582-6.78-8.828-14.411-10.288-22.746-1.323-7.553-1.838-15.287-2.208-22.961-.48-10.166-.506-20.357-.67-30.531a3866.409 3866.409 0 01-.394-31.58c-.086-10.183-.344-20.374-.06-30.549.291-10.44 1.236-20.855 1.709-31.296.137-2.964.875-5.955-.353-9.005-.429-1.066.318-3.137 1.22-4.108 2.25-2.432 4.715-4.76 7.428-6.66 6.004-4.202 12.195-8.137 18.327-12.15 2.01-1.315 4.071-2.544 6.141-3.773.944-.558 1.348-1.091 1.262-2.388-.79-12.624-1.288-25.204.799-37.827 1.563-9.47 4.191-18.562 7.652-27.421 2.19-5.594 4.775-11.068 7.574-16.387 4.672-8.877 9.945-17.35 17.082-24.585 5.865-5.947 12.366-10.965 19.537-15.176 9.378-5.49 19.169-10.088 29.569-13.276 12.169-3.73 24.596-5.998 37.332-6.299zM127.603 383.835c2.362-.111 4.363.06 6.235-.352 6.235-1.401 12.375-3.231 18.636-4.494 13.5-2.724 26.605-6.789 39.685-11.017 4.758-1.538 9.704-2.569 14.634-3.437 5.144-.902 10.426-1.057 15.561-2.036 9.919-1.882 19.109-5.784 28.023-10.527 9.464-5.036 18.447-10.75 26.949-17.246 4.612-3.524 9.206-7.081 13.672-10.785 7.643-6.324 16.068-11.721 22.87-19.077 3.452-3.729 6.604-7.725 7.532-12.76.841-4.555 1.107-9.281 1.116-13.921.017-10.252-.421-20.512-.429-30.764-.018-11.196-.009-22.402.429-33.59.489-12.426 1.58-24.834 2.207-37.26.283-5.586.326-11.214.009-16.791-.267-4.7-1.168-9.366-1.864-14.041-.172-1.16-.61-2.286-.988-3.644-.403.43-.626.619-.781.851-5.428 8.224-12.848 14.471-20.611 20.271-11.233 8.396-23.583 14.961-36.259 20.856-15.089 7.02-30.29 13.826-45.49 20.615-10.134 4.52-20.783 7.553-31.544 10.088a657.117 657.117 0 01-29.637 6.273c-10.1 1.891-20.208 4.073-31.071 2.492-.378 8.774-1.074 17.487-1.065 26.201.025 16.387.412 32.774.738 49.161.206 10.406.593 20.821.859 31.227.232 9.109.438 18.218.575 27.318.086 5.216.018 10.44.018 15.656v10.716l-.009.017zm125.539-269.377c.447 6.015.79 12.039 1.391 18.045.353 3.515 1.95 6.574 4.767 8.8 1.271 1.005 2.714 2.311 4.182 2.457 6.621.636 12.891-.008 17.64-5.705 1.408-1.693 2.284-3.352 2.25-5.405-.052-3.163-.369-6.325-.515-9.487-.413-9.006-.73-18.02-1.203-27.026-.292-5.585-.67-11.17-1.219-16.74-.576-5.79-1.529-11.548-2.078-17.34-.971-10.209-3.522-19.781-10.117-27.936-4.801-5.938-10.744-10.45-17.666-13.466-8.253-3.6-16.961-4.692-26.004-4.142-11.929.714-23.557 2.94-34.781 6.78-11.354 3.893-22.235 8.929-32.171 15.855-6.501 4.528-12.513 9.59-17.373 15.802-10.461 13.38-18.078 28.29-23.197 44.496-2.859 9.065-4.981 18.312-5.453 27.773-.67 13.457-.189 26.888 2.19 40.233 1.4 7.862 2.156 15.837 3.229 23.751.052.387.249.911.55 1.083 2.43 1.383 4.783 3.093 7.403 3.918 2.585.817 5.453.842 8.201.989 5.952.317 11.731-.662 16.549-4.314 5.479-4.159 7.635-10.097 7.24-16.886-.378-6.599-1.082-13.173-1.434-19.772-.395-7.408-.533-14.824-.816-22.231-.258-6.642.584-13.173 1.812-19.678 1.185-6.265 3.358-12.168 5.857-18.02 3.89-9.126 8.322-17.814 15.097-25.264 6.802-7.476 15.141-12.33 24.442-15.768 8.614-3.188 17.339-3.145 26.176-.825 9.696 2.552 17.262 7.734 21.204 17.169 1.64 3.927 2.731 8.146 3.529 12.34 1.907 10.097 1.083 20.314.335 30.522l-.017-.008zm-2.808-6.428c-6.02 1.083-12.006 1.882-17.837 3.274-13.363 3.197-26.692 6.626-39.299 12.245-11.156 4.976-22.208 10.2-33.338 15.227-1.589.714-2.19 1.659-2.062 3.335.524 6.9 1.1 13.8 1.478 20.709.334 6.247 1.142 12.589.463 18.742-.962 8.756-8.193 15.579-17.717 17.169-4.74.79-9.704.653-14.522.3-2.8-.197-5.685-1.297-8.21-2.62-3.289-1.728-5.514-4.434-5.557-8.594-.025-2.81-.566-5.628-1.013-8.421-.696-4.374-1.486-8.73-2.276-13.087-.403-2.234-.893-4.451-1.382-6.875-11.74 7.064-23.592 13.303-33.124 22.626 1.142 1.384 2.181 2.483 3.04 3.712 1.365 1.951 2.37 4.211 3.95 5.955 4.38 4.812 9.516 8.757 15.167 11.996 9.017 5.165 18.035 10.329 27.086 15.434 1.872 1.057 3.873 2.457 5.883 2.578 3.676.223 7.429-.164 11.096-.697 6.329-.919 12.641-1.985 18.902-3.265 10.606-2.165 21.264-4.193 31.724-6.943 8.407-2.209 16.669-5.096 24.785-8.241 8.33-3.231 16.463-6.995 24.561-10.776 10.203-4.76 20.337-9.693 30.41-14.711 12.797-6.376 24.992-13.732 35.452-23.588 4.302-4.056 8.751-8.052 11.447-13.56 1.727-3.515 1.383-6.815-1.7-9.307-2.868-2.32-5.926-4.417-8.889-6.625-6.286-4.683-12.529-9.418-18.859-14.041-1.176-.859-2.653-1.306-4.672-2.26.344 6.11.181 11.609 1.065 16.937 1.46 8.799-.463 14.316-7.883 19.137-3.994 2.595-8.614 2.586-13.106 2.423-6.406-.232-11.267-4.193-13.294-10.389-1.864-5.706-1.657-11.626-1.769-17.513-.06-3.317-.009-6.634-.009-10.294l.009.008zM124.4 384.05c0-4.107.017-8.077 0-12.056-.035-8.559.034-17.118-.172-25.668-.318-13.285-.876-26.57-1.228-39.855-.249-9.306-.395-18.612-.455-27.927-.095-13.457-.215-26.914-.026-40.371.069-5.053 1.039-10.097 1.477-15.15.06-.678-.446-1.692-1.022-2.079-2.095-1.401-4.32-2.621-6.51-3.876-7.196-4.107-14.496-8.034-21.573-12.339-5.96-3.618-11.585-7.743-15.75-13.509-.696-.962-1.46-1.864-2.31-2.947-.275 3.755-.696 7.175-.747 10.612-.146 8.877-.18 17.745-.172 26.622.009 12.374.017 24.757.18 37.131.112 7.991.576 15.983.748 23.983.257 11.859.094 23.743.695 35.584.352 6.858 1.778 13.681 2.868 20.486 1.057 6.617 4.011 12.452 8.03 17.719 6.029 7.915 13.561 14.128 22.114 19.189 4.372 2.586 9.129 3.583 13.87 4.443l-.017.008zm33.484-246.966c.395-.069.627-.061.808-.146 6.887-3.429 13.603-7.27 20.688-10.218a539.753 539.753 0 0132.84-12.365c7.266-2.466 14.806-4.151 22.286-5.921 4.664-1.1 9.456-1.65 14.17-2.552.713-.138 1.813-.739 1.898-1.263.378-2.32.756-4.718.576-7.047-.395-4.984-.962-9.968-1.778-14.9-.816-4.958-2.301-9.77-4.964-14.076-3.306-5.336-8.158-8.687-14.015-10.853-7.755-2.861-15.639-3.583-23.557-1.375-4.371 1.22-8.605 3.102-12.71 5.07-7.223 3.472-12.934 8.851-17.709 15.21-5.11 6.806-8.528 14.514-11.808 22.308-5.119 12.159-7.274 24.791-6.725 38.119v.009z"
    }), /* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M262.091 252.893c.163 8.851-2.19 16.92-7.12 24.327-.944 1.418-1.022 3.584-1.064 5.414-.181 7.562-.112 15.124-.292 22.677-.086 3.489-.55 6.961-.842 10.441-.189 2.208-1.348 3.832-3.143 4.993a913.325 913.325 0 01-11.603 7.355c-3.169 1.968-6.587.877-7.042-3.523-1.03-9.985-1.795-19.996-2.739-29.981-.215-2.312-.67-4.598-1.082-6.883-.078-.456-.344-1.092-.696-1.238-4.354-1.856-6.587-5.534-8.914-9.427-3.333-5.585-4.827-11.497-4.827-17.873 0-4.623 1.031-9.023 3.023-13.234 1.623-3.428 3.109-6.848 5.943-9.547 3.324-3.179 7.317-5.035 11.671-5.98 6.596-1.427 13.165-1.41 19.4 1.727 3.504 1.761 6.45 4.219 7.472 8.086 1.091 4.116 1.623 8.378 2.405 12.58l-.533.103-.017-.017zm-11.877 26.166c1.623-2.707 3.34-5.138 4.629-7.777 4.07-8.3 5.092-17.117 3.478-26.14-1.555-8.696-4.595-11.291-13.251-12.804 2.808 2.759 6.681 4.666 7.076 9.186.198 2.226.335 4.469.283 6.703-.171 7.932-3.357 14.454-9.343 19.653-1.057.919-1.864 2.139-2.929 3.394 3.41 2.647 6.544 5.078 10.048 7.794l.009-.009zm-.344 36.203c.301-5.388.696-10.166.799-14.952.112-4.726-.12-9.461-.103-14.196.008-2.475.438-5.035-2.954-5.723-.31-.06-.541-.472-.825-.696-2.327-1.761-4.672-3.523-7.291-5.491 0 .92-.017 1.409 0 1.899.343 9.745.678 19.489 1.048 29.225.017.464.163 1.057.472 1.367 2.782 2.75 5.617 5.448 8.854 8.567zm-.962 2.698c-2.782-2.706-5.195-5.087-7.652-7.424-.395-.378-1.236-.92-1.434-.782-2.25 1.615-4.423 3.351-6.612 5.053.343 3.463.635 6.934 1.056 10.397.172 1.41 1.039 1.616 2.181.834 2.216-1.521 4.414-3.068 6.664-4.537 1.855-1.212 3.771-2.312 5.797-3.541z"
    })]
  });
}
function PaperPlane(props) {
  return /* @__PURE__ */ jsx(Illustration, {
    ...props,
    viewBox: "0 0 400 400",
    width: "100%",
    children: /* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M116.73 282.302c4.643 1.407 9.225 2.693 13.709 4.252.794.274 1.187 1.704 1.769 2.594-.93.197-1.973.775-2.775.54-4.476-1.339-8.907-2.838-13.308-4.404-.582-.206-.907-1.134-1.353-1.735.59-.372 1.179-.753 1.951-1.247h.007zm103.81-6.458c-2.866.327-5.724.738-8.597.913-.779.045-1.596-.639-2.397-.989.597-.616 1.089-1.521 1.822-1.795 3.463-1.301 6.979-2.624 10.782-1.552.666.19 1.452.396 1.868.867.469.548.59 1.4.862 2.122-.628.198-1.248.495-1.89.579-.802.098-1.618.022-2.435.022 0-.053 0-.114-.008-.167h-.007zM99.165 234.169c-.416-.328-1.225-.639-1.338-1.126-.144-.571.106-1.59.544-1.902 3.002-2.114 6.057-4.161 9.202-6.047.507-.304 1.777.084 2.284.571.378.372.431 1.711.068 2.129-2.798 3.203-6.435 5.059-10.76 6.375zm-24.597 18.939c.393.373.741.655 1.029.982 3.145 3.575 6.32 7.135 9.383 10.786.461.555.348 1.589.507 2.403-.81-.114-1.966.084-2.374-.38-3.176-3.651-6.231-7.401-9.233-11.189-.355-.449-.227-1.346-.181-2.023.015-.198.529-.358.87-.571v-.008zM11.09 108.709c.787-.244 1.611-.784 2.36-.7 4.348.525 8.695 1.103 12.998 1.901.703.13 1.194 1.446 1.784 2.214-.87.167-1.77.585-2.6.471a239.957 239.957 0 01-10.897-1.802c-1.27-.236-2.495-.746-3.735-1.134.03-.319.068-.639.098-.958l-.007.008zm22.17 72.025c.605 1.604 1.18 2.532 1.301 3.521.53 4.298.99 8.603 1.316 12.916.06.821-.59 1.689-.908 2.541-.597-.579-1.656-1.119-1.716-1.75-.484-5.096-.794-10.208-1.096-15.319-.023-.35.4-.723 1.104-1.909zm-.49 26.401c.664.883 1.383 1.735 1.988 2.663a844.416 844.416 0 015.943 9.371c.43.684.953 1.376 1.111 2.137.121.601-.25 1.308-.408 1.97-.635-.213-1.588-.236-1.845-.677a391.641 391.641 0 01-7.516-13.075c-.302-.548.023-1.438.053-2.176.227-.068.454-.144.68-.213h-.007zm121.57 84.743c-1.618-.076-3.266 0-4.839-.296-.62-.114-1.074-1.08-1.603-1.659.537-.471 1.028-1.285 1.603-1.353 3.123-.373 6.268-.761 9.399-.7 1.013.023 2.004 1.399 3.002 2.152-.908.533-1.755 1.316-2.73 1.529-1.565.35-3.214.32-4.832.449v-.122zM71.816 201.24c.295.936.877 1.803.756 2.556-.643 3.887-1.43 7.751-2.246 11.608-.113.547-.635 1.004-.968 1.498-.552-.38-1.33-.631-1.618-1.149-1.353-2.464.749-12.284 2.889-13.904.204-.152.461-.236 1.194-.601l-.007-.008zm110.993 85.215c-.34-.289-1.157-.707-1.119-1.027.083-.814.348-2.046.907-2.297 2.873-1.316 5.807-2.556 8.839-3.408.772-.22 1.974 1.088 2.972 1.689-.582.662-1.051 1.666-1.777 1.932-3.138 1.126-6.344 2.038-9.822 3.119v-.008zM35.242 138.609c.363-.593.726-1.186 1.096-1.787.62.388 1.64.669 1.785 1.194.952 3.491 1.814 7.013 2.457 10.573.151.829-.65 1.825-1.013 2.746-.696-.708-1.785-1.309-2.004-2.145-.9-3.408-1.535-6.884-2.321-10.581zm52.105 44.855c.257.198.983.487 1.134.951.144.441-.174 1.217-.537 1.613a285.763 285.763 0 01-7.281 7.56c-.363.365-1.051.525-1.588.533-.227 0-.598-.616-.673-1.004-.582-3.126 5.414-9.828 8.952-9.66l-.007.007zM34.818 170.29c.734-2.601 1.354-5.142 2.2-7.606.19-.556 1.165-.837 1.777-1.24.288.608.847 1.224.825 1.818a160.93 160.93 0 01-.658 9.743c-.06.579-.658 1.316-1.195 1.552-.363.152-1.293-.312-1.535-.745-.59-1.065-.93-2.275-1.406-3.522h-.008zm34.949 62.327c.635.958 1.217 1.521 1.421 2.19a348.174 348.174 0 013.395 11.988c.167.624-.28 1.407-.438 2.122-.613-.304-1.558-.456-1.785-.943-2.087-4.45-3.69-9.036-3.357-14.072.015-.228.25-.441.771-1.285h-.007zm35.727 48.544c-1.391-.601-2.707-.997-3.834-1.696-2.29-1.415-4.529-2.921-6.669-4.557-.476-.357-.453-1.376-.665-2.091.718 0 1.558-.259 2.132.03 2.964 1.468 5.928 2.974 8.749 4.701.831.509 1.21 1.78 1.792 2.692-.484.29-.968.586-1.512.913l.007.008zm-72.71-163.416c.348.631.688 1.27 1.044 1.902 1.588 2.837 3.236 5.636 4.733 8.519.303.578.053 1.453.053 2.19-.93-.319-2.283-.35-2.707-1.004-1.368-2.107-2.39-4.434-3.554-6.671-.416-.798-1.05-1.559-1.21-2.403-.113-.647.37-1.4.598-2.107.348-.137.695-.282 1.043-.418v-.008zm88.415 92.501c.03 3.507-2.692 7.303-5.603 8.405-.514.198-1.149.077-1.724.099-.023-.76-.348-1.696-.023-2.251 1.482-2.541 3.123-4.99 4.787-7.424.242-.35 1.164-.715 1.27-.601.628.669 1.096 1.476 1.301 1.772h-.008zm-68.891 22.226c2.926 1.864 5.837 3.636 8.635 5.568.378.259.506 1.468.227 1.909-.235.381-1.415.609-1.83.35a131.627 131.627 0 01-7.849-5.256c-.355-.258-.378-1.141-.333-1.719.023-.258.605-.471 1.142-.852h.008zm31.047 9.706c-.666-.434-1.513-.989-2.367-1.544.726-.647 1.353-1.491 2.2-1.902 1.202-.578 2.548-1.11 3.841-1.148.885-.023 1.792.829 2.692 1.293-.552.776-.945 1.901-1.694 2.244-1.27.578-2.76.654-4.672 1.049v.008zm20.234-57.831c-.809 0-1.702.213-2.412-.054-.787-.296-1.422-1.027-2.118-1.567.757-.753 1.467-2.091 2.269-2.152 1.656-.122 3.41.281 5.021.798.627.206.975 1.294 1.459 1.986-.681.304-1.339.722-2.057.882-.688.152-1.437.031-2.155.031v.076h-.007zm13.875 6.282c4.597 1.438 6.041 6.048 3.281 9.044-1.066-2.943-2.064-5.689-3.281-9.044zm149.412 51.268c-4.96 4.548-9.928 9.044-14.82 13.615a329.135 329.135 0 00-9.906 9.615c-.93.943-1.391 2.342-2.261 3.362-.589.684-1.64 1.62-2.268 1.475-.87-.205-1.868-1.186-2.193-2.061-.514-1.415-.59-3.012-.741-4.541-.62-6.481-.764-13.045-1.913-19.427-1.172-6.481-2.82-12.976-5.164-19.115-2.601-6.815-5.921-13.402-9.49-19.769-2.911-5.195-8.174-7.994-13.61-9.736-7.539-2.419-15.312-4.085-22.919-6.283-1.043-.297-1.739-1.795-2.593-2.738.809-.639 1.52-1.582 2.442-1.879a678.585 678.585 0 0118.798-5.864c9.61-2.838 19.266-5.546 28.884-8.345a925.035 925.035 0 0015.531-4.655c7.939-2.457 15.841-5.035 23.788-7.447 9.754-2.951 19.516-5.879 29.323-8.64 5.557-1.567 11.206-2.838 16.839-4.138 8.968-2.077 17.943-4.1 26.926-6.078 13.83-3.042 27.659-6.07 41.519-9.006 1.641-.35 3.418-.159 5.112 0 .665.061 1.693.616 1.814 1.118.144.601-.34 1.59-.862 2.069-1.663 1.529-3.44 2.936-5.232 4.313-17.074 13.076-31.259 29.087-45.64 44.939-10.654 11.736-20.076 24.371-27.425 38.389-5.875 11.212-10.798 22.934-16.144 34.427-1.081 2.327-2.268 2.731-4.453 1.415-5.014-3.02-10.057-5.987-15.002-9.113-2.82-1.78-5.459-3.849-8.333-5.887l-.007-.015zm24.204 11.006c.597-1.232 1.172-2.35 1.686-3.499 2.767-6.1 5.323-12.307 8.34-18.286 3.448-6.83 7.198-13.516 11.017-20.149 5.973-10.39 13.247-19.838 21.255-28.714 3.327-3.689 6.782-7.272 10.147-10.923 4.469-4.845 8.877-9.744 13.376-14.559 2.397-2.563 4.93-4.997 7.403-7.492-.174-.221-.356-.434-.53-.654-2.563 1.453-5.134 2.898-7.69 4.358-15.394 8.778-30.948 17.275-46.124 26.417-17.33 10.436-34.358 21.374-51.424 32.244-3.6 2.289-6.798 5.226-10.496 8.108 2.844 2.396 5.46 4.351 7.774 6.61 3.546 3.469 6.805 7.242 10.336 10.733 7.055 6.975 15.584 11.668 24.945 15.798l-.015.008zm-105.292-66.236c12.968 3.392 26.298 5.666 35.652 16.909.839-.449 1.777-.814 2.555-1.385 9.845-7.165 20.688-12.558 31.637-17.692 7.818-3.667 15.909-6.732 23.803-10.254 11.887-5.301 23.705-10.763 35.561-16.148 11.259-5.119 22.525-10.223 33.784-15.342 1.452-.662 2.874-1.377 4.31-2.077l-.257-.654c-12.673 2.852-25.421 5.431-38.003 8.641-13.989 3.575-27.856 7.667-41.739 11.645-10.072 2.883-20.083 5.956-30.124 8.938-12.983 3.856-25.973 7.66-38.941 11.569-6.11 1.841-12.159 3.887-18.23 5.842l-.008.008z"
    })
  });
}
function SpiltCoffee(props) {
  return /* @__PURE__ */ jsx(Illustration, {
    ...props,
    viewBox: "0 0 400 400",
    width: "100%",
    children: /* @__PURE__ */ jsx("path", {
      fill: "currentColor",
      d: "M107.181 247.779c-1.033-4.109-2.286-7.934-2.918-11.862-1.456-9.043-3.352-18.04-3.849-27.219-.18-3.311-.09-6.655.147-9.96.322-4.476.751-8.958 1.405-13.395 1.231-8.301 3.488-16.348 6.191-24.288 2.145-6.287 5.368-12.002 8.793-17.627 1.022-1.675 2.1-3.339 3.308-4.884 1.614-2.054 3.719-3.497 6.405-3.542 1.569-.029 3.161.339 4.713.656 7.009 1.443 13.562 4.25 20.193 6.819 4.154 1.613 8.533 2.416 12.907 2.897 5.689.629 11.293 1.608 16.875 2.824 6.535 1.426 13.065 2.903 19.64 4.12 10.26 1.896 20.56 3.565 30.837 5.382 3.324.588 6.603 1.409 9.928 1.986 10.644 1.845 21.305 3.61 31.949 5.438 4.295.741 8.544 1.664 12.704 2.999 1.919.617 3.318 1.738 4.272 3.531 1.704 3.192 2.636 6.644 3.257 10.153.88 4.968 1.726 9.959 2.15 14.979.575 6.802 1.377 13.621.937 20.463-.486 7.492-1.016 14.984-3.42 22.194-.683 2.037-.999 4.193-1.62 6.253-.542 1.817-1.276 3.576-1.919 5.359-.158.447-.311.894-.564 1.618.959.131 1.715.312 2.471.329 5.706.153 11.418.203 17.124.43 4.046.158 8.081.554 12.122.82.858.057 1.722.034 2.579.029 12.287-.085 24.573-.17 36.86-.266 8.781-.068 17.569-.153 26.35-.249 1.225-.012 2.466-.046 3.68-.21 3.042-.401 5.948.43 9.312.781-1.236.826-2.286.979-3.324 1.041-3.86.227-7.726.425-11.592.589-10.865.475-21.734.096-32.598.396-6.135.17-12.276.362-18.405.691-4.503.237-8.956-.216-13.432-.476-5.762-.339-11.524-.668-17.286-.962a365.177 365.177 0 00-9.008-.328c-.858-.023-1.716.164-2.573.147-4.109-.102-8.218-.266-12.326-.368-3.302-.079-6.615-.22-9.916-.119-7.117.221-14.228.612-21.345.883-11.536.436-23.071.883-34.607 1.223-4.171.124-8.353-.136-12.524-.074-4.91.074-9.82.351-14.73.458-7.184.159-14.374.204-21.553.379-3.99.097-7.975.368-11.959.544-5.096.22-10.181.379-15.283-.017-3.911-.306-7.845-.3-11.773-.408-.542-.017-1.14.012-1.614.232-2.794 1.279-5.644 1.358-8.63.832-1.664-.288-3.408-.136-5.113-.153-1.044-.011-2.088.057-3.132.046-1.592-.017-3.149.022-4.741.379-1.467.328-3.053.209-4.582.124-2.168-.119-4.273-.028-6.378.606-1.044.317-2.173.396-3.268.453-2.692.147-5.39.277-8.087.299-1.151.012-2.32-.175-3.443-.435-1.117-.255-2.139-.328-3.222.153a4.998 4.998 0 01-2.122.424 30.994 30.994 0 01-4.024-.419c-2.952-.492-5.892-1.081-8.844-1.567-.711-.119-1.467 0-2.201.028-2.76.124-5.53.13-8.274.43-2.793.306-5.598.73-8.319 1.409-2.364.589-4.667.968-7.082.509-.633-.118-1.327.046-1.987.131-1.755.232-3.415.124-4.882-1.223.937-2.218 2.32-3.984 4.47-4.968.784-.362 1.778-.329 2.68-.351.667-.017 1.338.181 2.01.249 1.004.102 1.851-.085 2.709-.787.818-.668 1.936-.973 2.935-1.403.558-.238 1.173-.334 1.715-.606 2.111-1.052 4.318-1.431 6.615-.877 1.608.385 3.172.94 4.774 1.353 2.19.566 4.38 1.194 6.61 1.545 1.105.175 2.313-.142 3.453-.334 1.575-.266 3.127-.64 4.696-.934 3.081-.572 6.106-.028 9.137.492 1.75.3 3.516.555 5.282.702 1.169.102 2.303-.096 3.217-1.036 2.771-2.846 6.254-3.135 9.91-2.654 1.214.159 2.416.442 3.624.651 1.4.243 2.686-.079 3.849-.888 1.259-.877 2.5-1.766 3.663-2.586l.011.017zm97.337-92.071c.096 1.018.136 1.737.237 2.45.717 5.24 1.513 10.475 2.139 15.726.328 2.745.35 5.529.531 8.29.389 5.897.954 11.788 1.151 17.69.215 6.401.13 12.812.102 19.218a52.218 52.218 0 01-1.36 11.714c-.627 2.694-1.033 5.438-1.535 8.16-.192 1.024-.362 2.06-.599 3.073-.773 3.327-2.359 6.327-3.775 9.4-.446.973-.881 1.952-1.473 3.259 1.061 0 1.772.023 2.483-.006.609-.022 1.219-.152 1.828-.164 8.353-.119 16.711-.073 25.053-.384 5.943-.221 11.863-1.047 17.811-1.376 7.665-.424 15.34-.582 23.01-.922 4.413-.198 8.821-.6 13.234-.764 2.36-.091 3.55-1.369 4.239-3.407.214-.639.451-1.279.638-1.924.587-2.071 1.247-4.125 1.715-6.225.757-3.355 1.665-6.717 1.998-10.123.678-6.859 1.033-13.746 1.473-20.622.486-7.594-.101-15.115-1.49-22.601-.869-4.697-2.884-8.868-5.164-12.959-.699-1.251-1.659-2.349-3.07-2.807-2.325-.758-4.583-1.749-7.105-1.8-1.468-.028-2.946-.209-4.391-.452a1895.858 1895.858 0 01-17.772-3.107 3449.508 3449.508 0 01-20.098-3.684c-7.178-1.336-14.357-2.694-21.53-4.046-2.653-.498-5.294-1.025-8.285-1.602l.005-.005zm-82.629 95.251c.953-.798 1.71-1.517 2.551-2.1.801-.554 1.236-1.267 1.597-2.161.502-1.234 1.196-2.394 1.902-3.532.383-.616.965-1.109 1.433-1.68.491-.6.785-1.257.35-2.026-.705-1.256-.711-2.581-.389-3.939.383-1.613 1.049-3.225 1.055-4.838.017-2.694.903-4.991 2.506-6.983 2.432-3.028 4.103-6.395 5.226-10.079.09-.294.243-.571.322-.866.953-3.553 1.986-7.09 2.799-10.678.434-1.907.378-3.922.717-5.851.863-4.918 1.405-9.858 1.382-14.855-.011-2.218-.146-4.476.226-6.638 1.016-5.834.192-11.544-.869-17.237-1.101-5.897-4.188-10.99-6.897-16.219-.163-.317-.412-.667-.716-.815-1.964-.973-3.703-2.331-5.921-2.903-2.556-.662-4.532-.022-6.005 1.992-1.591 2.179-3.047 4.471-4.43 6.785-3.042 5.088-5.294 10.543-7.196 16.151-2.658 7.815-4.927 15.738-6.259 23.892-.716 4.369-1.213 8.783-1.546 13.197-.44 5.772-.355 11.567.158 17.344.564 6.327 1.958 12.518 3.172 18.731a37.936 37.936 0 003.335 9.751c.52 1.041 1.123 1.562 2.309 1.743 3.363.526 6.586 1.488 9.188 3.831v-.017zm5.073 4.601c2.145.498 3.793.056 4.6-2.151a.857.857 0 01.09-.158c3.347-5.201 5.723-10.877 8.155-16.53 1.191-2.762 2.382-5.54 3.279-8.404 1.857-5.941 2.952-12.064 3.985-18.193 1.112-6.553 2.319-13.101 2.365-19.772.045-5.971.09-11.952-.164-17.911-.198-4.601-.734-9.201-1.338-13.774-.722-5.478-1.681-10.927-2.551-16.484-.914-.368-1.93-.815-2.968-1.177-.977-.346-1.851-1.076-2.799-1.002 1.343 4.295 2.748 8.488 3.961 12.738 1.372 4.793 2.54 9.649 2.585 14.68.028 3.135-.073 6.27-.141 9.41-.237 10.917-1.648 21.714-3.307 32.488-2.122 13.78-6.874 26.648-13.082 39.03-1.152 2.298-2.41 4.505-2.664 7.221l-.006-.011zm71.201-1.047c.672-1.494 1.265-2.909 1.931-4.29 1.941-4.012 3.346-8.183 4.029-12.602.316-2.066.819-4.097 1.185-6.152.412-2.297.881-4.589 1.118-6.903.226-2.196.26-4.426.254-6.638-.028-8.059.186-16.111-.474-24.17-.7-8.454-.988-16.948-1.575-25.414-.293-4.222-.852-8.42-1.298-12.744-1.354-.13-2.647-.764-4.108-.407.146.939.276 1.788.423 2.637 1.49 8.748 2.359 17.565 2.731 26.421.378 8.975.486 17.967.881 26.942.321 7.295-.153 14.493-1.592 21.657-1.411 7-2.647 14.029-5.683 20.57-.141.3-.13.668-.203 1.098h2.387l-.006-.005zm-184.668 4.668c2.393.521 4.786 1.025 7.173 1.568.802.181 1.248.798 1.383 1.567.152.872-.44 1.404-1.112 1.732-.53.26-1.174.487-1.744.441-2.438-.192-4.87-.469-7.297-.764-.536-.067-1.072-.283-1.558-.532-1.382-.713-1.518-1.901-.327-2.92.993-.848 2.184-1.063 3.482-1.086v-.006zM1 264.263c1.117-1.341 2.432-1.867 3.928-1.947.864-.045 1.665.623 1.778 1.313.152.94-.536 2.066-1.468 2.269-1.659.368-2.963-.283-4.238-1.635z"
    })
  });
}
const Illustrations = {
  Cogs,
  Done,
  Padlock,
  PaperPlane,
  SpiltCoffee
};
const reset$7 = {
  boxSizing: "border-box",
  position: "relative",
  margin: 0,
  padding: 0
};
const inline = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap"
};
const Inline = forwardRef(function Inline2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children,
    collapseAt
  } = props;
  let ElementType = asChild ? Slot$2 : "div";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$7, inline, styleProps, {
      [`@media(max-width: ${collapseAt})`]: {
        flexDirection: "column"
      }
    })),
    ref,
    children
  });
});
const reset$6 = {
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility"
};
const base$7 = te({
  display: "inline-flex",
  alignItems: "center",
  gap: "$size150",
  borderRadius: "$full",
  fontFamily: "$primary",
  width: "fit-content"
});
const variants$6 = te({
  backgroundColor: "$$labelBackgroundColor",
  borderColor: "$$labelBorderColor",
  color: "$$labelTextColor",
  borderStyle: "solid",
  borderWidth: "1.5px",
  fontWeight: "$semi",
  paddingTop: "$$labelPaddingY",
  paddingBottom: "$$labelPaddingY",
  paddingLeft: "$$labelPaddingX",
  paddingRight: "$$labelPaddingX",
  lineHeight: "$$labelLineHeight",
  fontSize: "$$labelFontSize",
  variants: {
    tone: {
      critical: {},
      info: {},
      neutral: {},
      notice: {},
      positive: {},
      blue: {},
      canary: {},
      lilac: {}
    },
    emphasis: {
      heavy: {},
      light: {},
      outlined: {},
      ghost: {}
    },
    size: {
      large: {
        $$labelPaddingY: "9.5px",
        $$labelPaddingX: "$sizes-size250",
        $$labelFontSize: "$fontSizes-medium",
        $$labelLineHeight: "$lineHeights-medium"
      },
      medium: {
        $$labelPaddingY: "3.5px",
        $$labelPaddingX: "$sizes-size225",
        $$labelFontSize: "$fontSizes-small",
        $$labelLineHeight: "$lineHeights-small"
      },
      small: {
        $$labelPaddingY: "2.5px",
        $$labelPaddingX: "$sizes-size100",
        $$labelFontSize: "$fontSizes-xsmall",
        $$labelLineHeight: "$lineHeights-xsmall"
      },
      xsmall: {
        $$labelPaddingY: "1.5px",
        $$labelPaddingX: "$sizes-size75",
        $$labelFontSize: "$fontSizes-xxsmall",
        $$labelLineHeight: "$lineHeights-xxsmall"
      }
    }
  },
  compoundVariants: [
    {
      tone: "neutral",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-neutralDark1",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-neutralDark1"
      }
    },
    {
      tone: "neutral",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-bodyLight1",
        $$labelTextColor: "$colors-bodyDark2",
        $$labelBorderColor: "$colors-bodyLight1"
      }
    },
    {
      tone: "neutral",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-bodyDark1",
        $$labelBorderColor: "$colors-bodyDark1"
      }
    },
    {
      tone: "neutral",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-bodyDark2",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "info",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-info",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-info"
      }
    },
    {
      tone: "info",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-infoBackground",
        $$labelTextColor: "$colors-lavenderDark1",
        $$labelBorderColor: "$colors-infoBackground"
      }
    },
    {
      tone: "info",
      emphasis: "outlined",
      css: {
        $$labelBorderColor: "$colors-lavenderDark1",
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-lavenderDark1"
      }
    },
    {
      tone: "info",
      emphasis: "ghost",
      css: {
        $$labelTextColor: "$colors-lavenderDark1",
        $$labelBackgroundColor: "$colors-transparent",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "positive",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-positive",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-positive"
      }
    },
    {
      tone: "positive",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-positiveBackground",
        $$labelTextColor: "$colors-greenDark1",
        $$labelBorderColor: "$colors-positiveBackground"
      }
    },
    {
      tone: "positive",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-green",
        $$labelBorderColor: "$colors-green"
      }
    },
    {
      tone: "positive",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-green",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "notice",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-notice",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-notice"
      }
    },
    {
      tone: "notice",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-noticeBackground",
        $$labelTextColor: "$colors-orangeDark1",
        $$labelBorderColor: "$colors-noticeBackground"
      }
    },
    {
      tone: "notice",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-orange",
        $$labelBorderColor: "$colors-orange"
      }
    },
    {
      tone: "notice",
      emphasis: "ghost",
      css: {
        $$labelTextColor: "$colors-notice",
        $$labelBackgroundColor: "$colors-transparent",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "critical",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-critical",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-critical"
      }
    },
    {
      tone: "critical",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-criticalBackground",
        $$labelTextColor: "$colors-redDark1",
        $$labelBorderColor: "$colors-criticalBackground"
      }
    },
    {
      tone: "critical",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-critical",
        $$labelBorderColor: "$colors-critical"
      }
    },
    {
      tone: "critical",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-critical",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "blue",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-blue",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-blue"
      }
    },
    {
      tone: "blue",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-infoBackground",
        $$labelTextColor: "$colors-blueDark1",
        $$labelBorderColor: "$colors-infoBackground"
      }
    },
    {
      tone: "blue",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-blueDark1",
        $$labelBorderColor: "$colors-blueDark1"
      }
    },
    {
      tone: "blue",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-blueDark1",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "canary",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-canary",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-canary"
      }
    },
    {
      tone: "canary",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-canaryLight1",
        $$labelTextColor: "$colors-canaryDark1",
        $$labelBorderColor: "$colors-canaryLight1"
      }
    },
    {
      tone: "canary",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-canary",
        $$labelBorderColor: "$colors-canary"
      }
    },
    {
      tone: "canary",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-canary",
        $$labelBorderColor: "$colors-transparent"
      }
    },
    {
      tone: "lilac",
      emphasis: "heavy",
      css: {
        $$labelBackgroundColor: "$colors-lilac",
        $$labelTextColor: "$colors-white",
        $$labelBorderColor: "$colors-lilac"
      }
    },
    {
      tone: "lilac",
      emphasis: "light",
      css: {
        $$labelBackgroundColor: "$colors-lilacLight1",
        $$labelTextColor: "$colors-lilacDark1",
        $$labelBorderColor: "$colors-lilacLight1"
      }
    },
    {
      tone: "lilac",
      emphasis: "outlined",
      css: {
        $$labelBackgroundColor: "$colors-white",
        $$labelTextColor: "$colors-lilac",
        $$labelBorderColor: "$colors-lilac"
      }
    },
    {
      tone: "lilac",
      emphasis: "ghost",
      css: {
        $$labelBackgroundColor: "$colors-transparent",
        $$labelTextColor: "$colors-lilac",
        $$labelBorderColor: "$colors-transparent"
      }
    }
  ],
  defaultVariants: {
    tone: "neutral",
    emphasis: "light",
    size: "medium"
  }
});
const Label = forwardRef(function Label2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    children,
    emphasis,
    tone,
    size
  } = props;
  return /* @__PURE__ */ jsx("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$6, base$7), variants$6({
      emphasis,
      size,
      tone
    }), css(styleProps)),
    ref,
    children
  });
});
const reset$5 = css({
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility",
  boxSizing: "border-box",
  position: "relative",
  outline: "none"
});
const base$6 = css({
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  fontWeight: "inherit"
});
const variants$5 = css({
  color: "$$linkColor",
  textDecoration: "$$linkTextDecoration",
  textDecorationStyle: "$$linkTextDecorationStyle",
  variants: {
    kind: {
      primary: {
        $$linkColor: "$colors-accent"
      },
      secondary: {
        $$linkColor: "inherit"
      }
    },
    emphasis: {
      quiet: {
        $$linkTextDecoration: "none"
      },
      underlined: {
        $$linkTextDecoration: "underline"
      }
    },
    isHovered: {},
    isFocused: {
      true: {
        $$linkTextDecorationStyle: "double"
      },
      false: {
        $$linkTextDecorationStyle: "initial"
      }
    },
    isDisabled: {
      true: {
        color: "$bodyDark1",
        cursor: "auto"
      }
    }
  },
  compoundVariants: [
    {
      emphasis: "quiet",
      isFocused: true,
      isDisabled: false,
      css: {
        $$linkTextDecoration: "underline",
        $$linkTextDecorationStyle: "double"
      }
    }
  ],
  defaultVariants: {
    kind: "primary",
    emphasis: "underlined"
  }
});
const Link = forwardRef(function Text(props, ref) {
  let {
    children,
    emphasis,
    isDisabled,
    kind
  } = props;
  let {
    linkProps,
    isPressed
  } = $298d61e98472621b$export$dcf14c9974fe2767(props, ref);
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    hoverProps
  } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled
  });
  let {
    focusProps,
    isFocusVisible
  } = $f7dceffc5ad7768b$export$4e328f61c538687f(props);
  linkProps = $3ef42575df84b30b$export$9d1611c77c2fe928(linkProps, hoverProps, focusProps);
  return /* @__PURE__ */ jsx(Slot$2, {
    ...linkProps,
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(reset$5, base$6, variants$5({
      emphasis,
      kind,
      isDisabled,
      isFocused: isFocusVisible,
      isPressed
    }), css(styleProps)),
    ref,
    children
  });
});
const base$5 = css({
  display: "block",
  maxWidth: "100%",
  width: "100%"
});
const Logo = forwardRef(function Logo2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    onBackground = false
  } = props;
  let id = $bdb11010cef70236$export$f680877a34711e37();
  let fill = onBackground ? "#fff" : "#000";
  return /* @__PURE__ */ jsxs("svg", {
    fill: "transparent",
    role: "img",
    "aria-labelledby": id,
    viewBox: "0 0 325 44",
    xmlns: "http://www.w3.org/2000/svg",
    className: css(base$5, styleProps)(),
    ref,
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    children: [/* @__PURE__ */ jsx("title", {
      id,
      children: "Good Human"
    }), /* @__PURE__ */ jsx("g", {
      clipPath: "url(#a)",
      children: /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.726 21.045v21.874h-6.113v-4.971C29.855 41.666 26.137 44 19.783 44 7.556 44 0 35.13 0 22.238 0 8.87 8.032 0 20.681 0c10.125 0 17.042 5.698 17.984 14.603h-6.709c-.666-5.187-5.395-8.456-11.569-8.456-8.455 0-13.73 6.113-13.73 15.823S11.932 37.8 20.491 37.8c6.917 0 11.742-3.899 12.226-10.608h-13.47v-6.173l19.479.026Zm33.746 6.648c0 9.598-5.81 15.883-14.802 15.883s-14.76-6.285-14.76-15.883c0-9.597 5.88-15.943 14.75-15.943 8.872 0 14.812 6.416 14.812 15.944Zm-23.198 0c0 6.174 3.182 10.134 8.517 10.134 5.334 0 8.326-3.96 8.326-10.133 0-6.174-3.173-10.186-8.508-10.186-5.335 0-8.335 4.073-8.335 10.186Zm41.19 15.883c8.992 0 14.802-6.285 14.802-15.883 0-9.527-5.93-15.943-14.802-15.943-8.87 0-14.75 6.346-14.75 15.944 0 9.597 5.758 15.882 14.75 15.882Zm.113-5.75c-5.335 0-8.508-3.96-8.508-10.133 0-6.112 3-10.185 8.335-10.185 5.335 0 8.508 4.012 8.508 10.186 0 6.173-3 10.133-8.335 10.133ZM138.77.304V42.92h-6.173v-5.092c-1.557 2.593-4.496 5.75-10.488 5.75-8.032 0-13.246-6.286-13.246-16.005 0-9.51 5.81-15.822 13.791-15.822 5.386 0 8.205 2.395 9.77 5.032V.302h6.346Zm-6.113 27.27c0-6.113-3.458-10.376-8.75-10.376-5.291 0-8.689 4.194-8.689 10.306 0 6.113 3.355 10.445 8.689 10.445 5.335 0 8.75-4.202 8.75-10.376Zm39.945 15.346h6.631l.026-41.96h-6.657v17.742H151.54V.96h-6.658v41.96h6.658V24.874h21.062v18.044Zm39.227-30.572V42.92h-6.112v-5.187a10.745 10.745 0 0 1-9.831 5.516c-6.709 0-10.851-4.496-10.851-11.75V12.312h6.294v18.59c0 4.435 2.162 6.916 6.113 6.916 5.101 0 8.093-4.02 8.093-10.67v-14.81l6.294.009Zm49.75 30.572V21.944c0-6.355-3.899-10.194-10.514-10.194-4.591 0-7.781 1.859-9.51 6.234-1.202-4.254-4.194-6.234-8.811-6.234-3.476 0-6.657 1.141-8.516 5.698v-5.101h-6.295v30.572h6.355V25.48c0-5.274 2.343-8.274 6.597-8.274 3.658 0 5.698 2.213 5.698 6.234v19.48h6.355V25.54c0-5.395 2.326-8.334 6.649-8.334 3.718 0 5.698 2.153 5.698 6.234v19.48h6.294Zm30.261-20.923V42.92h-6.052v-4.617c-2.456 3.96-6.294 5.274-10.004 5.274-6.294 0-9.951-3.77-9.951-9.346 0-5.335 3.458-8.274 9.511-9.113l6.839-.96c2.593-.302 3.83-1.202 3.83-3.355 0-2.818-2.335-4.322-5.992-4.322-4.141 0-6.597 1.919-6.917 5.274h-6c.605-6.234 5.187-10.013 13.012-10.013 7.522.01 11.724 3.485 11.724 10.255Zm-5.974 7.98v-2.222a28.283 28.283 0 0 1-4.548.96l-3.458.475c-3.77.605-5.75 2.101-5.75 4.86 0 2.757 1.859 4.193 5.188 4.193 4.591 0 8.568-3.113 8.568-8.266Zm38.389 12.943V23.137c0-7.488-3.805-11.387-10.67-11.421-4.461 0-7.548 1.59-9.649 5.187v-4.556h-6.355v30.572h6.355V26.561c0-5.637 2.94-9.174 7.669-9.174 4.021 0 6.355 2.456 6.355 6.407V42.92h6.295Z",
        fill
      })
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "a",
        children: /* @__PURE__ */ jsx("path", {
          fill: "transparent",
          d: "M0 0h324.255v44H0z"
        })
      })
    })]
  });
});
const reset$4 = {
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility",
  boxSizing: "borderBox",
  position: "relative"
};
const base$4 = {
  display: "flex",
  gap: "$xsmall",
  alignItems: "flex-start"
};
const variants$4 = te({
  color: "$$tone",
  variants: {
    tone: {
      neutral: {
        $$tone: "$colors-muted"
      },
      critical: {
        $$tone: "$colors-critical"
      },
      positive: {
        $$tone: "$colors-positive"
      },
      notice: {
        $$tone: "$colors-notice"
      },
      info: {
        $$tone: "$colors-info"
      }
    },
    iconPosition: {
      start: {
        flexDirection: "row",
        justifyContent: "flex-start"
      },
      end: {
        flexDirection: "row-reverse",
        justifyContent: "flex-end"
      }
    }
  },
  defaultVariants: {
    iconPosition: "start",
    tone: "neutral"
  }
});
const iconVariants = te({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  height: "$$iconHeight",
  "> svg": {
    height: "1em",
    width: "1em"
  },
  variants: {
    size: {
      xsmall: {
        $$iconHeight: "$lineHeights-xxsmall"
      },
      small: {
        $$iconHeight: "$lineHeights-small"
      },
      medium: {
        $$iconHeight: "$lineHeights-medium"
      },
      large: {
        $$iconHeight: "$lineHeights-large"
      },
      xlarge: {
        $$iconHeight: "$lineHeights-xlarge"
      }
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
const Message = forwardRef(function Message2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    children,
    iconPosition = "start",
    tone,
    size = "medium"
  } = props;
  let Icon3 = {
    neutral: null,
    critical: /* @__PURE__ */ jsx(Icons.Critical, {}),
    info: /* @__PURE__ */ jsx(Icons.Info, {}),
    muted: null,
    notice: /* @__PURE__ */ jsx(Icons.Notice, {}),
    positive: /* @__PURE__ */ jsx(Icons.Positive, {})
  }[tone];
  return /* @__PURE__ */ jsxs("span", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$4, base$4, styleProps), css({
      fontSize: `$${size}`
    }), variants$4({
      iconPosition,
      tone
    })),
    ref,
    children: [Icon3 && /* @__PURE__ */ jsx("span", {
      className: iconVariants({
        size
      }),
      children: Icon3
    }), /* @__PURE__ */ jsx(Text2, {
      size,
      children
    })]
  });
});
function NumberFormatter(props) {
  let {
    value
  } = props;
  let formatter = $a916eb452884faea$export$b7a616150fdb9f44({
    style: "decimal",
    ...props
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatter.format(value)
  });
}
function PercentFormatter(props) {
  let {
    value,
    minimumFractionDigits,
    maximumFractionDigits
  } = props;
  value = value / 100;
  let options = value * 100 % 1 === 0 ? {
    minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : 0,
    maximumFractionDigits: maximumFractionDigits != null ? maximumFractionDigits : 0
  } : {
    minimumFractionDigits: minimumFractionDigits != null ? minimumFractionDigits : 2,
    maximumFractionDigits: maximumFractionDigits != null ? maximumFractionDigits : 2
  };
  let formatter = $a916eb452884faea$export$b7a616150fdb9f44({
    style: "percent",
    ...props,
    ...options
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatter.format(value)
  });
}
const $89eedd556c436f6a$var$DEFAULT_ORIENTATION = "horizontal";
const $89eedd556c436f6a$var$ORIENTATIONS = [
  "horizontal",
  "vertical"
];
const $89eedd556c436f6a$export$1ff3c3f08ae963c0 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  const { decorative, orientation: orientationProp = $89eedd556c436f6a$var$DEFAULT_ORIENTATION, ...domProps } = props;
  const orientation = $89eedd556c436f6a$var$isValidOrientation(orientationProp) ? orientationProp : $89eedd556c436f6a$var$DEFAULT_ORIENTATION;
  const ariaOrientation = orientation === "vertical" ? orientation : void 0;
  const semanticProps = decorative ? {
    role: "none"
  } : {
    "aria-orientation": ariaOrientation,
    role: "separator"
  };
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({
    "data-orientation": orientation
  }, semanticProps, domProps, {
    ref: forwardedRef
  }));
});
$89eedd556c436f6a$export$1ff3c3f08ae963c0.propTypes = {
  orientation(props, propName, componentName) {
    const propValue = props[propName];
    const strVal = String(propValue);
    if (propValue && !$89eedd556c436f6a$var$isValidOrientation(propValue))
      return new Error($89eedd556c436f6a$var$getInvalidOrientationError(strVal, componentName));
    return null;
  }
};
function $89eedd556c436f6a$var$getInvalidOrientationError(value, componentName) {
  return `Invalid prop \`orientation\` of value \`${value}\` supplied to \`${componentName}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${$89eedd556c436f6a$var$DEFAULT_ORIENTATION}\`.`;
}
function $89eedd556c436f6a$var$isValidOrientation(orientation) {
  return $89eedd556c436f6a$var$ORIENTATIONS.includes(orientation);
}
const $89eedd556c436f6a$export$be92b6f5f03c0fe9 = $89eedd556c436f6a$export$1ff3c3f08ae963c0;
const reset$3 = {
  boxSizing: "border-box",
  margin: 0,
  position: "relative"
};
const base$3 = {
  display: "block"
};
const variants$3 = css({
  variants: {
    orientation: {
      horizontal: {
        width: "100%",
        borderBottomColor: "$bodyLight2",
        borderBottomWidth: "$$thickness",
        borderBottomStyle: "solid"
      },
      vertical: {
        width: "fit-content",
        height: "100%",
        borderRightColor: "$bodyLight2",
        borderRightWidth: "$$thickness",
        borderRightStyle: "solid"
      }
    },
    thickness: {
      thin: {
        $$thickness: "$borderWidths-thin"
      },
      thick: {
        $$thickness: "$borderWidths-thick"
      },
      thicker: {
        $$thickness: "$borderWidths-thicker"
      },
      thickest: {
        $$thickness: "$borderWidths-thickest"
      }
    }
  },
  defaultVariants: {
    orientation: "horizontal",
    thickness: "thickest"
  }
});
const Separator = forwardRef(function Separator2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    orientation,
    thickness
  } = props;
  return /* @__PURE__ */ jsx($89eedd556c436f6a$export$be92b6f5f03c0fe9, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$3, base$3), variants$3({
      orientation,
      thickness
    }), css(styleProps)),
    orientation,
    ref
  });
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
var uid = function() {
  return Math.random().toString(36).substring(6);
};
var SVG = function(_a) {
  var animate = _a.animate, animateBegin = _a.animateBegin, backgroundColor = _a.backgroundColor, backgroundOpacity = _a.backgroundOpacity, baseUrl = _a.baseUrl, children = _a.children, foregroundColor = _a.foregroundColor, foregroundOpacity = _a.foregroundOpacity, gradientRatio = _a.gradientRatio, gradientDirection = _a.gradientDirection, uniqueKey = _a.uniqueKey, interval = _a.interval, rtl = _a.rtl, speed = _a.speed, style = _a.style, title = _a.title, beforeMask = _a.beforeMask, props = __rest(_a, ["animate", "animateBegin", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "gradientDirection", "uniqueKey", "interval", "rtl", "speed", "style", "title", "beforeMask"]);
  var fixedId = uniqueKey || uid();
  var idClip = fixedId + "-diff";
  var idGradient = fixedId + "-animated-diff";
  var idAria = fixedId + "-aria";
  var rtlStyle = rtl ? { transform: "scaleX(-1)" } : null;
  var keyTimes = "0; " + interval + "; 1";
  var dur = speed + "s";
  var gradientTransform = gradientDirection === "top-bottom" ? "rotate(90)" : void 0;
  return createElement(
    "svg",
    __assign({ "aria-labelledby": idAria, role: "img", style: __assign(__assign({}, style), rtlStyle) }, props),
    title ? createElement("title", { id: idAria }, title) : null,
    beforeMask && isValidElement(beforeMask) ? beforeMask : null,
    createElement("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(" + baseUrl + "#" + idClip + ")", style: { fill: "url(" + baseUrl + "#" + idGradient + ")" } }),
    createElement(
      "defs",
      null,
      createElement("clipPath", { id: idClip }, children),
      createElement(
        "linearGradient",
        { id: idGradient, gradientTransform },
        createElement("stop", { offset: "0%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && createElement("animate", { attributeName: "offset", values: -gradientRatio + "; " + -gradientRatio + "; 1", keyTimes, dur, repeatCount: "indefinite", begin: animateBegin })),
        createElement("stop", { offset: "50%", stopColor: foregroundColor, stopOpacity: foregroundOpacity }, animate && createElement("animate", { attributeName: "offset", values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 + gradientRatio / 2), keyTimes, dur, repeatCount: "indefinite", begin: animateBegin })),
        createElement("stop", { offset: "100%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && createElement("animate", { attributeName: "offset", values: "0; 0; " + (1 + gradientRatio), keyTimes, dur, repeatCount: "indefinite", begin: animateBegin }))
      )
    )
  );
};
SVG.defaultProps = {
  animate: true,
  backgroundColor: "#f5f6f7",
  backgroundOpacity: 1,
  baseUrl: "",
  foregroundColor: "#eee",
  foregroundOpacity: 1,
  gradientRatio: 2,
  gradientDirection: "left-right",
  id: null,
  interval: 0.25,
  rtl: false,
  speed: 1.2,
  style: {},
  title: "Loading...",
  beforeMask: null
};
var ContentLoader = function(props) {
  return props.children ? createElement(SVG, __assign({}, props)) : createElement(ReactContentLoaderFacebook, __assign({}, props));
};
var ReactContentLoaderFacebook = function(props) {
  return createElement(
    ContentLoader,
    __assign({ viewBox: "0 0 476 124" }, props),
    createElement("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    createElement("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    createElement("circle", { cx: "20", cy: "20", r: "20" })
  );
};
var ContentLoader$1 = ContentLoader;
function Root(props) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    children
  } = props;
  return /* @__PURE__ */ jsx(ContentLoader$1, {
    ...otherProps,
    className: css(styleProps)(),
    speed: 1,
    height: "100%",
    width: "100%",
    backgroundColor: colorValues.bodyLight1,
    foregroundColor: colorValues.bodyLight2,
    children
  });
}
function Heading(props) {
  let {
    size = "medium",
    width = "100%",
    x: x2 = "0",
    y: y2 = "0",
    ...otherProps
  } = props;
  let sizeProps = {
    xlarge: {
      height: "40"
    },
    large: {
      height: "36"
    },
    medium: {
      height: "32"
    },
    small: {
      height: "28"
    },
    xsmall: {
      height: "20"
    },
    xxsmall: {
      height: "18"
    }
  }[size];
  return /* @__PURE__ */ jsx("rect", {
    x: x2,
    y: y2,
    width,
    ...otherProps,
    ...sizeProps,
    ry: "4"
  });
}
function Text$1(props) {
  let {
    width = "100%",
    x: x2 = "0",
    y: y2 = "0",
    lines = 3,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsx(Fragment, {
    children: Array.from(Array(lines)).map((e2, i2) => {
      let stackedPosition = Number(y2) + i2 * 16;
      width = i2 === 0 || i2 + 1 < lines ? width : `calc(${width} - 25%)`;
      return /* @__PURE__ */ jsx("rect", {
        x: x2,
        y: stackedPosition,
        width,
        ...otherProps,
        height: "8",
        ry: "4"
      }, i2);
    })
  });
}
var skeleton = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Root,
  Heading,
  Text: Text$1
}, Symbol.toStringTag, { value: "Module" }));
const reset$2 = css({
  boxSizing: "border-box",
  position: "relative",
  margin: 0,
  padding: 0
});
const base$2 = css({
  display: "grid"
});
const variants$2 = css({
  gridTemplateColumns: "$$fraction",
  variants: {
    fraction: {
      "one-quarter": {
        $$fraction: "1fr 3fr"
      },
      "one-third": {
        $$fraction: "1fr 2fr"
      },
      half: {
        $$fraction: "1fr 1fr"
      },
      "two-thirds": {
        $$fraction: "2fr 1fr"
      },
      "three-quarters": {
        $$fraction: "3fr 1fr"
      },
      "auto-start": {
        $$fraction: "auto 1fr"
      },
      "auto-end": {
        $$fraction: "1fr auto"
      }
    }
  },
  defaultVariants: {
    fraction: "half"
  }
});
const Split = forwardRef(function Split2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children,
    fraction,
    collapseAt
  } = props;
  let ElementType = asChild ? Slot$2 : "div";
  let collapseAtStyles = collapseAt ? {
    [`@media(max-width: ${collapseAt})`]: {
      display: "flex",
      flexDirection: "column"
    }
  } : {};
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(reset$2, base$2, variants$2({
      fraction
    }), css(styleProps), css(collapseAtStyles)),
    ref,
    children
  });
});
const Div = re("div");
const Slot = re(Slot$2);
const Stack = forwardRef(function Stack2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children
  } = props;
  let ElementType = asChild ? Slot : Div;
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css({
      ...styleProps,
      display: "flex",
      flexDirection: "column"
    })(),
    ref,
    children
  });
});
const StatusLabel = forwardRef(function StatusLabel2(props, ref) {
  let {
    emphasis,
    size = "medium",
    tone,
    children,
    ...otherProps
  } = props;
  let onBackground = emphasis === "heavy";
  let gap = {
    large: "$space125",
    medium: "$space100",
    small: "$space75",
    xsmall: "$space50"
  }[size];
  return /* @__PURE__ */ jsx(Label, {
    ref,
    emphasis,
    size,
    tone,
    ...otherProps,
    children: /* @__PURE__ */ jsxs(Inline, {
      gap,
      alignItems: "center",
      children: [/* @__PURE__ */ jsx(StatusLight, {
        onBackground,
        size,
        tone
      }), children]
    })
  });
});
const base$1 = {
  borderRadius: "$full"
};
const variants$1 = css({
  backgroundColor: "$$statusLightBackgroundColor",
  height: "$$statusLightSize",
  width: "$$statusLightSize",
  variants: {
    tone: {
      blue: {},
      canary: {},
      critical: {},
      info: {},
      lilac: {},
      neutral: {},
      notice: {},
      positive: {}
    },
    onBackground: {
      true: {}
    },
    size: {
      large: {
        $$statusLightSize: "$sizes-size150"
      },
      medium: {
        $$statusLightSize: "$sizes-size125"
      },
      small: {
        $$statusLightSize: "$sizes-size100"
      },
      xsmall: {
        $$statusLightSize: "$sizes-size75"
      }
    }
  },
  compoundVariants: [
    {
      tone: "critical",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-critical"
      }
    },
    {
      tone: "critical",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-criticalBackground"
      }
    },
    {
      tone: "info",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-info"
      }
    },
    {
      tone: "info",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-infoBackground"
      }
    },
    {
      tone: "neutral",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-neutralDark1"
      }
    },
    {
      tone: "neutral",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-neutral"
      }
    },
    {
      tone: "positive",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-positive"
      }
    },
    {
      tone: "positive",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-positiveBackground"
      }
    },
    {
      tone: "notice",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-notice"
      }
    },
    {
      tone: "notice",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-noticeBackground"
      }
    },
    {
      tone: "blue",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-blue"
      }
    },
    {
      tone: "blue",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-blueLight1"
      }
    },
    {
      tone: "canary",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-canary"
      }
    },
    {
      tone: "canary",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-canaryLight1"
      }
    },
    {
      tone: "lilac",
      onBackground: false,
      css: {
        $$statusLightBackgroundColor: "$colors-lilac"
      }
    },
    {
      tone: "lilac",
      onBackground: true,
      css: {
        $$statusLightBackgroundColor: "$colors-lilacLight1"
      }
    }
  ],
  defaultVariants: {
    onBackground: false,
    size: "medium",
    tone: "neutral"
  }
});
const StatusLight = forwardRef(function StatusLight2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props);
  let {
    onBackground,
    size,
    tone
  } = props;
  return /* @__PURE__ */ jsx("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(base$1), variants$1({
      onBackground,
      size,
      tone
    }), css(styleProps)),
    ref
  });
});
const reset$1 = {
  margin: 0,
  heading: 0,
  overflowWrap: "break-word",
  textRendering: "optimizeLegibility"
};
const text = {
  fontFamily: "$primary"
};
const variants = css({
  fontSize: "$$textFontSize",
  lineHeight: "$$textLineHeight",
  variants: {
    size: {
      xxsmall: {
        $$textFontSize: "$fontSizes-xxsmall",
        $$textLineHeight: "$lineHeights-xxsmall"
      },
      xsmall: {
        $$textFontSize: "$fontSizes-xsmall",
        $$textLineHeight: "$lineHeights-xsmall"
      },
      small: {
        $$textFontSize: "$fontSizes-small",
        $$textLineHeight: "$lineHeights-small"
      },
      medium: {
        $$textFontSize: "$fontSizes-medium",
        $$textLineHeight: "$lineHeights-medium"
      },
      large: {
        $$textFontSize: "$fontSizes-large",
        $$textLineHeight: "$lineHeights-large"
      },
      xlarge: {
        $$textFontSize: "$fontSizes-xlarge",
        $$textLineHeight: "$lineHeights-xlarge"
      },
      inherit: {
        $$textFontSize: "inherit",
        $$textLineHeight: "inherit"
      }
    }
  },
  defaultVariants: {
    size: "inherit"
  }
});
const Text2 = forwardRef(function Text22(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, textStyleProps);
  let {
    asChild,
    children,
    color: _color,
    size
  } = props;
  let ElementType = asChild ? Slot$2 : "span";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: compose(css(reset$1, text), variants({
      size
    }), css(styleProps)),
    ref,
    children
  });
});
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */ forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.span, _extends({}, props, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164;
function VisuallyHidden(props) {
  let {
    children
  } = props;
  return /* @__PURE__ */ jsx($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
    children
  });
}
const reset = {
  boxSizing: "border-box",
  margin: 0,
  position: "relative"
};
const base = {
  backgroundColor: "$bodyLight3",
  borderRadius: "12px",
  padding: "$space300"
};
const Well = forwardRef(function Well2(props, ref) {
  let {
    styleProps,
    ...otherProps
  } = useStyleProps(props, boxStyleProps);
  let {
    asChild,
    children
  } = props;
  let ElementType = asChild ? Slot$2 : "div";
  return /* @__PURE__ */ jsx(ElementType, {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps),
    className: css(reset, base, styleProps)(),
    ref,
    children
  });
});
function useContextProps(context, props) {
  var _a;
  let contextProps = (_a = useContext(context)) != null ? _a : {};
  return $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
}
export { Avatar, Box, BreadcrumbItem, Breadcrumbs, Button, Card, CurrencyFormatter, DateFormatter, FieldLabel, FieldMessage, Grid, Heading$1 as Heading, $18f2051aff69b9bf$export$a54013f0d02a8f82 as I18nProvider, Icon, Icons, Illustration, Illustrations, Inline, Label, Link, Logo, Message, NumberFormatter, PercentFormatter, Separator, skeleton as Skeleton, Split, Stack, StatusLabel, StatusLight, Text2 as Text, VisuallyHidden, Well, baseStyleProps, boxStyleProps, compose, css, iconStyleProps, textStyleProps, theme, useContextProps, useStyleProps };
//# sourceMappingURL=index.es.js.map
